import fetch from '@/helpers/fetch'

// import Papa from 'papaparse'
// import { sleep } from './sleep'

// let loading = true
// let error = false
// const reference = [] as Array<any>
// fetch('/cnj-pattern.tsv?v0.0.1').then(async (res) => {
// 	const file = await res.blob()
// 	Papa.parse(file, {
// 		download: true,
// 		header: true,
// 		worker: true,
// 		skipEmptyLines: true,
// 		delimiter: '\t',
// 		error: function () {
// 			error = true
// 			loading = false
// 		},
// 		complete: function (results) {
// 			loading = false
// 			reference.length = 0
// 			reference.push(...results.data)
// 		},
// 	})
// })

export default {
	/**
	 * cnj deve estar no seguinte formato '#######-##.####.#.##.####'
	 */
	async getData(cnj) {
		if (!cnj) return
		if (typeof cnj !== 'string') return
		if (cnj.length !== 25) return
		if (!cnj.includes('.')) return

		const cnjsByCode = getCnjsByCode()

		const [trialNumber, year, j, tr, code] = cnj.split('.')

		if (!code || code.length !== 4) return

		const list = cnjsByCode[code]

		if (!list || !list.length) return

		const found = list.find((item) => {
			const cond = item.j === j && item.tr === tr && item.code === code

			return cond
		})

		return found
	},
}

function getCnjsByCode() {
	return {
		'505': [
			{
				j: '8',
				tr: '26',
				code: '505',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Ribeirão Pires ',
			},
		],
		'1000': [
			{
				j: '8',
				tr: '04',
				code: '1000',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Manaus',
			},
			{
				j: '8',
				tr: '20',
				code: '1000',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Açu',
			},
		],
		'1010': [
			{
				j: '8',
				tr: '20',
				code: '1010',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Caicó',
			},
		],
		'1020': [
			{
				j: '8',
				tr: '20',
				code: '1020',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Ceará Mirim',
			},
		],
		'1030': [
			{
				j: '8',
				tr: '20',
				code: '1030',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Currais Novos',
			},
		],
		'1040': [
			{
				j: '8',
				tr: '20',
				code: '1040',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'João Câmara',
			},
		],
		'1050': [
			{
				j: '8',
				tr: '20',
				code: '1050',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Macau',
			},
		],
		'1060': [
			{
				j: '8',
				tr: '20',
				code: '1060',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Mossoró',
			},
		],
		'1070': [
			{
				j: '8',
				tr: '20',
				code: '1070',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Nova Cruz',
			},
		],
		'1071': [
			{
				j: '8',
				tr: '15',
				code: '1071',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Jacaraú',
			},
		],
		'1080': [
			{
				j: '8',
				tr: '20',
				code: '1080',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Pau dos Ferros',
			},
		],
		'1090': [
			{
				j: '8',
				tr: '20',
				code: '1090',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Acari',
			},
		],
		'1100': [
			{
				j: '8',
				tr: '04',
				code: '1100',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Manaus',
			},
			{
				j: '8',
				tr: '20',
				code: '1100',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Alexandria',
			},
		],
		'1110': [
			{
				j: '8',
				tr: '20',
				code: '1110',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Angicos',
			},
		],
		'1111': [
			{
				j: '8',
				tr: '22',
				code: '1111',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Porto Velho ',
			},
		],
		'1120': [
			{
				j: '8',
				tr: '20',
				code: '1120',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Apodi',
			},
		],
		'1130': [
			{
				j: '8',
				tr: '20',
				code: '1130',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Areia Branca',
			},
		],
		'1140': [
			{
				j: '8',
				tr: '20',
				code: '1140',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Canguaretama',
			},
		],
		'1150': [
			{
				j: '8',
				tr: '20',
				code: '1150',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Caraúbas',
			},
		],
		'1160': [
			{
				j: '8',
				tr: '20',
				code: '1160',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Goianinha',
			},
		],
		'1161': [
			{
				j: '8',
				tr: '15',
				code: '1161',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Santana dos Garrotes',
			},
		],
		'1170': [
			{
				j: '8',
				tr: '20',
				code: '1170',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Jardim do Seridó',
			},
		],
		'1171': [
			{
				j: '8',
				tr: '15',
				code: '1171',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Paulista',
			},
		],
		'1180': [
			{
				j: '8',
				tr: '20',
				code: '1180',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Jucurutu',
			},
		],
		'1190': [
			{
				j: '8',
				tr: '20',
				code: '1190',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Lajes',
			},
		],
		'1200': [
			{
				j: '8',
				tr: '04',
				code: '1200',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Manaus',
			},
			{
				j: '8',
				tr: '20',
				code: '1200',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Luís Gomes',
			},
		],
		'1201': [
			{
				j: '8',
				tr: '15',
				code: '1201',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Araçagi',
			},
		],
		'1210': [
			{
				j: '8',
				tr: '20',
				code: '1210',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Macaíba',
			},
		],
		'1211': [
			{
				j: '8',
				tr: '15',
				code: '1211',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Lucena',
			},
		],
		'1220': [
			{
				j: '8',
				tr: '20',
				code: '1220',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Martins',
			},
		],
		'1230': [
			{
				j: '8',
				tr: '20',
				code: '1230',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Parelhas',
			},
		],
		'1240': [
			{
				j: '8',
				tr: '20',
				code: '1240',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Parnamirim',
			},
		],
		'1250': [
			{
				j: '8',
				tr: '20',
				code: '1250',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Patu',
			},
		],
		'1260': [
			{
				j: '8',
				tr: '20',
				code: '1260',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Santa Cruz',
			},
		],
		'1270': [
			{
				j: '8',
				tr: '20',
				code: '1270',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Santana do Matos',
			},
		],
		'1280': [
			{
				j: '8',
				tr: '20',
				code: '1280',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Santo Antônio',
			},
		],
		'1290': [
			{
				j: '8',
				tr: '20',
				code: '1290',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'São Gonçalo do Amarante',
			},
		],
		'1300': [
			{
				j: '8',
				tr: '04',
				code: '1300',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Manaus',
			},
			{
				j: '8',
				tr: '20',
				code: '1300',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'São José de Mipibu',
			},
		],
		'1310': [
			{
				j: '8',
				tr: '20',
				code: '1310',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'São Miguel',
			},
		],
		'1320': [
			{
				j: '8',
				tr: '20',
				code: '1320',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'São Paulo do Potengi',
			},
		],
		'1330': [
			{
				j: '8',
				tr: '20',
				code: '1330',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Tangará',
			},
		],
		'1340': [
			{
				j: '8',
				tr: '20',
				code: '1340',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Afonso Bezerra',
			},
		],
		'1350': [
			{
				j: '8',
				tr: '20',
				code: '1350',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Almino Afonso',
			},
		],
		'1360': [
			{
				j: '8',
				tr: '20',
				code: '1360',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Arês',
			},
		],
		'1370': [
			{
				j: '8',
				tr: '20',
				code: '1370',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Campo Grande ',
			},
		],
		'1380': [
			{
				j: '8',
				tr: '20',
				code: '1380',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Cruzela',
			},
		],
		'1390': [
			{
				j: '8',
				tr: '20',
				code: '1390',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Florânia',
			},
		],
		'1400': [
			{
				j: '8',
				tr: '20',
				code: '1400',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Governador Dix-Sept Rosado',
			},
		],
		'1410': [
			{
				j: '8',
				tr: '20',
				code: '1410',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Janduís',
			},
		],
		'1420': [
			{
				j: '8',
				tr: '20',
				code: '1420',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Jardim de Piranhas',
			},
		],
		'1430': [
			{
				j: '8',
				tr: '20',
				code: '1430',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Marcelino Vieira',
			},
		],
		'1440': [
			{
				j: '8',
				tr: '20',
				code: '1440',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Monte Alegre',
			},
		],
		'1450': [
			{
				j: '8',
				tr: '20',
				code: '1450',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Nísia Floresta',
			},
		],
		'1460': [
			{
				j: '8',
				tr: '20',
				code: '1460',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Pedro Avelino',
			},
		],
		'1470': [
			{
				j: '8',
				tr: '20',
				code: '1470',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Pedro Velho',
			},
		],
		'1480': [
			{
				j: '8',
				tr: '20',
				code: '1480',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Pendências',
			},
		],
		'1490': [
			{
				j: '8',
				tr: '20',
				code: '1490',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Poço Branco',
			},
		],
		'1500': [
			{
				j: '8',
				tr: '20',
				code: '1500',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Portalegre',
			},
		],
		'1510': [
			{
				j: '8',
				tr: '20',
				code: '1510',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'São Bento do Norte',
			},
		],
		'1520': [
			{
				j: '8',
				tr: '20',
				code: '1520',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'São João do Sabugi',
			},
		],
		'1530': [
			{
				j: '8',
				tr: '20',
				code: '1530',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'São José do Campestre',
			},
		],
		'1540': [
			{
				j: '8',
				tr: '20',
				code: '1540',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'São Rafael',
			},
		],
		'1550': [
			{
				j: '8',
				tr: '20',
				code: '1550',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'São Tomé',
			},
		],
		'1560': [
			{
				j: '8',
				tr: '20',
				code: '1560',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Serra Negra do Norte',
			},
		],
		'1570': [
			{
				j: '8',
				tr: '20',
				code: '1570',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Taipu',
			},
		],
		'1580': [
			{
				j: '8',
				tr: '20',
				code: '1580',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Touros',
			},
		],
		'1590': [
			{
				j: '8',
				tr: '20',
				code: '1590',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Umarizal',
			},
		],
		'1600': [
			{
				j: '8',
				tr: '20',
				code: '1600',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Upanema',
			},
		],
		'1610': [
			{
				j: '8',
				tr: '20',
				code: '1610',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Baraúna',
			},
		],
		'1620': [
			{
				j: '8',
				tr: '20',
				code: '1620',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Extremoz',
			},
		],
		'1630': [
			{
				j: '8',
				tr: '20',
				code: '1630',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Ipanguaçu',
			},
		],
		'2000': [
			{
				j: '8',
				tr: '04',
				code: '2000',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Alvarães',
			},
		],
		'2001': [
			{
				j: '8',
				tr: '15',
				code: '2001',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'João Pessoa',
			},
			{
				j: '8',
				tr: '17',
				code: '2001',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Recife',
			},
		],
		'2002': [
			{
				j: '8',
				tr: '15',
				code: '2002',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'João Pessoa',
			},
		],
		'2003': [
			{
				j: '8',
				tr: '15',
				code: '2003',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'João Pessoa',
			},
		],
		'2004': [
			{
				j: '8',
				tr: '15',
				code: '2004',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'João Pessoa',
			},
		],
		'2005': [
			{
				j: '8',
				tr: '15',
				code: '2005',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'João Pessoa',
			},
		],
		'2100': [
			{
				j: '8',
				tr: '04',
				code: '2100',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Anori',
			},
			{
				j: '8',
				tr: '17',
				code: '2100',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Abreu e Lima',
			},
		],
		'2110': [
			{
				j: '8',
				tr: '17',
				code: '2110',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Afogados da lngazeira',
			},
		],
		'2120': [
			{
				j: '8',
				tr: '17',
				code: '2120',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Afrânio',
			},
		],
		'2130': [
			{
				j: '8',
				tr: '17',
				code: '2130',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Agrestina',
			},
		],
		'2140': [
			{
				j: '8',
				tr: '17',
				code: '2140',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Água Preta',
			},
		],
		'2150': [
			{
				j: '8',
				tr: '17',
				code: '2150',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Águas Belas',
			},
		],
		'2160': [
			{
				j: '8',
				tr: '17',
				code: '2160',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Alagoinha',
			},
		],
		'2170': [
			{
				j: '8',
				tr: '17',
				code: '2170',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Aliança',
			},
		],
		'2180': [
			{
				j: '8',
				tr: '17',
				code: '2180',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Altinho',
			},
		],
		'2190': [
			{
				j: '8',
				tr: '17',
				code: '2190',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Amaraji',
			},
		],
		'2200': [
			{
				j: '8',
				tr: '04',
				code: '2200',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Anamã',
			},
			{
				j: '8',
				tr: '17',
				code: '2200',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Angelim',
			},
		],
		'2210': [
			{
				j: '8',
				tr: '17',
				code: '2210',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Araripina',
			},
		],
		'2220': [
			{
				j: '8',
				tr: '17',
				code: '2220',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Arcoverde',
			},
		],
		'2230': [
			{
				j: '8',
				tr: '17',
				code: '2230',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Barreiros',
			},
		],
		'2240': [
			{
				j: '8',
				tr: '17',
				code: '2240',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Belém de Maria',
			},
		],
		'2250': [
			{
				j: '8',
				tr: '17',
				code: '2250',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Belém do São Francisco',
			},
		],
		'2260': [
			{
				j: '8',
				tr: '17',
				code: '2260',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Belo Jardim',
			},
		],
		'2270': [
			{
				j: '8',
				tr: '17',
				code: '2270',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Betânia',
			},
		],
		'2280': [
			{
				j: '8',
				tr: '17',
				code: '2280',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Bezerros',
			},
		],
		'2290': [
			{
				j: '8',
				tr: '17',
				code: '2290',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Bodocó',
			},
		],
		'2300': [
			{
				j: '8',
				tr: '04',
				code: '2300',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Apui',
			},
			{
				j: '8',
				tr: '17',
				code: '2300',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Bom Conselho',
			},
		],
		'2310': [
			{
				j: '8',
				tr: '17',
				code: '2310',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Bom Jardim',
			},
		],
		'2320': [
			{
				j: '8',
				tr: '17',
				code: '2320',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Bonito',
			},
		],
		'2330': [
			{
				j: '8',
				tr: '17',
				code: '2330',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Brejão',
			},
		],
		'2340': [
			{
				j: '8',
				tr: '17',
				code: '2340',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Brejo da Madre de Deus ',
			},
		],
		'2350': [
			{
				j: '8',
				tr: '17',
				code: '2350',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Buenos Aires',
			},
		],
		'2360': [
			{
				j: '8',
				tr: '17',
				code: '2360',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Buíque',
			},
		],
		'2370': [
			{
				j: '8',
				tr: '17',
				code: '2370',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Cabo de Santo Agostinho',
			},
		],
		'2380': [
			{
				j: '8',
				tr: '17',
				code: '2380',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Cabrobó',
			},
		],
		'2390': [
			{
				j: '8',
				tr: '17',
				code: '2390',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Cachoeirinha',
			},
		],
		'2400': [
			{
				j: '8',
				tr: '04',
				code: '2400',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Atalaia do Norte',
			},
			{
				j: '8',
				tr: '17',
				code: '2400',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Caetés',
			},
		],
		'2410': [
			{
				j: '8',
				tr: '17',
				code: '2410',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Calçado',
			},
		],
		'2420': [
			{
				j: '8',
				tr: '17',
				code: '2420',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Camaragíbe',
			},
		],
		'2430': [
			{
				j: '8',
				tr: '17',
				code: '2430',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Camocim de São Félix',
			},
		],
		'2440': [
			{
				j: '8',
				tr: '17',
				code: '2440',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Canhotinho',
			},
		],
		'2450': [
			{
				j: '8',
				tr: '17',
				code: '2450',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Capoeiras',
			},
		],
		'2460': [
			{
				j: '8',
				tr: '17',
				code: '2460',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Carnaíba',
			},
		],
		'2470': [
			{
				j: '8',
				tr: '17',
				code: '2470',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Carpina',
			},
		],
		'2480': [
			{
				j: '8',
				tr: '17',
				code: '2480',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Caruaru',
			},
		],
		'2490': [
			{
				j: '8',
				tr: '17',
				code: '2490',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Catende',
			},
		],
		'2500': [
			{
				j: '8',
				tr: '04',
				code: '2500',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Autazes',
			},
			{
				j: '8',
				tr: '17',
				code: '2500',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Chã Grande',
			},
		],
		'2510': [
			{
				j: '8',
				tr: '17',
				code: '2510',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Condado',
			},
		],
		'2520': [
			{
				j: '8',
				tr: '17',
				code: '2520',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Correntes',
			},
		],
		'2530': [
			{
				j: '8',
				tr: '17',
				code: '2530',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Cortês',
			},
		],
		'2540': [
			{
				j: '8',
				tr: '17',
				code: '2540',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Cumaru',
			},
		],
		'2550': [
			{
				j: '8',
				tr: '17',
				code: '2550',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Cupira',
			},
		],
		'2560': [
			{
				j: '8',
				tr: '17',
				code: '2560',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Custódia',
			},
		],
		'2570': [
			{
				j: '8',
				tr: '17',
				code: '2570',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Escada',
			},
		],
		'2580': [
			{
				j: '8',
				tr: '17',
				code: '2580',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Exu ',
			},
		],
		'2590': [
			{
				j: '8',
				tr: '17',
				code: '2590',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Feira Nova',
			},
		],
		'2600': [
			{
				j: '8',
				tr: '04',
				code: '2600',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Barcelos',
			},
			{
				j: '8',
				tr: '17',
				code: '2600',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Ferreiros',
			},
		],
		'2610': [
			{
				j: '8',
				tr: '17',
				code: '2610',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Flores',
			},
		],
		'2620': [
			{
				j: '8',
				tr: '17',
				code: '2620',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Floresta ',
			},
		],
		'2630': [
			{
				j: '8',
				tr: '17',
				code: '2630',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Gameleira',
			},
		],
		'2640': [
			{
				j: '8',
				tr: '17',
				code: '2640',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Garanhuns',
			},
		],
		'2650': [
			{
				j: '8',
				tr: '17',
				code: '2650',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Glória do Goitá',
			},
		],
		'2660': [
			{
				j: '8',
				tr: '17',
				code: '2660',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Goiana',
			},
		],
		'2670': [
			{
				j: '8',
				tr: '17',
				code: '2670',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Gravatá',
			},
		],
		'2680': [
			{
				j: '8',
				tr: '17',
				code: '2680',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'lati',
			},
		],
		'2690': [
			{
				j: '8',
				tr: '17',
				code: '2690',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'lbimirim',
			},
		],
		'2700': [
			{
				j: '8',
				tr: '04',
				code: '2700',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Barreirinha',
			},
			{
				j: '8',
				tr: '17',
				code: '2700',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'lbirajuba',
			},
		],
		'2710': [
			{
				j: '8',
				tr: '17',
				code: '2710',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'lgarassu',
			},
		],
		'2720': [
			{
				j: '8',
				tr: '17',
				code: '2720',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'lnajá ',
			},
		],
		'2730': [
			{
				j: '8',
				tr: '17',
				code: '2730',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'lpojuca ',
			},
		],
		'2740': [
			{
				j: '8',
				tr: '17',
				code: '2740',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'lpubi',
			},
		],
		'2750': [
			{
				j: '8',
				tr: '17',
				code: '2750',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'ltaiba',
			},
		],
		'2760': [
			{
				j: '8',
				tr: '17',
				code: '2760',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Itamaracá',
			},
		],
		'2770': [
			{
				j: '8',
				tr: '17',
				code: '2770',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'ltambé',
			},
		],
		'2780': [
			{
				j: '8',
				tr: '17',
				code: '2780',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'ltapetim',
			},
		],
		'2790': [
			{
				j: '8',
				tr: '17',
				code: '2790',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'ltapissuma',
			},
		],
		'2800': [
			{
				j: '8',
				tr: '04',
				code: '2800',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Benjamin Constant',
			},
			{
				j: '8',
				tr: '17',
				code: '2800',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'ltaquitinga',
			},
		],
		'2810': [
			{
				j: '8',
				tr: '17',
				code: '2810',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Jaboatão dos Guararapes ',
			},
		],
		'2820': [
			{
				j: '8',
				tr: '17',
				code: '2820',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Jataúba',
			},
		],
		'2830': [
			{
				j: '8',
				tr: '17',
				code: '2830',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'João Alfredo',
			},
		],
		'2840': [
			{
				j: '8',
				tr: '17',
				code: '2840',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Joaouim Nabuco',
			},
		],
		'2850': [
			{
				j: '8',
				tr: '17',
				code: '2850',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Jupi',
			},
		],
		'2860': [
			{
				j: '8',
				tr: '17',
				code: '2860',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Jurema',
			},
		],
		'2870': [
			{
				j: '8',
				tr: '17',
				code: '2870',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Lagoa do ltaenga',
			},
		],
		'2880': [
			{
				j: '8',
				tr: '17',
				code: '2880',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Lagoa do Ouro',
			},
		],
		'2890': [
			{
				j: '8',
				tr: '17',
				code: '2890',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Lagoa dos Gatos',
			},
		],
		'2900': [
			{
				j: '8',
				tr: '04',
				code: '2900',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Beruri',
			},
			{
				j: '8',
				tr: '17',
				code: '2900',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Lagoa Grande',
			},
		],
		'2910': [
			{
				j: '8',
				tr: '17',
				code: '2910',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Lajedo',
			},
		],
		'2920': [
			{
				j: '8',
				tr: '17',
				code: '2920',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Limoeiro',
			},
		],
		'2930': [
			{
				j: '8',
				tr: '17',
				code: '2930',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Macaparana ',
			},
		],
		'2940': [
			{
				j: '8',
				tr: '17',
				code: '2940',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Maraial',
			},
		],
		'2950': [
			{
				j: '8',
				tr: '17',
				code: '2950',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Mirandiba',
			},
		],
		'2960': [
			{
				j: '8',
				tr: '17',
				code: '2960',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Moreilandia',
			},
		],
		'2970': [
			{
				j: '8',
				tr: '17',
				code: '2970',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Moreno',
			},
		],
		'2980': [
			{
				j: '8',
				tr: '17',
				code: '2980',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Nazaré da Mata',
			},
		],
		'2990': [
			{
				j: '8',
				tr: '17',
				code: '2990',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Olinda ',
			},
		],
		'3000': [
			{
				j: '4',
				tr: '01',
				code: '3000',
				courthouse: 'TRF1',
				state: 'AC',
				city: 'Rio Branco',
			},
			{
				j: '8',
				tr: '04',
				code: '3000',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Boa Vista dos Ramos',
			},
			{
				j: '8',
				tr: '17',
				code: '3000',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Orobó',
			},
		],
		'3001': [
			{
				j: '4',
				tr: '01',
				code: '3001',
				courthouse: 'TRF1',
				state: 'AC',
				city: 'Cruzeiro do Sul',
			},
		],
		'3010': [
			{
				j: '8',
				tr: '17',
				code: '3010',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Ocoró',
			},
		],
		'3020': [
			{
				j: '8',
				tr: '17',
				code: '3020',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Ouricuri ',
			},
		],
		'3030': [
			{
				j: '8',
				tr: '17',
				code: '3030',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Palmares',
			},
		],
		'3040': [
			{
				j: '8',
				tr: '17',
				code: '3040',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Palmeirina',
			},
		],
		'3050': [
			{
				j: '8',
				tr: '17',
				code: '3050',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Panelas',
			},
		],
		'3060': [
			{
				j: '8',
				tr: '17',
				code: '3060',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Parnamirim',
			},
		],
		'3070': [
			{
				j: '8',
				tr: '17',
				code: '3070',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Passira',
			},
		],
		'3080': [
			{
				j: '8',
				tr: '17',
				code: '3080',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Paudalho',
			},
		],
		'3090': [
			{
				j: '8',
				tr: '17',
				code: '3090',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Paulista',
			},
		],
		'3100': [
			{
				j: '4',
				tr: '01',
				code: '3100',
				courthouse: 'TRF1',
				state: 'AP',
				city: 'Macapá',
			},
			{
				j: '8',
				tr: '04',
				code: '3100',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Boca do Acre',
			},
			{
				j: '8',
				tr: '17',
				code: '3100',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Pedra',
			},
		],
		'3101': [
			{
				j: '4',
				tr: '01',
				code: '3101',
				courthouse: 'TRF1',
				state: 'AP',
				city: 'Laranjal do Jari',
			},
		],
		'3102': [
			{
				j: '4',
				tr: '01',
				code: '3102',
				courthouse: 'TRF1',
				state: 'AP',
				city: 'Oiapoque',
			},
		],
		'3110': [
			{
				j: '8',
				tr: '17',
				code: '3110',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Pesqueira',
			},
		],
		'3120': [
			{
				j: '8',
				tr: '17',
				code: '3120',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Petrolândia',
			},
		],
		'3130': [
			{
				j: '8',
				tr: '17',
				code: '3130',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Petrolina',
			},
		],
		'3140': [
			{
				j: '8',
				tr: '17',
				code: '3140',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Poção',
			},
		],
		'3150': [
			{
				j: '8',
				tr: '17',
				code: '3150',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Pombos',
			},
		],
		'3160': [
			{
				j: '8',
				tr: '17',
				code: '3160',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Primavera',
			},
		],
		'3170': [
			{
				j: '8',
				tr: '17',
				code: '3170',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Quipapá',
			},
		],
		'3180': [
			{
				j: '8',
				tr: '17',
				code: '3180',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Riacho das Almas',
			},
		],
		'3190': [
			{
				j: '8',
				tr: '17',
				code: '3190',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Ribeirão',
			},
		],
		'3200': [
			{
				j: '4',
				tr: '01',
				code: '3200',
				courthouse: 'TRF1',
				state: 'AM',
				city: 'Manaus',
			},
			{
				j: '8',
				tr: '04',
				code: '3200',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Borba',
			},
			{
				j: '8',
				tr: '17',
				code: '3200',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Rio Formoso',
			},
		],
		'3201': [
			{
				j: '4',
				tr: '01',
				code: '3201',
				courthouse: 'TRF1',
				state: 'AM',
				city: 'Tabatinga',
			},
		],
		'3210': [
			{
				j: '8',
				tr: '17',
				code: '3210',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Sairé',
			},
		],
		'3220': [
			{
				j: '8',
				tr: '17',
				code: '3220',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Salgueiro',
			},
		],
		'3230': [
			{
				j: '8',
				tr: '17',
				code: '3230',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Saloá',
			},
		],
		'3240': [
			{
				j: '8',
				tr: '17',
				code: '3240',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Sanharó',
			},
		],
		'3250': [
			{
				j: '8',
				tr: '17',
				code: '3250',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Santa Cruz do Capibaribe',
			},
		],
		'3260': [
			{
				j: '8',
				tr: '17',
				code: '3260',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Santa Maria da Boa Vista',
			},
		],
		'3270': [
			{
				j: '8',
				tr: '17',
				code: '3270',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Santa Maria do Cambucá',
			},
		],
		'3280': [
			{
				j: '8',
				tr: '17',
				code: '3280',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'São Bento do Una',
			},
		],
		'3290': [
			{
				j: '8',
				tr: '17',
				code: '3290',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'São Caetano',
			},
		],
		'3300': [
			{
				j: '4',
				tr: '01',
				code: '3300',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Salvador',
			},
			{
				j: '8',
				tr: '04',
				code: '3300',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Caapiranga',
			},
			{
				j: '8',
				tr: '17',
				code: '3300',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'São João',
			},
		],
		'3301': [
			{
				j: '4',
				tr: '01',
				code: '3301',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Ilhéus',
			},
		],
		'3302': [
			{
				j: '4',
				tr: '01',
				code: '3302',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Campo Formoso',
			},
		],
		'3303': [
			{
				j: '4',
				tr: '01',
				code: '3303',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Barreiras',
			},
		],
		'3304': [
			{
				j: '4',
				tr: '01',
				code: '3304',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Feira de Santana',
			},
		],
		'3305': [
			{
				j: '4',
				tr: '01',
				code: '3305',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Juazeiro',
			},
		],
		'3306': [
			{
				j: '4',
				tr: '01',
				code: '3306',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Paulo Afonso',
			},
		],
		'3307': [
			{
				j: '4',
				tr: '01',
				code: '3307',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Vitória da Conquista',
			},
		],
		'3308': [
			{
				j: '4',
				tr: '01',
				code: '3308',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Jequié',
			},
		],
		'3309': [
			{
				j: '4',
				tr: '01',
				code: '3309',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Guanambi',
			},
		],
		'3310': [
			{
				j: '4',
				tr: '01',
				code: '3310',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Eunápolis',
			},
			{
				j: '8',
				tr: '17',
				code: '3310',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'São Joaquim do Monte',
			},
		],
		'3311': [
			{
				j: '4',
				tr: '01',
				code: '3311',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Itabuna',
			},
		],
		'3312': [
			{
				j: '4',
				tr: '01',
				code: '3312',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Irecê',
			},
		],
		'3313': [
			{
				j: '4',
				tr: '01',
				code: '3313',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Teixeira de Freitas',
			},
		],
		'3314': [
			{
				j: '4',
				tr: '01',
				code: '3314',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Alagoinha',
			},
		],
		'3315': [
			{
				j: '4',
				tr: '01',
				code: '3315',
				courthouse: 'TRF1',
				state: 'BA',
				city: 'Bom Jesus da Lapa',
			},
		],
		'3320': [
			{
				j: '8',
				tr: '17',
				code: '3320',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'São José da Coroa Grande ',
			},
		],
		'3330': [
			{
				j: '8',
				tr: '17',
				code: '3330',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'São José do Belmonte',
			},
		],
		'3340': [
			{
				j: '8',
				tr: '17',
				code: '3340',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'São José do Egito',
			},
		],
		'3350': [
			{
				j: '8',
				tr: '17',
				code: '3350',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'São Lourenço da Mata',
			},
		],
		'3360': [
			{
				j: '8',
				tr: '17',
				code: '3360',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'São Vicente Férrer',
			},
		],
		'3370': [
			{
				j: '8',
				tr: '17',
				code: '3370',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Serra Talhada',
			},
		],
		'3380': [
			{
				j: '8',
				tr: '17',
				code: '3380',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Serrita',
			},
		],
		'3390': [
			{
				j: '8',
				tr: '17',
				code: '3390',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Sertânia',
			},
		],
		'3400': [
			{
				j: '4',
				tr: '01',
				code: '3400',
				courthouse: 'TRF1',
				state: 'DF',
				city: 'Brasília',
			},
			{
				j: '8',
				tr: '04',
				code: '3400',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Canutama',
			},
			{
				j: '8',
				tr: '17',
				code: '3400',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Sirinhaém',
			},
		],
		'3410': [
			{
				j: '8',
				tr: '17',
				code: '3410',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Surubim',
			},
		],
		'3420': [
			{
				j: '8',
				tr: '17',
				code: '3420',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Tabira',
			},
		],
		'3430': [
			{
				j: '8',
				tr: '17',
				code: '3430',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Tacaimbó',
			},
		],
		'3440': [
			{
				j: '8',
				tr: '17',
				code: '3440',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Tacaratu',
			},
		],
		'3450': [
			{
				j: '8',
				tr: '17',
				code: '3450',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Tamandaré',
			},
		],
		'3460': [
			{
				j: '8',
				tr: '17',
				code: '3460',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Taquaritinga do Norte',
			},
		],
		'3470': [
			{
				j: '8',
				tr: '17',
				code: '3470',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Terra Nova',
			},
		],
		'3480': [
			{
				j: '8',
				tr: '17',
				code: '3480',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Timbaúba',
			},
		],
		'3490': [
			{
				j: '8',
				tr: '17',
				code: '3490',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Toritama',
			},
		],
		'3500': [
			{
				j: '4',
				tr: '01',
				code: '3500',
				courthouse: 'TRF1',
				state: 'GO',
				city: 'Goiânia',
			},
			{
				j: '8',
				tr: '04',
				code: '3500',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Carauari',
			},
			{
				j: '8',
				tr: '17',
				code: '3500',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Tracunhaém',
			},
		],
		'3501': [
			{
				j: '4',
				tr: '01',
				code: '3501',
				courthouse: 'TRF1',
				state: 'GO',
				city: 'Luziânia',
			},
		],
		'3502': [
			{
				j: '4',
				tr: '01',
				code: '3502',
				courthouse: 'TRF1',
				state: 'GO',
				city: 'Anápolis',
			},
		],
		'3503': [
			{
				j: '4',
				tr: '01',
				code: '3503',
				courthouse: 'TRF1',
				state: 'GO',
				city: 'Rio Verde',
			},
		],
		'3504': [
			{
				j: '4',
				tr: '01',
				code: '3504',
				courthouse: 'TRF1',
				state: 'GO',
				city: 'Aparecida de Goiânia',
			},
		],
		'3505': [
			{
				j: '4',
				tr: '01',
				code: '3505',
				courthouse: 'TRF1',
				state: 'GO',
				city: 'Uruaçu',
			},
		],
		'3506': [
			{
				j: '4',
				tr: '01',
				code: '3506',
				courthouse: 'TRF1',
				state: 'GO',
				city: 'Formosa',
			},
		],
		'3507': [
			{
				j: '4',
				tr: '01',
				code: '3507',
				courthouse: 'TRF1',
				state: 'GO',
				city: 'Jataí',
			},
		],
		'3508': [
			{
				j: '4',
				tr: '01',
				code: '3508',
				courthouse: 'TRF1',
				state: 'GO',
				city: 'Itumbiara',
			},
		],
		'3510': [
			{
				j: '8',
				tr: '17',
				code: '3510',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Trindade',
			},
		],
		'3520': [
			{
				j: '8',
				tr: '17',
				code: '3520',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Triunfo',
			},
		],
		'3530': [
			{
				j: '8',
				tr: '17',
				code: '3530',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Tupanatinga',
			},
		],
		'3540': [
			{
				j: '8',
				tr: '17',
				code: '3540',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Tuparetama',
			},
		],
		'3550': [
			{
				j: '8',
				tr: '17',
				code: '3550',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Venturosa',
			},
		],
		'3560': [
			{
				j: '8',
				tr: '17',
				code: '3560',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Verdejante',
			},
		],
		'3570': [
			{
				j: '8',
				tr: '17',
				code: '3570',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Vertentes',
			},
		],
		'3580': [
			{
				j: '8',
				tr: '17',
				code: '3580',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Vicência',
			},
		],
		'3590': [
			{
				j: '8',
				tr: '17',
				code: '3590',
				courthouse: 'TJPE',
				state: 'PE',
				city: 'Vitória de Santo Antão',
			},
		],
		'3600': [
			{
				j: '4',
				tr: '01',
				code: '3600',
				courthouse: 'TRF1',
				state: 'MT',
				city: 'Cuiabá',
			},
			{
				j: '8',
				tr: '04',
				code: '3600',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Careiro da Varzea',
			},
		],
		'3601': [
			{
				j: '4',
				tr: '01',
				code: '3601',
				courthouse: 'TRF1',
				state: 'MT',
				city: 'Cáceres',
			},
		],
		'3602': [
			{
				j: '4',
				tr: '01',
				code: '3602',
				courthouse: 'TRF1',
				state: 'MT',
				city: 'Rondonópolis',
			},
		],
		'3603': [
			{
				j: '4',
				tr: '01',
				code: '3603',
				courthouse: 'TRF1',
				state: 'MT',
				city: 'Sinop',
			},
		],
		'3604': [
			{
				j: '4',
				tr: '01',
				code: '3604',
				courthouse: 'TRF1',
				state: 'MT',
				city: 'Diamantino',
			},
		],
		'3605': [
			{
				j: '4',
				tr: '01',
				code: '3605',
				courthouse: 'TRF1',
				state: 'MT',
				city: 'Barra do Garças',
			},
		],
		'3606': [
			{
				j: '4',
				tr: '01',
				code: '3606',
				courthouse: 'TRF1',
				state: 'MT',
				city: 'Juína',
			},
		],
		'3700': [
			{
				j: '4',
				tr: '01',
				code: '3700',
				courthouse: 'TRF1',
				state: 'MA',
				city: 'São Luís',
			},
			{
				j: '8',
				tr: '04',
				code: '3700',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Careiro',
			},
		],
		'3701': [
			{
				j: '4',
				tr: '01',
				code: '3701',
				courthouse: 'TRF1',
				state: 'MA',
				city: 'Imperatriz',
			},
		],
		'3702': [
			{
				j: '4',
				tr: '01',
				code: '3702',
				courthouse: 'TRF1',
				state: 'MA',
				city: 'Caxias',
			},
		],
		'3703': [
			{
				j: '4',
				tr: '01',
				code: '3703',
				courthouse: 'TRF1',
				state: 'MA',
				city: 'Bacabal',
			},
		],
		'3704': [
			{
				j: '4',
				tr: '01',
				code: '3704',
				courthouse: 'TRF1',
				state: 'MA',
				city: 'Balsas',
			},
		],
		'3800': [
			{
				j: '4',
				tr: '06',
				code: '3800',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Belo Horizonte',
			},
			{
				j: '4',
				tr: '01',
				code: '3800',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Belo Horizonte',
			},
			{
				j: '8',
				tr: '04',
				code: '3800',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Coari',
			},
		],
		'3801': [
			{
				j: '4',
				tr: '06',
				code: '3801',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Juiz de Fora',
			},
			{
				j: '4',
				tr: '01',
				code: '3801',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Juiz de Fora',
			},
		],
		'3802': [
			{
				j: '4',
				tr: '06',
				code: '3802',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Uberaba',
			},
			{
				j: '4',
				tr: '01',
				code: '3802',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Uberaba',
			},
		],
		'3803': [
			{
				j: '4',
				tr: '06',
				code: '3803',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Uberlândia',
			},
			{
				j: '4',
				tr: '01',
				code: '3803',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Uberlândia',
			},
		],
		'3804': [
			{
				j: '4',
				tr: '06',
				code: '3804',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Passos',
			},
			{
				j: '4',
				tr: '01',
				code: '3804',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Passos',
			},
		],
		'3805': [
			{
				j: '4',
				tr: '06',
				code: '3805',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'São Sebatião do Paraíso',
			},
			{
				j: '4',
				tr: '01',
				code: '3805',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'São Sebatião do Paraíso',
			},
		],
		'3806': [
			{
				j: '4',
				tr: '06',
				code: '3806',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Patos de Minas',
			},
			{
				j: '4',
				tr: '01',
				code: '3806',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Patos de Minas',
			},
		],
		'3807': [
			{
				j: '4',
				tr: '06',
				code: '3807',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Montes Claros',
			},
			{
				j: '4',
				tr: '01',
				code: '3807',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Montes Claros',
			},
		],
		'3808': [
			{
				j: '4',
				tr: '06',
				code: '3808',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Lavras',
			},
			{
				j: '4',
				tr: '01',
				code: '3808',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Lavras',
			},
		],
		'3809': [
			{
				j: '4',
				tr: '06',
				code: '3809',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Varginha',
			},
			{
				j: '4',
				tr: '01',
				code: '3809',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Varginha',
			},
		],
		'3810': [
			{
				j: '4',
				tr: '06',
				code: '3810',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Pouso Alegre',
			},
			{
				j: '4',
				tr: '01',
				code: '3810',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Pouso Alegre',
			},
		],
		'3811': [
			{
				j: '4',
				tr: '06',
				code: '3811',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Divinópolis',
			},
			{
				j: '4',
				tr: '01',
				code: '3811',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Divinópolis',
			},
		],
		'3812': [
			{
				j: '4',
				tr: '06',
				code: '3812',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Sete Lagoas',
			},
			{
				j: '4',
				tr: '01',
				code: '3812',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Sete Lagoas',
			},
		],
		'3813': [
			{
				j: '4',
				tr: '06',
				code: '3813',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Governador Valadares',
			},
			{
				j: '4',
				tr: '01',
				code: '3813',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Governador Valadares',
			},
		],
		'3814': [
			{
				j: '4',
				tr: '06',
				code: '3814',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Ipatinga',
			},
			{
				j: '4',
				tr: '01',
				code: '3814',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Ipatinga',
			},
		],
		'3815': [
			{
				j: '4',
				tr: '06',
				code: '3815',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'São João Del Rey',
			},
			{
				j: '4',
				tr: '01',
				code: '3815',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'São João Del Rey',
			},
		],
		'3816': [
			{
				j: '4',
				tr: '06',
				code: '3816',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Teófilo Otoni',
			},
		],
		'3817': [
			{
				j: '4',
				tr: '06',
				code: '3817',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Paracatu',
			},
		],
		'3818': [
			{
				j: '4',
				tr: '06',
				code: '3818',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Unaí',
			},
		],
		'3819': [
			{
				j: '4',
				tr: '06',
				code: '3819',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Manhuaçu',
			},
		],
		'3820': [
			{
				j: '4',
				tr: '06',
				code: '3820',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Contagem',
			},
		],
		'3821': [
			{
				j: '4',
				tr: '06',
				code: '3821',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Muriaé',
			},
		],
		'3822': [
			{
				j: '4',
				tr: '06',
				code: '3822',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Ponte Nova',
			},
		],
		'3823': [
			{
				j: '4',
				tr: '06',
				code: '3823',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Viçosa',
			},
		],
		'3824': [
			{
				j: '4',
				tr: '06',
				code: '3824',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Ituiutaba',
			},
		],
		'3825': [
			{
				j: '4',
				tr: '06',
				code: '3825',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Janaúba',
			},
		],
		'3826': [
			{
				j: '4',
				tr: '06',
				code: '3826',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Poços de Caldas',
			},
			{
				j: '4',
				tr: '01',
				code: '3826',
				courthouse: 'TRF6',
				state: 'MG',
				city: 'Poços de Caldas',
			},
		],
		'3900': [
			{
				j: '4',
				tr: '01',
				code: '3900',
				courthouse: 'TRF1',
				state: 'PA',
				city: 'Belém',
			},
			{
				j: '8',
				tr: '04',
				code: '3900',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Codajás',
			},
		],
		'3901': [
			{
				j: '4',
				tr: '01',
				code: '3901',
				courthouse: 'TRF1',
				state: 'PA',
				city: 'Marabá',
			},
		],
		'3902': [
			{
				j: '4',
				tr: '01',
				code: '3902',
				courthouse: 'TRF1',
				state: 'PA',
				city: 'Santarém',
			},
		],
		'3903': [
			{
				j: '4',
				tr: '01',
				code: '3903',
				courthouse: 'TRF1',
				state: 'PA',
				city: 'Altamira',
			},
		],
		'3904': [
			{
				j: '4',
				tr: '01',
				code: '3904',
				courthouse: 'TRF1',
				state: 'PA',
				city: 'Castanhal',
			},
		],
		'3905': [
			{
				j: '4',
				tr: '01',
				code: '3905',
				courthouse: 'TRF1',
				state: 'PA',
				city: 'Redenção',
			},
		],
		'3906': [
			{
				j: '4',
				tr: '01',
				code: '3906',
				courthouse: 'TRF1',
				state: 'PA',
				city: 'Paragominas',
			},
		],
		'3907': [
			{
				j: '4',
				tr: '01',
				code: '3907',
				courthouse: 'TRF1',
				state: 'PA',
				city: 'Tucuruí',
			},
		],
		'3908': [
			{
				j: '4',
				tr: '01',
				code: '3908',
				courthouse: 'TRF1',
				state: 'PA',
				city: 'Itaituba',
			},
		],
		'4000': [
			{
				j: '4',
				tr: '01',
				code: '4000',
				courthouse: 'TRF1',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '04',
				code: '4000',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Envira',
			},
		],
		'4001': [
			{
				j: '4',
				tr: '01',
				code: '4001',
				courthouse: 'TRF1',
				state: 'PI',
				city: 'Picos ',
			},
		],
		'4002': [
			{
				j: '4',
				tr: '01',
				code: '4002',
				courthouse: 'TRF1',
				state: 'PI',
				city: 'Parnaíba',
			},
		],
		'4003': [
			{
				j: '4',
				tr: '01',
				code: '4003',
				courthouse: 'TRF1',
				state: 'PI',
				city: 'Floriano',
			},
		],
		'4004': [
			{
				j: '4',
				tr: '01',
				code: '4004',
				courthouse: 'TRF1',
				state: 'PI',
				city: 'São Raimundo Nonato',
			},
		],
		'4005': [
			{
				j: '4',
				tr: '01',
				code: '4005',
				courthouse: 'TRF1',
				state: 'PI',
				city: 'Corrente',
			},
		],
		'4100': [
			{
				j: '4',
				tr: '01',
				code: '4100',
				courthouse: 'TRF1',
				state: 'RO',
				city: 'Porto Velho',
			},
			{
				j: '8',
				tr: '04',
				code: '4100',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Eirunepé',
			},
		],
		'4101': [
			{
				j: '4',
				tr: '01',
				code: '4101',
				courthouse: 'TRF1',
				state: 'RO',
				city: 'Ji-Paraná',
			},
		],
		'4103': [
			{
				j: '4',
				tr: '01',
				code: '4103',
				courthouse: 'TRF1',
				state: 'RO',
				city: 'Vilhena',
			},
		],
		'4200': [
			{
				j: '4',
				tr: '01',
				code: '4200',
				courthouse: 'TRF1',
				state: 'RR',
				city: 'Boa Vista',
			},
			{
				j: '8',
				tr: '04',
				code: '4200',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Fonte Boa',
			},
		],
		'4300': [
			{
				j: '4',
				tr: '01',
				code: '4300',
				courthouse: 'TRF1',
				state: 'TO',
				city: 'Palmas',
			},
			{
				j: '8',
				tr: '04',
				code: '4300',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Guarajá',
			},
		],
		'4301': [
			{
				j: '4',
				tr: '01',
				code: '4301',
				courthouse: 'TRF1',
				state: 'TO',
				city: 'Araguaína',
			},
		],
		'4302': [
			{
				j: '4',
				tr: '01',
				code: '4302',
				courthouse: 'TRF1',
				state: 'TO',
				city: 'Gurupi',
			},
		],
		'4400': [
			{
				j: '8',
				tr: '04',
				code: '4400',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Humaitá',
			},
		],
		'4500': [
			{
				j: '8',
				tr: '04',
				code: '4500',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Ipixuna',
			},
		],
		'4600': [
			{
				j: '8',
				tr: '04',
				code: '4600',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Iranduba',
			},
		],
		'4700': [
			{
				j: '8',
				tr: '04',
				code: '4700',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Itacoatiara',
			},
		],
		'4800': [
			{
				j: '8',
				tr: '04',
				code: '4800',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Itamarati',
			},
		],
		'4900': [
			{
				j: '8',
				tr: '04',
				code: '4900',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Itapiranga',
			},
		],
		'5000': [
			{
				j: '8',
				tr: '04',
				code: '5000',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Japurá',
			},
		],
		'5001': [
			{
				j: '4',
				tr: '02',
				code: '5001',
				courthouse: 'TRF2',
				state: 'ES',
				city: 'Vitória ',
			},
		],
		'5002': [
			{
				j: '4',
				tr: '02',
				code: '5002',
				courthouse: 'TRF2',
				state: 'ES',
				city: 'Cachoeiro Itapemirim',
			},
		],
		'5003': [
			{
				j: '4',
				tr: '02',
				code: '5003',
				courthouse: 'TRF2',
				state: 'ES',
				city: 'São Mateus',
			},
		],
		'5004': [
			{
				j: '4',
				tr: '02',
				code: '5004',
				courthouse: 'TRF2',
				state: 'ES',
				city: 'Linhares',
			},
		],
		'5005': [
			{
				j: '4',
				tr: '02',
				code: '5005',
				courthouse: 'TRF2',
				state: 'ES',
				city: 'Colatina',
			},
		],
		'5006': [
			{
				j: '4',
				tr: '02',
				code: '5006',
				courthouse: 'TRF2',
				state: 'ES',
				city: 'Serra',
			},
		],
		'5100': [
			{
				j: '8',
				tr: '04',
				code: '5100',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Juruá',
			},
		],
		'5101': [
			{
				j: '4',
				tr: '02',
				code: '5101',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Rio de Janeiro',
			},
		],
		'5102': [
			{
				j: '4',
				tr: '02',
				code: '5102',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Niteroi',
			},
		],
		'5103': [
			{
				j: '4',
				tr: '02',
				code: '5103',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Campos',
			},
		],
		'5104': [
			{
				j: '4',
				tr: '02',
				code: '5104',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Volta Redonda',
			},
		],
		'5105': [
			{
				j: '4',
				tr: '02',
				code: '5105',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Nova Friburgo',
			},
		],
		'5106': [
			{
				j: '4',
				tr: '02',
				code: '5106',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Petrópolis',
			},
		],
		'5107': [
			{
				j: '4',
				tr: '02',
				code: '5107',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Itaboraí',
			},
		],
		'5108': [
			{
				j: '4',
				tr: '02',
				code: '5108',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'São Pedro da Aldeia',
			},
		],
		'5109': [
			{
				j: '4',
				tr: '02',
				code: '5109',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Resende',
			},
		],
		'5110': [
			{
				j: '4',
				tr: '02',
				code: '5110',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'São João do Meriti',
			},
		],
		'5111': [
			{
				j: '4',
				tr: '02',
				code: '5111',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Angra dos Reis',
			},
		],
		'5112': [
			{
				j: '4',
				tr: '02',
				code: '5112',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Itaperuna',
			},
		],
		'5113': [
			{
				j: '4',
				tr: '02',
				code: '5113',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Três Rios',
			},
		],
		'5114': [
			{
				j: '4',
				tr: '02',
				code: '5114',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Majé',
			},
		],
		'5115': [
			{
				j: '4',
				tr: '02',
				code: '5115',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Teresópolis',
			},
		],
		'5116': [
			{
				j: '4',
				tr: '02',
				code: '5116',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Macaé',
			},
		],
		'5117': [
			{
				j: '4',
				tr: '02',
				code: '5117',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'São Gonçalo',
			},
		],
		'5118': [
			{
				j: '4',
				tr: '02',
				code: '5118',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Duque de Caxias',
			},
		],
		'5119': [
			{
				j: '4',
				tr: '02',
				code: '5119',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Barra do Piraí',
			},
		],
		'5120': [
			{
				j: '4',
				tr: '02',
				code: '5120',
				courthouse: 'TRF2',
				state: 'RJ',
				city: 'Nova Iguaçu',
			},
		],
		'5200': [
			{
				j: '8',
				tr: '04',
				code: '5200',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Jutaí',
			},
		],
		'5300': [
			{
				j: '8',
				tr: '04',
				code: '5300',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Lábrea',
			},
		],
		'5400': [
			{
				j: '8',
				tr: '04',
				code: '5400',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Manacapuru',
			},
		],
		'5500': [
			{
				j: '8',
				tr: '04',
				code: '5500',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Manaquiri',
			},
		],
		'5600': [
			{
				j: '8',
				tr: '04',
				code: '5600',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Manicoré',
			},
		],
		'5700': [
			{
				j: '8',
				tr: '04',
				code: '5700',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Maraã',
			},
		],
		'5800': [
			{
				j: '8',
				tr: '04',
				code: '5800',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Maués',
			},
		],
		'5900': [
			{
				j: '8',
				tr: '04',
				code: '5900',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Novo Airão',
			},
		],
		'6000': [
			{
				j: '4',
				tr: '03',
				code: '6000',
				courthouse: 'TRF3',
				state: 'MS',
				city: 'Campo Grande ',
			},
			{
				j: '8',
				tr: '04',
				code: '6000',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Nova Olinda do Norte',
			},
		],
		'6002': [
			{
				j: '4',
				tr: '03',
				code: '6002',
				courthouse: 'TRF3',
				state: 'MS',
				city: 'Dourados',
			},
		],
		'6003': [
			{
				j: '4',
				tr: '03',
				code: '6003',
				courthouse: 'TRF3',
				state: 'MS',
				city: 'Três Lagoas',
			},
		],
		'6004': [
			{
				j: '4',
				tr: '03',
				code: '6004',
				courthouse: 'TRF3',
				state: 'MS',
				city: 'Corumbá',
			},
		],
		'6005': [
			{
				j: '4',
				tr: '03',
				code: '6005',
				courthouse: 'TRF3',
				state: 'MS',
				city: 'Ponta Porã',
			},
		],
		'6006': [
			{
				j: '4',
				tr: '03',
				code: '6006',
				courthouse: 'TRF3',
				state: 'MS',
				city: 'Naviraí',
			},
		],
		'6007': [
			{
				j: '4',
				tr: '03',
				code: '6007',
				courthouse: 'TRF3',
				state: 'MS',
				city: 'Coxim',
			},
		],
		'6084': [
			{
				j: '4',
				tr: '03',
				code: '6084',
				courthouse: 'TRF3',
				state: 'MS',
				city: 'Campo Grande ',
			},
		],
		'6094': [
			{
				j: '8',
				tr: '26',
				code: '6094',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Piracaia ',
			},
		],
		'6100': [
			{
				j: '4',
				tr: '03',
				code: '6100',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
			{
				j: '8',
				tr: '04',
				code: '6100',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Nhamundá',
			},
		],
		'6102': [
			{
				j: '4',
				tr: '03',
				code: '6102',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Ribeirão Preto',
			},
		],
		'6103': [
			{
				j: '4',
				tr: '03',
				code: '6103',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São José dos Campos',
			},
		],
		'6104': [
			{
				j: '4',
				tr: '03',
				code: '6104',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Santos',
			},
		],
		'6105': [
			{
				j: '4',
				tr: '03',
				code: '6105',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Campinas',
			},
		],
		'6106': [
			{
				j: '4',
				tr: '03',
				code: '6106',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São José do Rio Preto',
			},
		],
		'6107': [
			{
				j: '4',
				tr: '03',
				code: '6107',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Araçatuba ',
			},
		],
		'6108': [
			{
				j: '4',
				tr: '03',
				code: '6108',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Bauru',
			},
		],
		'6109': [
			{
				j: '4',
				tr: '03',
				code: '6109',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Piracicaba',
			},
		],
		'6110': [
			{
				j: '4',
				tr: '03',
				code: '6110',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Sorocaba',
			},
		],
		'6111': [
			{
				j: '4',
				tr: '03',
				code: '6111',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Marília',
			},
		],
		'6112': [
			{
				j: '4',
				tr: '03',
				code: '6112',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Presidente Prudente',
			},
		],
		'6113': [
			{
				j: '4',
				tr: '03',
				code: '6113',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Franca',
			},
		],
		'6114': [
			{
				j: '4',
				tr: '03',
				code: '6114',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Bernardo do Campo',
			},
		],
		'6115': [
			{
				j: '4',
				tr: '03',
				code: '6115',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Carlos',
			},
		],
		'6116': [
			{
				j: '4',
				tr: '03',
				code: '6116',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Assis',
			},
		],
		'6117': [
			{
				j: '4',
				tr: '03',
				code: '6117',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Jaú',
			},
		],
		'6118': [
			{
				j: '4',
				tr: '03',
				code: '6118',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Guaratinguetá',
			},
		],
		'6119': [
			{
				j: '4',
				tr: '03',
				code: '6119',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Guarulhos',
			},
		],
		'6120': [
			{
				j: '4',
				tr: '03',
				code: '6120',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Araraquara',
			},
		],
		'6121': [
			{
				j: '4',
				tr: '03',
				code: '6121',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Taubaté',
			},
		],
		'6122': [
			{
				j: '4',
				tr: '03',
				code: '6122',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Tupã',
			},
		],
		'6123': [
			{
				j: '4',
				tr: '03',
				code: '6123',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Bragança Paulista',
			},
		],
		'6124': [
			{
				j: '4',
				tr: '03',
				code: '6124',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Jales',
			},
		],
		'6125': [
			{
				j: '4',
				tr: '03',
				code: '6125',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Ourinhos',
			},
		],
		'6126': [
			{
				j: '4',
				tr: '03',
				code: '6126',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Santo André',
			},
		],
		'6127': [
			{
				j: '4',
				tr: '03',
				code: '6127',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São João da Boa Vista',
			},
		],
		'6128': [
			{
				j: '4',
				tr: '03',
				code: '6128',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Jundiaí',
			},
		],
		'6129': [
			{
				j: '4',
				tr: '03',
				code: '6129',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Registro',
			},
		],
		'6130': [
			{
				j: '4',
				tr: '03',
				code: '6130',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Osasco',
			},
		],
		'6131': [
			{
				j: '4',
				tr: '03',
				code: '6131',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Botucatu',
			},
		],
		'6132': [
			{
				j: '4',
				tr: '03',
				code: '6132',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Avaré',
			},
		],
		'6133': [
			{
				j: '4',
				tr: '03',
				code: '6133',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Mogi das Cruzes',
			},
		],
		'6134': [
			{
				j: '4',
				tr: '03',
				code: '6134',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Americana',
			},
		],
		'6135': [
			{
				j: '4',
				tr: '03',
				code: '6135',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Caraguatatuba',
			},
		],
		'6136': [
			{
				j: '4',
				tr: '03',
				code: '6136',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Catanduva',
			},
		],
		'6137': [
			{
				j: '4',
				tr: '03',
				code: '6137',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Andradina',
			},
		],
		'6138': [
			{
				j: '4',
				tr: '03',
				code: '6138',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Barretos',
			},
		],
		'6139': [
			{
				j: '4',
				tr: '03',
				code: '6139',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Itapeva',
			},
		],
		'6140': [
			{
				j: '4',
				tr: '03',
				code: '6140',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Mauá',
			},
		],
		'6141': [
			{
				j: '4',
				tr: '03',
				code: '6141',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Vicente',
			},
		],
		'6142': [
			{
				j: '4',
				tr: '03',
				code: '6142',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Lins',
			},
		],
		'6143': [
			{
				j: '4',
				tr: '03',
				code: '6143',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Limeira',
			},
		],
		'6144': [
			{
				j: '4',
				tr: '03',
				code: '6144',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Barueri',
			},
		],
		'6181': [
			{
				j: '4',
				tr: '03',
				code: '6181',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
		],
		'6182': [
			{
				j: '4',
				tr: '03',
				code: '6182',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
		],
		'6183': [
			{
				j: '4',
				tr: '03',
				code: '6183',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
		],
		'6184': [
			{
				j: '4',
				tr: '03',
				code: '6184',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
		],
		'6185': [
			{
				j: '4',
				tr: '03',
				code: '6185',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Ribeirão Preto',
			},
		],
		'6186': [
			{
				j: '4',
				tr: '03',
				code: '6186',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Campinas',
			},
		],
		'6187': [
			{
				j: '4',
				tr: '03',
				code: '6187',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
		],
		'6188': [
			{
				j: '4',
				tr: '03',
				code: '6188',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
		],
		'6189': [
			{
				j: '4',
				tr: '03',
				code: '6189',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
		],
		'6200': [
			{
				j: '8',
				tr: '04',
				code: '6200',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Novo Aripuanã',
			},
		],
		'6201': [
			{
				j: '4',
				tr: '03',
				code: '6201',
				courthouse: 'TRF3',
				state: 'MS',
				city: 'Campo Grande ',
			},
		],
		'6202': [
			{
				j: '4',
				tr: '03',
				code: '6202',
				courthouse: 'TRF3',
				state: 'MS',
				city: 'Dourados',
			},
		],
		'6300': [
			{
				j: '8',
				tr: '04',
				code: '6300',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Parintins',
			},
		],
		'6301': [
			{
				j: '4',
				tr: '03',
				code: '6301',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
		],
		'6302': [
			{
				j: '4',
				tr: '03',
				code: '6302',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Ribeirão Preto',
			},
		],
		'6303': [
			{
				j: '4',
				tr: '03',
				code: '6303',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Campinas',
			},
		],
		'6304': [
			{
				j: '4',
				tr: '03',
				code: '6304',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Jundiaí',
			},
		],
		'6305': [
			{
				j: '4',
				tr: '03',
				code: '6305',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Registro',
			},
		],
		'6306': [
			{
				j: '4',
				tr: '03',
				code: '6306',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Osasco',
			},
		],
		'6307': [
			{
				j: '4',
				tr: '03',
				code: '6307',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Botucatu',
			},
		],
		'6308': [
			{
				j: '4',
				tr: '03',
				code: '6308',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Avaré',
			},
		],
		'6309': [
			{
				j: '4',
				tr: '03',
				code: '6309',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Mogi das Cruzes',
			},
		],
		'6310': [
			{
				j: '4',
				tr: '03',
				code: '6310',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Americana',
			},
		],
		'6311': [
			{
				j: '4',
				tr: '03',
				code: '6311',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Santos',
			},
		],
		'6312': [
			{
				j: '4',
				tr: '03',
				code: '6312',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Carlos',
			},
		],
		'6313': [
			{
				j: '4',
				tr: '03',
				code: '6313',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Caraguatatuba',
			},
		],
		'6314': [
			{
				j: '4',
				tr: '03',
				code: '6314',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Catanduva',
			},
		],
		'6315': [
			{
				j: '4',
				tr: '03',
				code: '6315',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Sorocaba',
			},
		],
		'6316': [
			{
				j: '4',
				tr: '03',
				code: '6316',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Andradina',
			},
		],
		'6317': [
			{
				j: '4',
				tr: '03',
				code: '6317',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Santo André',
			},
		],
		'6318': [
			{
				j: '4',
				tr: '03',
				code: '6318',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Franca',
			},
		],
		'6319': [
			{
				j: '4',
				tr: '03',
				code: '6319',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Lins',
			},
		],
		'6320': [
			{
				j: '4',
				tr: '03',
				code: '6320',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Cruzeiro',
			},
		],
		'6321': [
			{
				j: '4',
				tr: '03',
				code: '6321',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Vicente',
			},
		],
		'6322': [
			{
				j: '4',
				tr: '03',
				code: '6322',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Araraquara',
			},
		],
		'6323': [
			{
				j: '4',
				tr: '03',
				code: '6323',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Ourinhos',
			},
		],
		'6324': [
			{
				j: '4',
				tr: '03',
				code: '6324',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São José do Rio Preto',
			},
		],
		'6325': [
			{
				j: '4',
				tr: '03',
				code: '6325',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Bauru',
			},
		],
		'6326': [
			{
				j: '4',
				tr: '03',
				code: '6326',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Piracicaba',
			},
		],
		'6327': [
			{
				j: '4',
				tr: '03',
				code: '6327',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São José dos Campos',
			},
		],
		'6328': [
			{
				j: '4',
				tr: '03',
				code: '6328',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Presidente Prudente',
			},
		],
		'6329': [
			{
				j: '4',
				tr: '03',
				code: '6329',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Bragança Paulista',
			},
		],
		'6330': [
			{
				j: '4',
				tr: '03',
				code: '6330',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Tatuapé',
			},
		],
		'6331': [
			{
				j: '4',
				tr: '03',
				code: '6331',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Araçatuba ',
			},
		],
		'6332': [
			{
				j: '4',
				tr: '03',
				code: '6332',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Guarulhos',
			},
		],
		'6333': [
			{
				j: '4',
				tr: '03',
				code: '6333',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Limeira',
			},
		],
		'6334': [
			{
				j: '4',
				tr: '03',
				code: '6334',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Assis',
			},
		],
		'6335': [
			{
				j: '4',
				tr: '03',
				code: '6335',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Barretos',
			},
		],
		'6336': [
			{
				j: '4',
				tr: '03',
				code: '6336',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Jaú',
			},
		],
		'6337': [
			{
				j: '4',
				tr: '03',
				code: '6337',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Jales',
			},
		],
		'6338': [
			{
				j: '4',
				tr: '03',
				code: '6338',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Bernardo do Campo',
			},
		],
		'6339': [
			{
				j: '4',
				tr: '03',
				code: '6339',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Tupã',
			},
		],
		'6340': [
			{
				j: '4',
				tr: '03',
				code: '6340',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Guaratinguetá',
			},
		],
		'6341': [
			{
				j: '4',
				tr: '03',
				code: '6341',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Itapeva',
			},
		],
		'6342': [
			{
				j: '4',
				tr: '03',
				code: '6342',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Barueri',
			},
		],
		'6343': [
			{
				j: '4',
				tr: '03',
				code: '6343',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Mauá',
			},
		],
		'6387': [
			{
				j: '4',
				tr: '03',
				code: '6387',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
		],
		'6389': [
			{
				j: '4',
				tr: '03',
				code: '6389',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
		],
		'6400': [
			{
				j: '8',
				tr: '04',
				code: '6400',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Pauini',
			},
		],
		'6401': [
			{
				j: '4',
				tr: '03',
				code: '6401',
				courthouse: 'TRF3',
				state: 'MS',
				city: 'Campo Grande ',
			},
		],
		'6500': [
			{
				j: '4',
				tr: '03',
				code: '6500',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
			{
				j: '8',
				tr: '04',
				code: '6500',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Presidente Figueiredo',
			},
		],
		'6600': [
			{
				j: '8',
				tr: '04',
				code: '6600',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Rio Preto da Eva',
			},
		],
		'6700': [
			{
				j: '8',
				tr: '04',
				code: '6700',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Santa Isabel do Rio Negro',
			},
		],
		'6800': [
			{
				j: '8',
				tr: '04',
				code: '6800',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Santo Antônio do Içá',
			},
		],
		'6801': [
			{
				j: '4',
				tr: '03',
				code: '6801',
				courthouse: 'TRF3',
				state: 'MS',
				city: 'Campo Grande ',
			},
		],
		'6802': [
			{
				j: '4',
				tr: '03',
				code: '6802',
				courthouse: 'TRF3',
				state: 'MS',
				city: 'Dourados',
			},
		],
		'6900': [
			{
				j: '4',
				tr: '03',
				code: '6900',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
			{
				j: '8',
				tr: '04',
				code: '6900',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'São Gabriel da Cachoeira',
			},
		],
		'6901': [
			{
				j: '4',
				tr: '03',
				code: '6901',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
		],
		'6902': [
			{
				j: '4',
				tr: '03',
				code: '6902',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Ribeirão Preto',
			},
		],
		'6903': [
			{
				j: '4',
				tr: '03',
				code: '6903',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São José dos Campos',
			},
		],
		'6904': [
			{
				j: '4',
				tr: '03',
				code: '6904',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Santos',
			},
		],
		'6905': [
			{
				j: '4',
				tr: '03',
				code: '6905',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Campinas',
			},
		],
		'6906': [
			{
				j: '4',
				tr: '03',
				code: '6906',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São José do Rio Preto',
			},
		],
		'6907': [
			{
				j: '4',
				tr: '03',
				code: '6907',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Araçatuba ',
			},
		],
		'6908': [
			{
				j: '4',
				tr: '03',
				code: '6908',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Bauru',
			},
		],
		'6909': [
			{
				j: '4',
				tr: '03',
				code: '6909',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Piracicaba',
			},
		],
		'6910': [
			{
				j: '4',
				tr: '03',
				code: '6910',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Sorocaba',
			},
		],
		'6911': [
			{
				j: '4',
				tr: '03',
				code: '6911',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Marília',
			},
		],
		'6912': [
			{
				j: '4',
				tr: '03',
				code: '6912',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Presidente Prudente',
			},
		],
		'6913': [
			{
				j: '4',
				tr: '03',
				code: '6913',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Franca',
			},
		],
		'6914': [
			{
				j: '4',
				tr: '03',
				code: '6914',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Bernardo do Campo',
			},
		],
		'6915': [
			{
				j: '4',
				tr: '03',
				code: '6915',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Carlos',
			},
		],
		'6918': [
			{
				j: '4',
				tr: '03',
				code: '6918',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Guaratinguetá',
			},
		],
		'6919': [
			{
				j: '4',
				tr: '03',
				code: '6919',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Guarulhos',
			},
		],
		'6920': [
			{
				j: '4',
				tr: '03',
				code: '6920',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Araraquara',
			},
		],
		'6921': [
			{
				j: '4',
				tr: '03',
				code: '6921',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Taubaté',
			},
		],
		'6923': [
			{
				j: '4',
				tr: '03',
				code: '6923',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Bragança ',
			},
		],
		'6925': [
			{
				j: '4',
				tr: '03',
				code: '6925',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Ourinhos',
			},
		],
		'6926': [
			{
				j: '4',
				tr: '03',
				code: '6926',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Santo André',
			},
		],
		'6928': [
			{
				j: '4',
				tr: '03',
				code: '6928',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Jundiaí',
			},
		],
		'6929': [
			{
				j: '4',
				tr: '03',
				code: '6929',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Registro',
			},
		],
		'6930': [
			{
				j: '4',
				tr: '03',
				code: '6930',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Osasco',
			},
		],
		'6931': [
			{
				j: '4',
				tr: '03',
				code: '6931',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Botucatu',
			},
		],
		'6933': [
			{
				j: '4',
				tr: '03',
				code: '6933',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Mogi das Cruzes',
			},
		],
		'6934': [
			{
				j: '4',
				tr: '03',
				code: '6934',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Americana',
			},
		],
		'6939': [
			{
				j: '4',
				tr: '03',
				code: '6939',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Itapeva',
			},
		],
		'6940': [
			{
				j: '4',
				tr: '03',
				code: '6940',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Mauá',
			},
		],
		'6941': [
			{
				j: '4',
				tr: '03',
				code: '6941',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Vicente',
			},
		],
		'6943': [
			{
				j: '4',
				tr: '03',
				code: '6943',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Limeira',
			},
		],
		'6944': [
			{
				j: '4',
				tr: '03',
				code: '6944',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Barueri',
			},
		],
		'7000': [
			{
				j: '4',
				tr: '04',
				code: '7000',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Curitiba',
			},
			{
				j: '8',
				tr: '04',
				code: '7000',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'São Paulo de Olivença',
			},
		],
		'7001': [
			{
				j: '4',
				tr: '04',
				code: '7001',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Londrina',
			},
		],
		'7002': [
			{
				j: '4',
				tr: '04',
				code: '7002',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Foz do Iguaçu',
			},
		],
		'7003': [
			{
				j: '4',
				tr: '04',
				code: '7003',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Maringá',
			},
		],
		'7004': [
			{
				j: '4',
				tr: '04',
				code: '7004',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Umuarama',
			},
		],
		'7005': [
			{
				j: '4',
				tr: '04',
				code: '7005',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Cascavel',
			},
		],
		'7006': [
			{
				j: '4',
				tr: '04',
				code: '7006',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Guarapuava',
			},
		],
		'7007': [
			{
				j: '4',
				tr: '04',
				code: '7007',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Francisco Beltrão',
			},
		],
		'7008': [
			{
				j: '4',
				tr: '04',
				code: '7008',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Paranaguá',
			},
		],
		'7009': [
			{
				j: '4',
				tr: '04',
				code: '7009',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Ponta Grossa',
			},
		],
		'7010': [
			{
				j: '4',
				tr: '04',
				code: '7010',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Campo Mourão',
			},
		],
		'7011': [
			{
				j: '4',
				tr: '04',
				code: '7011',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Paranavaí',
			},
		],
		'7012': [
			{
				j: '4',
				tr: '04',
				code: '7012',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Pato Branco',
			},
		],
		'7013': [
			{
				j: '4',
				tr: '04',
				code: '7013',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Jacarezinho',
			},
		],
		'7014': [
			{
				j: '4',
				tr: '04',
				code: '7014',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'União da Vitória',
			},
		],
		'7015': [
			{
				j: '4',
				tr: '04',
				code: '7015',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Apucarana',
			},
		],
		'7016': [
			{
				j: '4',
				tr: '04',
				code: '7016',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Toledo',
			},
		],
		'7017': [
			{
				j: '4',
				tr: '04',
				code: '7017',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Guaíra',
			},
		],
		'7018': [
			{
				j: '4',
				tr: '04',
				code: '7018',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Jacarezinho',
			},
			{
				j: '4',
				tr: '04',
				code: '7018',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Ibaiti - Jacarezinho',
			},
		],
		'7019': [
			{
				j: '4',
				tr: '04',
				code: '7019',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Londrina',
			},
			{
				j: '4',
				tr: '04',
				code: '7019',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Ibaiti',
			},
		],
		'7020': [
			{
				j: '4',
				tr: '04',
				code: '7020',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Ponta Grossa',
			},
			{
				j: '4',
				tr: '04',
				code: '7020',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Ibaiti ',
			},
		],
		'7021': [
			{
				j: '4',
				tr: '04',
				code: '7021',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Guarapuava',
			},
			{
				j: '4',
				tr: '04',
				code: '7021',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Pitanga ',
			},
		],
		'7022': [
			{
				j: '4',
				tr: '04',
				code: '7022',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Campo Mourão',
			},
			{
				j: '4',
				tr: '04',
				code: '7022',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Pitanga',
			},
		],
		'7023': [
			{
				j: '4',
				tr: '04',
				code: '7023',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Apucarana',
			},
			{
				j: '4',
				tr: '04',
				code: '7023',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Pitanga',
			},
		],
		'7024': [
			{
				j: '4',
				tr: '04',
				code: '7024',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Jacarezinho',
			},
			{
				j: '4',
				tr: '04',
				code: '7024',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Wenceslau Braz ',
			},
		],
		'7025': [
			{
				j: '4',
				tr: '04',
				code: '7025',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Ponta Grossa',
			},
			{
				j: '4',
				tr: '04',
				code: '7025',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Wenceslau Braz ',
			},
		],
		'7026': [
			{
				j: '4',
				tr: '04',
				code: '7026',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Astorga',
			},
			{
				j: '4',
				tr: '04',
				code: '7026',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Londrina',
			},
		],
		'7027': [
			{
				j: '4',
				tr: '04',
				code: '7027',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Astorga',
			},
			{
				j: '4',
				tr: '04',
				code: '7027',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Maringá',
			},
		],
		'7028': [
			{
				j: '4',
				tr: '04',
				code: '7028',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Telêmaco Borba',
			},
		],
		'7029': [
			{
				j: '4',
				tr: '04',
				code: '7029',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Telêmaco Borba',
			},
			{
				j: '4',
				tr: '04',
				code: '7029',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Wenceslau Braz ',
			},
		],
		'7030': [
			{
				j: '4',
				tr: '04',
				code: '7030',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Telêmaco Borba',
			},
			{
				j: '4',
				tr: '04',
				code: '7030',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Ibaiti',
			},
		],
		'7031': [
			{
				j: '4',
				tr: '04',
				code: '7031',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Arapongas',
			},
		],
		'7032': [
			{
				j: '4',
				tr: '04',
				code: '7032',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Pitanga',
			},
		],
		'7033': [
			{
				j: '4',
				tr: '04',
				code: '7033',
				courthouse: 'TRF4',
				state: 'PR',
				city: 'Ivaiporã',
			},
		],
		'7100': [
			{
				j: '4',
				tr: '04',
				code: '7100',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Porto Alegre',
			},
			{
				j: '8',
				tr: '04',
				code: '7100',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'São Sebastião do Uatumã',
			},
		],
		'7101': [
			{
				j: '4',
				tr: '04',
				code: '7101',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Rio Grande',
			},
		],
		'7102': [
			{
				j: '4',
				tr: '04',
				code: '7102',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Santa Maria',
			},
		],
		'7103': [
			{
				j: '4',
				tr: '04',
				code: '7103',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Uruguaiana',
			},
		],
		'7104': [
			{
				j: '4',
				tr: '04',
				code: '7104',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Passo Fundo',
			},
		],
		'7105': [
			{
				j: '4',
				tr: '04',
				code: '7105',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Santo Ângelo',
			},
		],
		'7106': [
			{
				j: '4',
				tr: '04',
				code: '7106',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Santana do Livramento',
			},
		],
		'7107': [
			{
				j: '4',
				tr: '04',
				code: '7107',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Caxias do Sul',
			},
		],
		'7108': [
			{
				j: '4',
				tr: '04',
				code: '7108',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Novo Hamburgo',
			},
		],
		'7109': [
			{
				j: '4',
				tr: '04',
				code: '7109',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Bagé',
			},
		],
		'7110': [
			{
				j: '4',
				tr: '04',
				code: '7110',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Pelotas',
			},
		],
		'7111': [
			{
				j: '4',
				tr: '04',
				code: '7111',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Santa Cruz do Sul',
			},
		],
		'7112': [
			{
				j: '4',
				tr: '04',
				code: '7112',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Canoas',
			},
		],
		'7113': [
			{
				j: '4',
				tr: '04',
				code: '7113',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Bento Gonçalves',
			},
		],
		'7114': [
			{
				j: '4',
				tr: '04',
				code: '7114',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Lajeado',
			},
		],
		'7115': [
			{
				j: '4',
				tr: '04',
				code: '7115',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Santa Rosa',
			},
		],
		'7116': [
			{
				j: '4',
				tr: '04',
				code: '7116',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Cruz Alta',
			},
		],
		'7117': [
			{
				j: '4',
				tr: '04',
				code: '7117',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Erechim',
			},
		],
		'7118': [
			{
				j: '4',
				tr: '04',
				code: '7118',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Carazinho',
			},
		],
		'7119': [
			{
				j: '4',
				tr: '04',
				code: '7119',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Cachoeira do Sul',
			},
		],
		'7120': [
			{
				j: '4',
				tr: '04',
				code: '7120',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Santiago',
			},
		],
		'7121': [
			{
				j: '4',
				tr: '04',
				code: '7121',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Capão da Canoa',
			},
		],
		'7122': [
			{
				j: '4',
				tr: '04',
				code: '7122',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Gravataí',
			},
		],
		'7123': [
			{
				j: '4',
				tr: '04',
				code: '7123',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Alegrete',
			},
		],
		'7124': [
			{
				j: '4',
				tr: '04',
				code: '7124',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Montenegro',
			},
		],
		'7125': [
			{
				j: '4',
				tr: '04',
				code: '7125',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Santa Vitória do Palmar',
			},
		],
		'7126': [
			{
				j: '4',
				tr: '04',
				code: '7126',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Jaguarão',
			},
		],
		'7127': [
			{
				j: '4',
				tr: '04',
				code: '7127',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Palmeira das Missões',
			},
		],
		'7128': [
			{
				j: '4',
				tr: '04',
				code: '7128',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Vacaria',
			},
		],
		'7129': [
			{
				j: '4',
				tr: '04',
				code: '7129',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'São Leopoldo',
			},
		],
		'7130': [
			{
				j: '4',
				tr: '04',
				code: '7130',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Frederico Westphalen',
			},
		],
		'7131': [
			{
				j: '4',
				tr: '04',
				code: '7131',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Soledade',
			},
		],
		'7132': [
			{
				j: '4',
				tr: '04',
				code: '7132',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Itaqui',
			},
		],
		'7133': [
			{
				j: '4',
				tr: '04',
				code: '7133',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Ijuí',
			},
		],
		'7134': [
			{
				j: '4',
				tr: '04',
				code: '7134',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'São Borja',
			},
		],
		'7135': [
			{
				j: '4',
				tr: '04',
				code: '7135',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'São Jerônimo',
			},
		],
		'7136': [
			{
				j: '4',
				tr: '04',
				code: '7136',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'São Luiz Gonzaga',
			},
		],
		'7137': [
			{
				j: '4',
				tr: '04',
				code: '7137',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Camaquã',
			},
		],
		'7138': [
			{
				j: '4',
				tr: '04',
				code: '7138',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Gramado',
			},
			{
				j: '4',
				tr: '04',
				code: '7138',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Canela',
			},
			{
				j: '4',
				tr: '04',
				code: '7138',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Caxias',
			},
		],
		'7139': [
			{
				j: '4',
				tr: '04',
				code: '7139',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Torres',
			},
		],
		'7140': [
			{
				j: '4',
				tr: '04',
				code: '7140',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Gramado',
			},
			{
				j: '4',
				tr: '04',
				code: '7140',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Canela',
			},
			{
				j: '4',
				tr: '04',
				code: '7140',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Novo Hamburgo',
			},
		],
		'7141': [
			{
				j: '4',
				tr: '04',
				code: '7141',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Nova Prata',
			},
		],
		'7200': [
			{
				j: '4',
				tr: '04',
				code: '7200',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Florianópolis',
			},
			{
				j: '8',
				tr: '04',
				code: '7200',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Silves',
			},
		],
		'7201': [
			{
				j: '4',
				tr: '04',
				code: '7201',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Joinville',
			},
		],
		'7202': [
			{
				j: '4',
				tr: '04',
				code: '7202',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Chapecó',
			},
		],
		'7203': [
			{
				j: '4',
				tr: '04',
				code: '7203',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Joaçaba',
			},
		],
		'7204': [
			{
				j: '4',
				tr: '04',
				code: '7204',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Criciúma',
			},
		],
		'7205': [
			{
				j: '4',
				tr: '04',
				code: '7205',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Blumenau',
			},
		],
		'7206': [
			{
				j: '4',
				tr: '04',
				code: '7206',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Lages',
			},
		],
		'7207': [
			{
				j: '4',
				tr: '04',
				code: '7207',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Tubarão',
			},
		],
		'7208': [
			{
				j: '4',
				tr: '04',
				code: '7208',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Itajaí',
			},
		],
		'7209': [
			{
				j: '4',
				tr: '04',
				code: '7209',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Jaraguá do Sul',
			},
		],
		'7210': [
			{
				j: '4',
				tr: '04',
				code: '7210',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'São Miguel do Oeste',
			},
		],
		'7211': [
			{
				j: '4',
				tr: '04',
				code: '7211',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Caçador',
			},
		],
		'7212': [
			{
				j: '4',
				tr: '04',
				code: '7212',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Concórdia',
			},
		],
		'7213': [
			{
				j: '4',
				tr: '04',
				code: '7213',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Rio do Sul',
			},
		],
		'7214': [
			{
				j: '4',
				tr: '04',
				code: '7214',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Mafra',
			},
		],
		'7215': [
			{
				j: '4',
				tr: '04',
				code: '7215',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Brusque',
			},
		],
		'7216': [
			{
				j: '4',
				tr: '04',
				code: '7216',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Laguna',
			},
		],
		'7217': [
			{
				j: '4',
				tr: '04',
				code: '7217',
				courthouse: 'TRF4',
				state: 'SC',
				city: 'Araranguá',
			},
		],
		'7218': [
			{
				j: '4',
				tr: '04',
				code: '7218',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'São Francisco do Sul',
			},
		],
		'7219': [
			{
				j: '4',
				tr: '04',
				code: '7219',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Caçador',
			},
			{
				j: '4',
				tr: '04',
				code: '7219',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Videira ',
			},
		],
		'7220': [
			{
				j: '4',
				tr: '04',
				code: '7220',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Tijucas',
			},
		],
		'7221': [
			{
				j: '4',
				tr: '04',
				code: '7221',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Videira ',
			},
			{
				j: '4',
				tr: '04',
				code: '7221',
				courthouse: 'TRF4',
				state: 'RS',
				city: 'Joaçaba',
			},
		],
		'7300': [
			{
				j: '8',
				tr: '04',
				code: '7300',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Tabatinga',
			},
		],
		'7400': [
			{
				j: '8',
				tr: '04',
				code: '7400',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Tapauá',
			},
		],
		'7500': [
			{
				j: '8',
				tr: '04',
				code: '7500',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Tefé',
			},
		],
		'7600': [
			{
				j: '8',
				tr: '04',
				code: '7600',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Urucurituba',
			},
		],
		'7700': [
			{
				j: '8',
				tr: '04',
				code: '7700',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Uarini',
			},
		],
		'7800': [
			{
				j: '8',
				tr: '04',
				code: '7800',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Urucará',
			},
		],
		'8000': [
			{
				j: '4',
				tr: '03',
				code: '8000',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
			{
				j: '4',
				tr: '05',
				code: '8000',
				courthouse: 'TRF5',
				state: 'AL',
				city: 'Maceió',
			},
		],
		'8001': [
			{
				j: '4',
				tr: '03',
				code: '8001',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
			{
				j: '4',
				tr: '05',
				code: '8001',
				courthouse: 'TRF5',
				state: 'AL',
				city: 'Arapiraca',
			},
		],
		'8002': [
			{
				j: '4',
				tr: '03',
				code: '8002',
				courthouse: 'TRF3',
				state: 'MS',
				city: 'Campo Grande ',
			},
			{
				j: '4',
				tr: '05',
				code: '8002',
				courthouse: 'TRF5',
				state: 'AL',
				city: 'União dos Palmares',
			},
		],
		'8003': [
			{
				j: '4',
				tr: '05',
				code: '8003',
				courthouse: 'TRF5',
				state: 'AL',
				city: 'Santana do Ipanema',
			},
		],
		'8100': [
			{
				j: '4',
				tr: '05',
				code: '8100',
				courthouse: 'TRF5',
				state: 'CE',
				city: 'Fortaleza',
			},
		],
		'8101': [
			{
				j: '4',
				tr: '05',
				code: '8101',
				courthouse: 'TRF5',
				state: 'CE',
				city: 'Limoeiro do Norte',
			},
		],
		'8102': [
			{
				j: '4',
				tr: '05',
				code: '8102',
				courthouse: 'TRF5',
				state: 'CE',
				city: 'Juazeiro do Norte',
			},
		],
		'8103': [
			{
				j: '4',
				tr: '05',
				code: '8103',
				courthouse: 'TRF5',
				state: 'CE',
				city: 'Sobral',
			},
		],
		'8104': [
			{
				j: '4',
				tr: '05',
				code: '8104',
				courthouse: 'TRF5',
				state: 'CE',
				city: 'Crateús',
			},
		],
		'8105': [
			{
				j: '4',
				tr: '05',
				code: '8105',
				courthouse: 'TRF5',
				state: 'CE',
				city: 'Quixadá',
			},
		],
		'8106': [
			{
				j: '4',
				tr: '05',
				code: '8106',
				courthouse: 'TRF5',
				state: 'CE',
				city: 'Tauá',
			},
		],
		'8107': [
			{
				j: '4',
				tr: '05',
				code: '8107',
				courthouse: 'TRF5',
				state: 'CE',
				city: 'Iguatu',
			},
		],
		'8108': [
			{
				j: '4',
				tr: '05',
				code: '8108',
				courthouse: 'TRF5',
				state: 'CE',
				city: 'Itapipoca',
			},
		],
		'8109': [
			{
				j: '4',
				tr: '05',
				code: '8109',
				courthouse: 'TRF5',
				state: 'CE',
				city: 'Maracanaú',
			},
		],
		'8200': [
			{
				j: '4',
				tr: '05',
				code: '8200',
				courthouse: 'TRF5',
				state: 'PB',
				city: 'João Pessoa',
			},
		],
		'8201': [
			{
				j: '4',
				tr: '05',
				code: '8201',
				courthouse: 'TRF5',
				state: 'PB',
				city: 'Campina Grande',
			},
		],
		'8202': [
			{
				j: '4',
				tr: '05',
				code: '8202',
				courthouse: 'TRF5',
				state: 'PB',
				city: 'Sousa',
			},
		],
		'8203': [
			{
				j: '4',
				tr: '05',
				code: '8203',
				courthouse: 'TRF5',
				state: 'PB',
				city: 'Monteiro',
			},
		],
		'8204': [
			{
				j: '4',
				tr: '05',
				code: '8204',
				courthouse: 'TRF5',
				state: 'PB',
				city: 'Guarabira',
			},
		],
		'8205': [
			{
				j: '4',
				tr: '05',
				code: '8205',
				courthouse: 'TRF5',
				state: 'PB',
				city: 'Patos',
			},
		],
		'8300': [
			{
				j: '4',
				tr: '05',
				code: '8300',
				courthouse: 'TRF5',
				state: 'PE',
				city: 'Recife',
			},
		],
		'8302': [
			{
				j: '4',
				tr: '05',
				code: '8302',
				courthouse: 'TRF5',
				state: 'PE',
				city: 'Caruaru',
			},
		],
		'8303': [
			{
				j: '4',
				tr: '05',
				code: '8303',
				courthouse: 'TRF5',
				state: 'PE',
				city: 'Serra Talhada',
			},
		],
		'8304': [
			{
				j: '4',
				tr: '05',
				code: '8304',
				courthouse: 'TRF5',
				state: 'PE',
				city: 'Salgueiro',
			},
		],
		'8305': [
			{
				j: '4',
				tr: '05',
				code: '8305',
				courthouse: 'TRF5',
				state: 'PE',
				city: 'Garanhuns',
			},
		],
		'8306': [
			{
				j: '4',
				tr: '05',
				code: '8306',
				courthouse: 'TRF5',
				state: 'PE',
				city: 'Goiana',
			},
		],
		'8307': [
			{
				j: '4',
				tr: '05',
				code: '8307',
				courthouse: 'TRF5',
				state: 'PE',
				city: 'Palmares',
			},
		],
		'8308': [
			{
				j: '4',
				tr: '05',
				code: '8308',
				courthouse: 'TRF5',
				state: 'PE',
				city: 'Petrolina',
			},
		],
		'8309': [
			{
				j: '4',
				tr: '05',
				code: '8309',
				courthouse: 'TRF5',
				state: 'PE',
				city: 'Ouricuri',
			},
		],
		'8310': [
			{
				j: '4',
				tr: '05',
				code: '8310',
				courthouse: 'TRF5',
				state: 'PE',
				city: 'Arcoverde',
			},
		],
		'8311': [
			{
				j: '4',
				tr: '05',
				code: '8311',
				courthouse: 'TRF5',
				state: 'PE',
				city: 'Jaboatão dos Guararapes',
			},
		],
		'8312': [
			{
				j: '4',
				tr: '05',
				code: '8312',
				courthouse: 'TRF5',
				state: 'PE',
				city: 'Cabo de Santo Agostinho',
			},
		],
		'8400': [
			{
				j: '4',
				tr: '05',
				code: '8400',
				courthouse: 'TRF5',
				state: 'RN',
				city: 'Natal',
			},
		],
		'8401': [
			{
				j: '4',
				tr: '05',
				code: '8401',
				courthouse: 'TRF5',
				state: 'RN',
				city: 'Mossoró',
			},
		],
		'8402': [
			{
				j: '4',
				tr: '05',
				code: '8402',
				courthouse: 'TRF5',
				state: 'RN',
				city: 'Caicó',
			},
		],
		'8403': [
			{
				j: '4',
				tr: '05',
				code: '8403',
				courthouse: 'TRF5',
				state: 'RN',
				city: 'Assu',
			},
		],
		'8404': [
			{
				j: '4',
				tr: '05',
				code: '8404',
				courthouse: 'TRF5',
				state: 'RN',
				city: 'Pau dos Ferros',
			},
		],
		'8405': [
			{
				j: '4',
				tr: '05',
				code: '8405',
				courthouse: 'TRF5',
				state: 'RN',
				city: 'Ceará-Mirim',
			},
		],
		'8500': [
			{
				j: '4',
				tr: '05',
				code: '8500',
				courthouse: 'TRF5',
				state: 'SE',
				city: 'Aracaju',
			},
		],
		'8501': [
			{
				j: '4',
				tr: '05',
				code: '8501',
				courthouse: 'TRF5',
				state: 'SE',
				city: 'Itabaiana',
			},
		],
		'8502': [
			{
				j: '4',
				tr: '05',
				code: '8502',
				courthouse: 'TRF5',
				state: 'SE',
				city: 'Estância',
			},
		],
		'8503': [
			{
				j: '4',
				tr: '05',
				code: '8503',
				courthouse: 'TRF5',
				state: 'SE',
				city: 'Lagarto',
			},
		],
		'8504': [
			{
				j: '4',
				tr: '05',
				code: '8504',
				courthouse: 'TRF5',
				state: 'SE',
				city: 'Propriá',
			},
		],
		'9000': [
			{
				j: '8',
				tr: '05',
				code: '9000',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'Salvador',
			},
			{
				j: '8',
				tr: '06',
				code: '9000',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '22',
				code: '9000',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Porto Velho',
			},
			{
				j: '8',
				tr: '27',
				code: '9000',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Palmas',
			},
		],
		'9001': [
			{
				j: '8',
				tr: '10',
				code: '9001',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '15',
				code: '9001',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'João Pessoa',
			},
			{
				j: '8',
				tr: '22',
				code: '9001',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Ji-Paraná',
			},
		],
		'9002': [
			{
				j: '8',
				tr: '10',
				code: '9002',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Imperatriz',
			},
			{
				j: '8',
				tr: '15',
				code: '9002',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'João Pessoa',
			},
		],
		'9003': [
			{
				j: '8',
				tr: '15',
				code: '9003',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'João Pessoa',
			},
		],
		'9004': [
			{
				j: '8',
				tr: '15',
				code: '9004',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Campina Grande',
			},
		],
		'9005': [
			{
				j: '8',
				tr: '15',
				code: '9005',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Campina Grande',
			},
		],
		'9006': [
			{
				j: '8',
				tr: '15',
				code: '9006',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Campina Grande',
			},
		],
		'9007': [
			{
				j: '8',
				tr: '15',
				code: '9007',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Patos',
			},
		],
		'9008': [
			{
				j: '8',
				tr: '15',
				code: '9008',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Sousa',
			},
		],
		'9009': [
			{
				j: '8',
				tr: '15',
				code: '9009',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Guarabira',
			},
		],
		'9010': [
			{
				j: '8',
				tr: '23',
				code: '9010',
				courthouse: 'TJRR',
				state: 'RR',
				city: 'Boa Vista',
			},
		],
		'9300': [
			{
				j: '4',
				tr: '03',
				code: '9300',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
		],
		'9301': [
			{
				j: '4',
				tr: '03',
				code: '9301',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
		],
		'9302': [
			{
				j: '4',
				tr: '03',
				code: '9302',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Ribeirão Preto',
			},
		],
		'9303': [
			{
				j: '4',
				tr: '03',
				code: '9303',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Campinas',
			},
		],
		'9306': [
			{
				j: '4',
				tr: '03',
				code: '9306',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Osasco',
			},
		],
		'9310': [
			{
				j: '4',
				tr: '03',
				code: '9310',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Americana',
			},
		],
		'9601': [
			{
				j: '4',
				tr: '03',
				code: '9601',
				courthouse: 'TRF3',
				state: 'MS',
				city: 'Campo Grande ',
			},
		],
		'9701': [
			{
				j: '4',
				tr: '03',
				code: '9701',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
		],
		'9702': [
			{
				j: '4',
				tr: '03',
				code: '9702',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Ribeirão Preto',
			},
		],
		'9703': [
			{
				j: '4',
				tr: '03',
				code: '9703',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'Campinas',
			},
		],
		'9999': [
			{
				j: '8',
				tr: '01',
				code: '9999',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Rio Branco',
			},
		],
		'0000': [
			{
				j: '4',
				tr: '03',
				code: '0000',
				courthouse: 'TRF3',
				state: 'SP',
				city: 'São Paulo',
			},
			{
				j: '8',
				tr: '22',
				code: '0000',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Rondônia',
			},
			{
				j: '8',
				tr: '23',
				code: '0000',
				courthouse: 'TJRR',
				state: 'RR',
				city: 'Boa Vista',
			},
			{
				j: '8',
				tr: '26',
				code: '0000',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
		'0001': [
			{
				j: '8',
				tr: '01',
				code: '0001',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Rio Branco',
			},
			{
				j: '8',
				tr: '02',
				code: '0001',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Maceió',
			},
			{
				j: '8',
				tr: '03',
				code: '0001',
				courthouse: 'TJAP',
				state: 'AP',
				city: 'Macapá',
			},
			{
				j: '8',
				tr: '04',
				code: '0001',
				courthouse: 'TJAM',
				state: 'AM',
				city: 'Manaus',
			},
			{
				j: '8',
				tr: '05',
				code: '0001',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SALVADOR',
			},
			{
				j: '8',
				tr: '06',
				code: '0001',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0001',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Brasília',
			},
			{
				j: '8',
				tr: '08',
				code: '0001',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Afonso Cláudio',
			},
			{
				j: '8',
				tr: '09',
				code: '0001',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ABADIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0001',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '12',
				code: '0001',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Campo Grande',
			},
			{
				j: '8',
				tr: '14',
				code: '0001',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'BELÉM',
			},
			{
				j: '8',
				tr: '15',
				code: '0001',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Paraíba',
			},
			{
				j: '8',
				tr: '16',
				code: '0001',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'ALTO PARANA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0001',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0001',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Rio de Janeiro',
			},
			{
				j: '8',
				tr: '21',
				code: '0001',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Porto Alegre',
			},
			{
				j: '8',
				tr: '22',
				code: '0001',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Porto Velho',
			},
			{
				j: '8',
				tr: '24',
				code: '0001',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Florianópolis',
			},
			{
				j: '8',
				tr: '25',
				code: '0001',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Aracaju ',
			},
			{
				j: '8',
				tr: '26',
				code: '0001',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0001',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Palmas',
			},
		],
		'0002': [
			{
				j: '8',
				tr: '01',
				code: '0002',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Cruzeiro do Sul',
			},
			{
				j: '8',
				tr: '02',
				code: '0002',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Arapiraca',
			},
			{
				j: '8',
				tr: '03',
				code: '0002',
				courthouse: 'TJAP',
				state: 'AP',
				city: 'Santana',
			},
			{
				j: '8',
				tr: '05',
				code: '0002',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ABARÉ',
			},
			{
				j: '8',
				tr: '06',
				code: '0002',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0002',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Brazlândia',
			},
			{
				j: '8',
				tr: '08',
				code: '0002',
				courthouse: 'TJES',
				state: 'ES',
				city: 'ÁGUA DOCE DO NORTE',
			},
			{
				j: '8',
				tr: '09',
				code: '0002',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ACREUNA',
			},
			{
				j: '8',
				tr: '10',
				code: '0002',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0002',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Várzea Grande',
			},
			{
				j: '8',
				tr: '12',
				code: '0002',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Dourados',
			},
			{
				j: '8',
				tr: '13',
				code: '0002',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Abaeté',
			},
			{
				j: '8',
				tr: '14',
				code: '0002',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'Afuá',
			},
			{
				j: '8',
				tr: '16',
				code: '0002',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'ALTO PIQUIRI ',
			},
			{
				j: '8',
				tr: '18',
				code: '0002',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '21',
				code: '0002',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Alegrete ',
			},
			{
				j: '8',
				tr: '22',
				code: '0002',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Ariquemes',
			},
			{
				j: '8',
				tr: '24',
				code: '0002',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Blumenau',
			},
			{
				j: '8',
				tr: '25',
				code: '0002',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Aracaju ',
			},
			{
				j: '8',
				tr: '26',
				code: '0002',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0002',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Almas',
			},
		],
		'0003': [
			{
				j: '8',
				tr: '01',
				code: '0003',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Brasileia',
			},
			{
				j: '8',
				tr: '02',
				code: '0003',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Penedo',
			},
			{
				j: '8',
				tr: '03',
				code: '0003',
				courthouse: 'TJAP',
				state: 'AP',
				city: 'Mazagão',
			},
			{
				j: '8',
				tr: '05',
				code: '0003',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ACAJUTIBA',
			},
			{
				j: '8',
				tr: '06',
				code: '0003',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0003',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Ceilândia',
			},
			{
				j: '8',
				tr: '08',
				code: '0003',
				courthouse: 'TJES',
				state: 'ES',
				city: 'ÁGUIA BRANCA',
			},
			{
				j: '8',
				tr: '09',
				code: '0003',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ALEXANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0003',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0003',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Rondonópolis',
			},
			{
				j: '8',
				tr: '12',
				code: '0003',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'BELA VISTA ',
			},
			{
				j: '8',
				tr: '13',
				code: '0003',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Abre Campo',
			},
			{
				j: '8',
				tr: '14',
				code: '0003',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'ALENQUER',
			},
			{
				j: '8',
				tr: '16',
				code: '0003',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'ALTÔNIA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0003',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0003',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Angra dos Reis ',
			},
			{
				j: '8',
				tr: '21',
				code: '0003',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Alvorada',
			},
			{
				j: '8',
				tr: '22',
				code: '0003',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Jaru',
			},
			{
				j: '8',
				tr: '24',
				code: '0003',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Criciúma',
			},
			{
				j: '8',
				tr: '25',
				code: '0003',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Aracaju ',
			},
			{
				j: '8',
				tr: '26',
				code: '0003',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0003',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Alvorada',
			},
		],
		'0004': [
			{
				j: '8',
				tr: '01',
				code: '0004',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Epitaciolândia',
			},
			{
				j: '8',
				tr: '02',
				code: '0004',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Palmeira dos Índios',
			},
			{
				j: '8',
				tr: '03',
				code: '0004',
				courthouse: 'TJAP',
				state: 'AP',
				city: 'Amapá',
			},
			{
				j: '8',
				tr: '05',
				code: '0004',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ALAGOINHAS',
			},
			{
				j: '8',
				tr: '06',
				code: '0004',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0004',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Gama',
			},
			{
				j: '8',
				tr: '08',
				code: '0004',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Alegre',
			},
			{
				j: '8',
				tr: '09',
				code: '0004',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ALTO PARAISO DE GOIAS',
			},
			{
				j: '8',
				tr: '10',
				code: '0004',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0004',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Barra do Garças',
			},
			{
				j: '8',
				tr: '12',
				code: '0004',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Amambai',
			},
			{
				j: '8',
				tr: '14',
				code: '0004',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'ALMEIRIM',
			},
			{
				j: '8',
				tr: '16',
				code: '0004',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'ANDIRA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0004',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0004',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'São Gonçalo ',
			},
			{
				j: '8',
				tr: '21',
				code: '0004',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Bagé',
			},
			{
				j: '8',
				tr: '24',
				code: '0004',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Joinville',
			},
			{
				j: '8',
				tr: '25',
				code: '0004',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Aracaju ',
			},
			{
				j: '8',
				tr: '26',
				code: '0004',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0004',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Ananás',
			},
		],
		'0005': [
			{
				j: '8',
				tr: '01',
				code: '0005',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Capixaba',
			},
			{
				j: '8',
				tr: '02',
				code: '0005',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'São Miguel dos Campos',
			},
			{
				j: '8',
				tr: '03',
				code: '0005',
				courthouse: 'TJAP',
				state: 'AP',
				city: 'Tartarugalzinho',
			},
			{
				j: '8',
				tr: '05',
				code: '0005',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ALCOBAÇA',
			},
			{
				j: '8',
				tr: '06',
				code: '0005',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0005',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Planaltina',
			},
			{
				j: '8',
				tr: '08',
				code: '0005',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Alfredo Chaves',
			},
			{
				j: '8',
				tr: '09',
				code: '0005',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ALVORADA DO NORTE',
			},
			{
				j: '8',
				tr: '10',
				code: '0005',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0005',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Diamantino',
			},
			{
				j: '8',
				tr: '12',
				code: '0005',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Aquidauana',
			},
			{
				j: '8',
				tr: '13',
				code: '0005',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Açucena',
			},
			{
				j: '8',
				tr: '14',
				code: '0005',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'ALTAMIRA',
			},
			{
				j: '8',
				tr: '16',
				code: '0005',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'ANTONINA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0005',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0005',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Arraial do Cabo ',
			},
			{
				j: '8',
				tr: '21',
				code: '0005',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Bento Gonçalves',
			},
			{
				j: '8',
				tr: '22',
				code: '0005',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Ji-Paraná',
			},
			{
				j: '8',
				tr: '23',
				code: '0005',
				courthouse: 'TJRR',
				state: 'RR',
				city: 'Alto Alegre',
			},
			{
				j: '8',
				tr: '24',
				code: '0005',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Itajaí',
			},
			{
				j: '8',
				tr: '25',
				code: '0005',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Aracaju ',
			},
			{
				j: '8',
				tr: '26',
				code: '0005',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0005',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Araguacema',
			},
		],
		'0006': [
			{
				j: '8',
				tr: '01',
				code: '0006',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Acrelândia',
			},
			{
				j: '8',
				tr: '02',
				code: '0006',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'União dos Palmares',
			},
			{
				j: '8',
				tr: '03',
				code: '0006',
				courthouse: 'TJAP',
				state: 'AP',
				city: 'Ferreira Gomes',
			},
			{
				j: '8',
				tr: '05',
				code: '0006',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'AMARGOSA',
			},
			{
				j: '8',
				tr: '06',
				code: '0006',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0006',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Sobradinho',
			},
			{
				j: '8',
				tr: '08',
				code: '0006',
				courthouse: 'TJES',
				state: 'ES',
				city: 'ALTO RIO NOVO',
			},
			{
				j: '8',
				tr: '09',
				code: '0006',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ANAPOLIS',
			},
			{
				j: '8',
				tr: '10',
				code: '0006',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0006',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Cáceres',
			},
			{
				j: '8',
				tr: '12',
				code: '0006',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Camapuã',
			},
			{
				j: '8',
				tr: '14',
				code: '0006',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'ANANlNDEUA',
			},
			{
				j: '8',
				tr: '16',
				code: '0006',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'APUCARANA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0006',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0006',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Barra do Pirai ',
			},
			{
				j: '8',
				tr: '21',
				code: '0006',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Cachoeira do Sul',
			},
			{
				j: '8',
				tr: '22',
				code: '0006',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Presidente Médici',
			},
			{
				j: '8',
				tr: '24',
				code: '0006',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Tubarão',
			},
			{
				j: '8',
				tr: '25',
				code: '0006',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Aracaju ',
			},
			{
				j: '8',
				tr: '26',
				code: '0006',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0006',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Araguaçu',
			},
		],
		'0007': [
			{
				j: '8',
				tr: '01',
				code: '0007',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Xapuri',
			},
			{
				j: '8',
				tr: '02',
				code: '0007',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Marechal Deodoro',
			},
			{
				j: '8',
				tr: '03',
				code: '0007',
				courthouse: 'TJAP',
				state: 'AP',
				city: 'Calçoene',
			},
			{
				j: '8',
				tr: '05',
				code: '0007',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'AMÉLIA RODRIGUES',
			},
			{
				j: '8',
				tr: '06',
				code: '0007',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0007',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Taguatinga',
			},
			{
				j: '8',
				tr: '08',
				code: '0007',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Anchieta',
			},
			{
				j: '8',
				tr: '09',
				code: '0007',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ANAPOLIS',
			},
			{
				j: '8',
				tr: '10',
				code: '0007',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0007',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Alta Floresta',
			},
			{
				j: '8',
				tr: '12',
				code: '0007',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Cassilândia',
			},
			{
				j: '8',
				tr: '14',
				code: '0007',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'BAIÃO',
			},
			{
				j: '8',
				tr: '16',
				code: '0007',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'ARAPONGAS ',
			},
			{
				j: '8',
				tr: '18',
				code: '0007',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0007',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Barra Mansa ',
			},
			{
				j: '8',
				tr: '21',
				code: '0007',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Camaquã',
			},
			{
				j: '8',
				tr: '22',
				code: '0007',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Cacoal ',
			},
			{
				j: '8',
				tr: '24',
				code: '0007',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Lages',
			},
			{
				j: '8',
				tr: '25',
				code: '0007',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Aracaju ',
			},
			{
				j: '8',
				tr: '26',
				code: '0007',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0007',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Araguaína',
			},
		],
		'0008': [
			{
				j: '8',
				tr: '01',
				code: '0008',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Plácido de Castro',
			},
			{
				j: '8',
				tr: '02',
				code: '0008',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Delmiro Gouveia',
			},
			{
				j: '8',
				tr: '03',
				code: '0008',
				courthouse: 'TJAP',
				state: 'AP',
				city: 'Laranjal do Jari',
			},
			{
				j: '8',
				tr: '05',
				code: '0008',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'AMÉRICA DOURADA',
			},
			{
				j: '8',
				tr: '06',
				code: '0008',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0008',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Paranoá',
			},
			{
				j: '8',
				tr: '08',
				code: '0008',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Apiacá',
			},
			{
				j: '8',
				tr: '09',
				code: '0008',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ANAPOLIS',
			},
			{
				j: '8',
				tr: '10',
				code: '0008',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0008',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Barra do Bugres',
			},
			{
				j: '8',
				tr: '12',
				code: '0008',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Corumbá',
			},
			{
				j: '8',
				tr: '14',
				code: '0008',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'BARCARENA',
			},
			{
				j: '8',
				tr: '16',
				code: '0008',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'ARAPOTI ',
			},
			{
				j: '8',
				tr: '18',
				code: '0008',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0008',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Belford Roxo ',
			},
			{
				j: '8',
				tr: '21',
				code: '0008',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Canoas',
			},
			{
				j: '8',
				tr: '22',
				code: '0008',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Espigão do Oeste',
			},
			{
				j: '8',
				tr: '24',
				code: '0008',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Concórdia',
			},
			{
				j: '8',
				tr: '25',
				code: '0008',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Aracaju ',
			},
			{
				j: '8',
				tr: '26',
				code: '0008',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0008',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Araguatins',
			},
		],
		'0009': [
			{
				j: '8',
				tr: '01',
				code: '0009',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Senador Guiomard',
			},
			{
				j: '8',
				tr: '02',
				code: '0009',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Coruripe',
			},
			{
				j: '8',
				tr: '03',
				code: '0009',
				courthouse: 'TJAP',
				state: 'AP',
				city: 'Oiapoque',
			},
			{
				j: '8',
				tr: '05',
				code: '0009',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ANAGÉ',
			},
			{
				j: '8',
				tr: '06',
				code: '0009',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0009',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Samambaia',
			},
			{
				j: '8',
				tr: '08',
				code: '0009',
				courthouse: 'TJES',
				state: 'ES',
				city: 'ARACRUZ',
			},
			{
				j: '8',
				tr: '09',
				code: '0009',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ANAPOLIS',
			},
			{
				j: '8',
				tr: '10',
				code: '0009',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0009',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Colíder',
			},
			{
				j: '8',
				tr: '12',
				code: '0009',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Costa Rica',
			},
			{
				j: '8',
				tr: '13',
				code: '0009',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Águas Formosas',
			},
			{
				j: '8',
				tr: '14',
				code: '0009',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'BRAGANÇA',
			},
			{
				j: '8',
				tr: '16',
				code: '0009',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'ASSAI ',
			},
			{
				j: '8',
				tr: '18',
				code: '0009',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0009',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Bom Jardim ',
			},
			{
				j: '8',
				tr: '21',
				code: '0009',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Carazinho',
			},
			{
				j: '8',
				tr: '22',
				code: '0009',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Pimenta Bueno',
			},
			{
				j: '8',
				tr: '24',
				code: '0009',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Chapecó',
			},
			{
				j: '8',
				tr: '25',
				code: '0009',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Aracaju ',
			},
			{
				j: '8',
				tr: '26',
				code: '0009',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0009',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Arapoema',
			},
		],
		'0010': [
			{
				j: '8',
				tr: '01',
				code: '0010',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Bujari',
			},
			{
				j: '8',
				tr: '02',
				code: '0010',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Santana do Ipanema',
			},
			{
				j: '8',
				tr: '03',
				code: '0010',
				courthouse: 'TJAP',
				state: 'AP',
				city: 'Serra do Navio',
			},
			{
				j: '8',
				tr: '05',
				code: '0010',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ANDARAÍ',
			},
			{
				j: '8',
				tr: '06',
				code: '0010',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0010',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Santa Maria',
			},
			{
				j: '8',
				tr: '08',
				code: '0010',
				courthouse: 'TJES',
				state: 'ES',
				city: 'ATILIO VIVACQUA',
			},
			{
				j: '8',
				tr: '09',
				code: '0010',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ANICUNS',
			},
			{
				j: '8',
				tr: '10',
				code: '0010',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0010',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Jaciara',
			},
			{
				j: '8',
				tr: '12',
				code: '0010',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Fátima do Sul',
			},
			{
				j: '8',
				tr: '14',
				code: '0010',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'BREVES',
			},
			{
				j: '8',
				tr: '16',
				code: '0010',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'ASSIS CHATEAUBRIAND ',
			},
			{
				j: '8',
				tr: '18',
				code: '0010',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0010',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Bom Jesus de ltabapoana ',
			},
			{
				j: '8',
				tr: '20',
				code: '0010',
				courthouse: 'TJRN',
				state: 'RN',
				city: 'Natal',
			},
			{
				j: '8',
				tr: '21',
				code: '0010',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Caxias do Sul',
			},
			{
				j: '8',
				tr: '22',
				code: '0010',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Rolim de Moura',
			},
			{
				j: '8',
				tr: '23',
				code: '0010',
				courthouse: 'TJRR',
				state: 'RR',
				city: 'Boa Vista',
			},
			{
				j: '8',
				tr: '24',
				code: '0010',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Brusque',
			},
			{
				j: '8',
				tr: '25',
				code: '0010',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Aracaju ',
			},
			{
				j: '8',
				tr: '26',
				code: '0010',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0010',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Arraias',
			},
		],
		'0011': [
			{
				j: '8',
				tr: '01',
				code: '0011',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Sena Madureira',
			},
			{
				j: '8',
				tr: '02',
				code: '0011',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Rio Largo',
			},
			{
				j: '8',
				tr: '03',
				code: '0011',
				courthouse: 'TJAP',
				state: 'AP',
				city: 'Porto Grande',
			},
			{
				j: '8',
				tr: '05',
				code: '0011',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ANGICAL',
			},
			{
				j: '8',
				tr: '06',
				code: '0011',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0011',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Núcleo Bandeirante',
			},
			{
				j: '8',
				tr: '08',
				code: '0011',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Baixo Guandu',
			},
			{
				j: '8',
				tr: '09',
				code: '0011',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'APARECIDA DE GOIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0011',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0011',
				courthouse: 'TJMT',
				state: 'MT',
				city: "Mirassol D'Oeste",
			},
			{
				j: '8',
				tr: '12',
				code: '0011',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Coxim',
			},
			{
				j: '8',
				tr: '13',
				code: '0011',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Aimorés',
			},
			{
				j: '8',
				tr: '14',
				code: '0011',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'CACHOEIRA DO ARARI',
			},
			{
				j: '8',
				tr: '15',
				code: '0011',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Campina Grande',
			},
			{
				j: '8',
				tr: '16',
				code: '0011',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'ASTORGA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0011',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0011',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Cabo Frio ',
			},
			{
				j: '8',
				tr: '21',
				code: '0011',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Cruz Alta',
			},
			{
				j: '8',
				tr: '22',
				code: '0011',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Alvorada do Oeste',
			},
			{
				j: '8',
				tr: '24',
				code: '0011',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Rio do Sul',
			},
			{
				j: '8',
				tr: '26',
				code: '0011',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0011',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Augustinópolis',
			},
		],
		'0012': [
			{
				j: '8',
				tr: '01',
				code: '0012',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Manuel Urbano',
			},
			{
				j: '8',
				tr: '02',
				code: '0012',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Pão de Açúcar',
			},
			{
				j: '8',
				tr: '03',
				code: '0012',
				courthouse: 'TJAP',
				state: 'AP',
				city: 'Vitória do Jari',
			},
			{
				j: '8',
				tr: '05',
				code: '0012',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ANTAS',
			},
			{
				j: '8',
				tr: '06',
				code: '0012',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0012',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'São Sebastião',
			},
			{
				j: '8',
				tr: '08',
				code: '0012',
				courthouse: 'TJES',
				state: 'ES',
				city: 'BARRA DE SÃO FRANCISCO',
			},
			{
				j: '8',
				tr: '09',
				code: '0012',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'APARECIDA DE GOIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0012',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0012',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Nova Xavantina',
			},
			{
				j: '8',
				tr: '12',
				code: '0012',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Ivinhema',
			},
			{
				j: '8',
				tr: '13',
				code: '0012',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Aiuruoca',
			},
			{
				j: '8',
				tr: '14',
				code: '0012',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'CAMETA',
			},
			{
				j: '8',
				tr: '16',
				code: '0012',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'BANDEIRANTES ',
			},
			{
				j: '8',
				tr: '18',
				code: '0012',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0012',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Cachoeiras de Macacu  ',
			},
			{
				j: '8',
				tr: '21',
				code: '0012',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Dom Pedrito',
			},
			{
				j: '8',
				tr: '22',
				code: '0012',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Colorado do Oeste',
			},
			{
				j: '8',
				tr: '24',
				code: '0012',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Joaçaba',
			},
			{
				j: '8',
				tr: '26',
				code: '0012',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0012',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Aurora do Tocantins',
			},
		],
		'0013': [
			{
				j: '8',
				tr: '01',
				code: '0013',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Feijó',
			},
			{
				j: '8',
				tr: '02',
				code: '0013',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Pilar',
			},
			{
				j: '8',
				tr: '05',
				code: '0013',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'APORÁ',
			},
			{
				j: '8',
				tr: '06',
				code: '0013',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0013',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Brasília',
			},
			{
				j: '8',
				tr: '08',
				code: '0013',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Boa Esperança',
			},
			{
				j: '8',
				tr: '09',
				code: '0013',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ARACU',
			},
			{
				j: '8',
				tr: '10',
				code: '0013',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0013',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Pontes e Lacerda',
			},
			{
				j: '8',
				tr: '12',
				code: '0013',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Jardim',
			},
			{
				j: '8',
				tr: '14',
				code: '0013',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'CAPANEMA',
			},
			{
				j: '8',
				tr: '16',
				code: '0013',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'BARBOSA FERRAZ ',
			},
			{
				j: '8',
				tr: '18',
				code: '0013',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0013',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Cambuci',
			},
			{
				j: '8',
				tr: '21',
				code: '0013',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Erechim',
			},
			{
				j: '8',
				tr: '22',
				code: '0013',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Cerejeitas',
			},
			{
				j: '8',
				tr: '24',
				code: '0013',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Caçador',
			},
			{
				j: '8',
				tr: '26',
				code: '0013',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0013',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Axixá do Tocantins',
			},
		],
		'0014': [
			{
				j: '8',
				tr: '01',
				code: '0014',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Tarauacá',
			},
			{
				j: '8',
				tr: '02',
				code: '0014',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Atalaia',
			},
			{
				j: '8',
				tr: '05',
				code: '0014',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ARACI',
			},
			{
				j: '8',
				tr: '06',
				code: '0014',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0014',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Guará',
			},
			{
				j: '8',
				tr: '08',
				code: '0014',
				courthouse: 'TJES',
				state: 'ES',
				city: 'BOM JESUS DO NORTE',
			},
			{
				j: '8',
				tr: '09',
				code: '0014',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ARAGARCAS',
			},
			{
				j: '8',
				tr: '10',
				code: '0014',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0014',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Poxoréu',
			},
			{
				j: '8',
				tr: '12',
				code: '0014',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Maracajú',
			},
			{
				j: '8',
				tr: '14',
				code: '0014',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'CAPITÃO POÇO',
			},
			{
				j: '8',
				tr: '16',
				code: '0014',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'BARRACAO ',
			},
			{
				j: '8',
				tr: '18',
				code: '0014',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0014',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Campos dos Goytacazes ',
			},
			{
				j: '8',
				tr: '21',
				code: '0014',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Esteio',
			},
			{
				j: '8',
				tr: '22',
				code: '0014',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Vilhena',
			},
			{
				j: '8',
				tr: '24',
				code: '0014',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Florianópolis',
			},
			{
				j: '8',
				tr: '26',
				code: '0014',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0014',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Colinas do Tocantins',
			},
		],
		'0015': [
			{
				j: '8',
				tr: '01',
				code: '0015',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Mâncio Lima',
			},
			{
				j: '8',
				tr: '02',
				code: '0015',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Murici',
			},
			{
				j: '8',
				tr: '05',
				code: '0015',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'AURELINO LEAL',
			},
			{
				j: '8',
				tr: '06',
				code: '0015',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0015',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Brasília',
			},
			{
				j: '8',
				tr: '08',
				code: '0015',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Cachoeiro do Itapemirim',
			},
			{
				j: '8',
				tr: '09',
				code: '0015',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'AURILANDIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0015',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0015',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Sinop',
			},
			{
				j: '8',
				tr: '12',
				code: '0015',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Miranda',
			},
			{
				j: '8',
				tr: '13',
				code: '0015',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Além Paraíba',
			},
			{
				j: '8',
				tr: '14',
				code: '0015',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'CASTANHAL',
			},
			{
				j: '8',
				tr: '16',
				code: '0015',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'BELA VISTA DO PARAISO ',
			},
			{
				j: '8',
				tr: '18',
				code: '0015',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0015',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Cantagalo',
			},
			{
				j: '8',
				tr: '21',
				code: '0015',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Gravataí',
			},
			{
				j: '8',
				tr: '22',
				code: '0015',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Guajará-Mirim',
			},
			{
				j: '8',
				tr: '24',
				code: '0015',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'São Miguel do Oeste',
			},
			{
				j: '8',
				tr: '26',
				code: '0015',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0015',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Colméia',
			},
		],
		'0016': [
			{
				j: '8',
				tr: '01',
				code: '0016',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Assis Brasil',
			},
			{
				j: '8',
				tr: '02',
				code: '0016',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Porto Calvo',
			},
			{
				j: '8',
				tr: '05',
				code: '0016',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BAIANÓPOLIS',
			},
			{
				j: '8',
				tr: '06',
				code: '0016',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0016',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Brasília',
			},
			{
				j: '8',
				tr: '08',
				code: '0016',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Cariacica',
			},
			{
				j: '8',
				tr: '09',
				code: '0016',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'BARRO ALTO',
			},
			{
				j: '8',
				tr: '10',
				code: '0016',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '12',
				code: '0016',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Mundo Novo',
			},
			{
				j: '8',
				tr: '13',
				code: '0016',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Alfenas',
			},
			{
				j: '8',
				tr: '14',
				code: '0016',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'CHAVES',
			},
			{
				j: '8',
				tr: '16',
				code: '0016',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'BOCAIUVA DO SUL ',
			},
			{
				j: '8',
				tr: '18',
				code: '0016',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0016',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Carmo',
			},
			{
				j: '8',
				tr: '21',
				code: '0016',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Ijuí',
			},
			{
				j: '8',
				tr: '22',
				code: '0016',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Costa Marques',
			},
			{
				j: '8',
				tr: '24',
				code: '0016',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Joinville',
			},
			{
				j: '8',
				tr: '26',
				code: '0016',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0016',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Cristalândia',
			},
		],
		'0017': [
			{
				j: '8',
				tr: '01',
				code: '0017',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Rodrigues Alves',
			},
			{
				j: '8',
				tr: '02',
				code: '0017',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Maragogi',
			},
			{
				j: '8',
				tr: '05',
				code: '0017',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BAIXA GRANDE',
			},
			{
				j: '8',
				tr: '06',
				code: '0017',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '07',
				code: '0017',
				courthouse: 'TJDFT',
				state: 'DF',
				city: 'Riacho Fundo',
			},
			{
				j: '8',
				tr: '08',
				code: '0017',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Castelo',
			},
			{
				j: '8',
				tr: '09',
				code: '0017',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'BELA VISTA DE GOIAS',
			},
			{
				j: '8',
				tr: '10',
				code: '0017',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0017',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'São Félix do Araguaia',
			},
			{
				j: '8',
				tr: '12',
				code: '0017',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Nova Andradina',
			},
			{
				j: '8',
				tr: '13',
				code: '0017',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Almenara',
			},
			{
				j: '8',
				tr: '14',
				code: '0017',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'CONCEIÇÃO DO ARAGUAIA',
			},
			{
				j: '8',
				tr: '16',
				code: '0017',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CAMBARA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0017',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0017',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Casimiro de Abreu ',
			},
			{
				j: '8',
				tr: '21',
				code: '0017',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Lajeado ',
			},
			{
				j: '8',
				tr: '22',
				code: '0017',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Alta Floresta Do Oeste',
			},
			{
				j: '8',
				tr: '24',
				code: '0017',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Mafra',
			},
			{
				j: '8',
				tr: '26',
				code: '0017',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0017',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Dianópolis',
			},
		],
		'0018': [
			{
				j: '8',
				tr: '01',
				code: '0018',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Santa Rosa',
			},
			{
				j: '8',
				tr: '02',
				code: '0018',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'São Luiz do Quitunde',
			},
			{
				j: '8',
				tr: '05',
				code: '0018',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BARRA',
			},
			{
				j: '8',
				tr: '06',
				code: '0018',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '08',
				code: '0018',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Cariacica',
			},
			{
				j: '8',
				tr: '09',
				code: '0018',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'BOM JESUS',
			},
			{
				j: '8',
				tr: '10',
				code: '0018',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0018',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Juara',
			},
			{
				j: '8',
				tr: '12',
				code: '0018',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Paranaíba',
			},
			{
				j: '8',
				tr: '14',
				code: '0018',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'CURIONÓPOLIS',
			},
			{
				j: '8',
				tr: '16',
				code: '0018',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CAMBE ',
			},
			{
				j: '8',
				tr: '18',
				code: '0018',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0018',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Conceição de Macabu',
			},
			{
				j: '8',
				tr: '21',
				code: '0018',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Montenegro',
			},
			{
				j: '8',
				tr: '22',
				code: '0018',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Santa Luzia do Oeste',
			},
			{
				j: '8',
				tr: '24',
				code: '0018',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Blumenau',
			},
			{
				j: '8',
				tr: '26',
				code: '0018',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0018',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Figueirópolis',
			},
		],
		'0019': [
			{
				j: '8',
				tr: '01',
				code: '0019',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Jordão',
			},
			{
				j: '8',
				tr: '02',
				code: '0019',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'São José da Lage',
			},
			{
				j: '8',
				tr: '05',
				code: '0019',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BARRA DA ESTIVA',
			},
			{
				j: '8',
				tr: '06',
				code: '0019',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '08',
				code: '0019',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Colatina',
			},
			{
				j: '8',
				tr: '09',
				code: '0019',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'BURITI ALEGRE',
			},
			{
				j: '8',
				tr: '10',
				code: '0019',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0019',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Porto dos Gaúchos',
			},
			{
				j: '8',
				tr: '12',
				code: '0019',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Ponta Porã',
			},
			{
				j: '8',
				tr: '13',
				code: '0019',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Alpinópolis',
			},
			{
				j: '8',
				tr: '14',
				code: '0019',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'CURUÇA',
			},
			{
				j: '8',
				tr: '16',
				code: '0019',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CAMPINA DA LAGOA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0019',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0019',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Cordeiro ',
			},
			{
				j: '8',
				tr: '22',
				code: '0019',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Machadinho do Oeste',
			},
			{
				j: '8',
				tr: '24',
				code: '0019',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Jaraguá do Sul',
			},
			{
				j: '8',
				tr: '26',
				code: '0019',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Americana ',
			},
			{
				j: '8',
				tr: '27',
				code: '0019',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Filadélfia',
			},
		],
		'0020': [
			{
				j: '8',
				tr: '01',
				code: '0020',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Porto Walter',
			},
			{
				j: '8',
				tr: '02',
				code: '0020',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Viçosa',
			},
			{
				j: '8',
				tr: '05',
				code: '0020',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BARRA DO CHOÇA',
			},
			{
				j: '8',
				tr: '06',
				code: '0020',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '08',
				code: '0020',
				courthouse: 'TJES',
				state: 'ES',
				city: 'CONCEIÇÃO DA BARRA',
			},
			{
				j: '8',
				tr: '09',
				code: '0020',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CACHOEIRA ALTA',
			},
			{
				j: '8',
				tr: '10',
				code: '0020',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0020',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Alto Araguaia',
			},
			{
				j: '8',
				tr: '12',
				code: '0020',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Rio Brilhante',
			},
			{
				j: '8',
				tr: '14',
				code: '0020',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'GURUPÁ',
			},
			{
				j: '8',
				tr: '16',
				code: '0020',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CAMPO MOURAO ',
			},
			{
				j: '8',
				tr: '18',
				code: '0020',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0020',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Duas Barras ',
			},
			{
				j: '8',
				tr: '21',
				code: '0020',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Palmeira das Missões',
			},
			{
				j: '8',
				tr: '22',
				code: '0020',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Nova Brasilândia do Oeste',
			},
			{
				j: '8',
				tr: '23',
				code: '0020',
				courthouse: 'TJRR',
				state: 'RR',
				city: 'Caracaraí',
			},
			{
				j: '8',
				tr: '24',
				code: '0020',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Videira',
			},
			{
				j: '8',
				tr: '25',
				code: '0020',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Nossa Senhora do Socorro',
			},
			{
				j: '8',
				tr: '26',
				code: '0020',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0020',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Formoso do Araguaia',
			},
		],
		'0021': [
			{
				j: '8',
				tr: '01',
				code: '0021',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Marechal Thaumaturgo',
			},
			{
				j: '8',
				tr: '02',
				code: '0021',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Capela',
			},
			{
				j: '8',
				tr: '05',
				code: '0021',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BARRA DO MENDES',
			},
			{
				j: '8',
				tr: '06',
				code: '0021',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '08',
				code: '0021',
				courthouse: 'TJES',
				state: 'ES',
				city: 'CONCEIÇÃO DO CASTELO',
			},
			{
				j: '8',
				tr: '09',
				code: '0021',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CACU',
			},
			{
				j: '8',
				tr: '10',
				code: '0021',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '11',
				code: '0021',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Água Boa',
			},
			{
				j: '8',
				tr: '12',
				code: '0021',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Três Lagoas',
			},
			{
				j: '8',
				tr: '13',
				code: '0021',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Alto Rio Doce',
			},
			{
				j: '8',
				tr: '14',
				code: '0021',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'Igarapé-Açu',
			},
			{
				j: '8',
				tr: '15',
				code: '0021',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Caaporã',
			},
			{
				j: '8',
				tr: '16',
				code: '0021',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CANDIDO DE ABREU ',
			},
			{
				j: '8',
				tr: '18',
				code: '0021',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0021',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Duque de Caxias ',
			},
			{
				j: '8',
				tr: '21',
				code: '0021',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Passo Fundo',
			},
			{
				j: '8',
				tr: '22',
				code: '0021',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Buritis ',
			},
			{
				j: '8',
				tr: '24',
				code: '0021',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Canoinhas',
			},
			{
				j: '8',
				tr: '25',
				code: '0021',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Nossa Senhora do Socorro',
			},
			{
				j: '8',
				tr: '26',
				code: '0021',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
			{
				j: '8',
				tr: '26',
				code: '0021',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Amparo ',
			},
			{
				j: '8',
				tr: '27',
				code: '0021',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Goiatins',
			},
		],
		'0022': [
			{
				j: '8',
				tr: '01',
				code: '0022',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Porto Acre',
			},
			{
				j: '8',
				tr: '02',
				code: '0022',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Boca da Mata',
			},
			{
				j: '8',
				tr: '05',
				code: '0022',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BARREIRAS',
			},
			{
				j: '8',
				tr: '06',
				code: '0022',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '08',
				code: '0022',
				courthouse: 'TJES',
				state: 'ES',
				city: 'DOMINGOS MARTINS',
			},
			{
				j: '8',
				tr: '09',
				code: '0022',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CACU',
			},
			{
				j: '8',
				tr: '10',
				code: '0022',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Açailândia',
			},
			{
				j: '8',
				tr: '11',
				code: '0022',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Pedra Preta',
			},
			{
				j: '8',
				tr: '12',
				code: '0022',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Anaurilândia',
			},
			{
				j: '8',
				tr: '14',
				code: '0022',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'Igarapé-Miri',
			},
			{
				j: '8',
				tr: '16',
				code: '0022',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CANTAGALO',
			},
			{
				j: '8',
				tr: '18',
				code: '0022',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0022',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Engenheiro Paulo de Frontin',
			},
			{
				j: '8',
				tr: '21',
				code: '0022',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Pelotas',
			},
			{
				j: '8',
				tr: '22',
				code: '0022',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'São Miguel do Guaraporé',
			},
			{
				j: '8',
				tr: '24',
				code: '0022',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Itajaí',
			},
			{
				j: '8',
				tr: '25',
				code: '0022',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Nossa Senhora do Socorro',
			},
			{
				j: '8',
				tr: '27',
				code: '0022',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Guaraí',
			},
		],
		'0070': [
			{
				j: '8',
				tr: '01',
				code: '0070',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Rio Branco',
			},
			{
				j: '8',
				tr: '05',
				code: '0070',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'COTEGIPE',
			},
			{
				j: '8',
				tr: '08',
				code: '0070',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Vitória',
			},
			{
				j: '8',
				tr: '09',
				code: '0070',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GUAPO',
			},
			{
				j: '8',
				tr: '10',
				code: '0070',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Arari',
			},
			{
				j: '8',
				tr: '14',
				code: '0070',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'Abaetetuba',
			},
			{
				j: '8',
				tr: '16',
				code: '0070',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'IRATI ',
			},
			{
				j: '8',
				tr: '18',
				code: '0070',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'São João do Piauí',
			},
			{
				j: '8',
				tr: '19',
				code: '0070',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'São Francisco do ltabapoana',
			},
			{
				j: '8',
				tr: '21',
				code: '0070',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Taquara',
			},
			{
				j: '8',
				tr: '26',
				code: '0070',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Batatais ',
			},
		],
		'0081': [
			{
				j: '8',
				tr: '01',
				code: '0081',
				courthouse: 'TJAC',
				state: 'AC',
				city: 'Rio Branco',
			},
			{
				j: '8',
				tr: '05',
				code: '0081',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'FORMOSA DO RIO PRETO',
			},
			{
				j: '8',
				tr: '06',
				code: '0081',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Granja',
			},
			{
				j: '8',
				tr: '08',
				code: '0081',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Serra',
			},
			{
				j: '8',
				tr: '09',
				code: '0081',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ITAGUARU',
			},
			{
				j: '8',
				tr: '10',
				code: '0081',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Carolina',
			},
			{
				j: '8',
				tr: '12',
				code: '0081',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Campo Grande',
			},
			{
				j: '8',
				tr: '13',
				code: '0081',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Bonfim',
			},
			{
				j: '8',
				tr: '14',
				code: '0081',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'BUJARU',
			},
			{
				j: '8',
				tr: '15',
				code: '0081',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Bananeiras',
			},
			{
				j: '8',
				tr: '16',
				code: '0081',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'LONDRINA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0081',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Antônio Almeida',
			},
			{
				j: '8',
				tr: '19',
				code: '0081',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Itatiaia ',
			},
			{
				j: '8',
				tr: '21',
				code: '0081',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Arroio Grande ',
			},
			{
				j: '8',
				tr: '26',
				code: '0081',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Adamantina ',
			},
		],
		'0023': [
			{
				j: '8',
				tr: '02',
				code: '0023',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'São Sebastião',
			},
			{
				j: '8',
				tr: '05',
				code: '0023',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BELMONTE',
			},
			{
				j: '8',
				tr: '06',
				code: '0023',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '08',
				code: '0023',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Dores do Rio Preto',
			},
			{
				j: '8',
				tr: '09',
				code: '0023',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CAIAPONIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0023',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Açailândia',
			},
			{
				j: '8',
				tr: '11',
				code: '0023',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Peixoto de Azevedo',
			},
			{
				j: '8',
				tr: '12',
				code: '0023',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Angélica',
			},
			{
				j: '8',
				tr: '13',
				code: '0023',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Alvinópolis',
			},
			{
				j: '8',
				tr: '14',
				code: '0023',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'IRITUIA',
			},
			{
				j: '8',
				tr: '16',
				code: '0023',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CAPANEMA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0023',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0023',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'ltaboraí ',
			},
			{
				j: '8',
				tr: '21',
				code: '0023',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Rio Grande',
			},
			{
				j: '8',
				tr: '24',
				code: '0023',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Araranguá',
			},
			{
				j: '8',
				tr: '27',
				code: '0023',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Gurupi',
			},
		],
		'0024': [
			{
				j: '8',
				tr: '02',
				code: '0024',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Teotônio Vilela',
			},
			{
				j: '8',
				tr: '05',
				code: '0024',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BELO CAMPO',
			},
			{
				j: '8',
				tr: '06',
				code: '0024',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '08',
				code: '0024',
				courthouse: 'TJES',
				state: 'ES',
				city: 'ECOPORANGA',
			},
			{
				j: '8',
				tr: '09',
				code: '0024',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CALDAS NOVAS',
			},
			{
				j: '8',
				tr: '10',
				code: '0024',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Bacabal',
			},
			{
				j: '8',
				tr: '11',
				code: '0024',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Chapada dos Guimarães',
			},
			{
				j: '8',
				tr: '12',
				code: '0024',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Aparecida do Taboado',
			},
			{
				j: '8',
				tr: '13',
				code: '0024',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Belo Horizonte',
			},
			{
				j: '8',
				tr: '14',
				code: '0024',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'ITAITUBA',
			},
			{
				j: '8',
				tr: '16',
				code: '0024',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CAPITAO LEÕNIDAS MARQUES ',
			},
			{
				j: '8',
				tr: '18',
				code: '0024',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '21',
				code: '0024',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Rio Pardo',
			},
			{
				j: '8',
				tr: '24',
				code: '0024',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'São Bento do Sul',
			},
			{
				j: '8',
				tr: '26',
				code: '0024',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Andradina ',
			},
			{
				j: '8',
				tr: '27',
				code: '0024',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Itacajá',
			},
		],
		'0025': [
			{
				j: '8',
				tr: '02',
				code: '0025',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Girau do Ponciano',
			},
			{
				j: '8',
				tr: '05',
				code: '0025',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BOA NOVA',
			},
			{
				j: '8',
				tr: '06',
				code: '0025',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '08',
				code: '0025',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Fundão',
			},
			{
				j: '8',
				tr: '09',
				code: '0025',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CALDAS NOVAS',
			},
			{
				j: '8',
				tr: '10',
				code: '0025',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Bacabal',
			},
			{
				j: '8',
				tr: '11',
				code: '0025',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Juína',
			},
			{
				j: '8',
				tr: '12',
				code: '0025',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Bandeirantes',
			},
			{
				j: '8',
				tr: '14',
				code: '0025',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'ITUPIRANGA',
			},
			{
				j: '8',
				tr: '16',
				code: '0025',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CARLOPOLIS ',
			},
			{
				j: '8',
				tr: '18',
				code: '0025',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Teresina',
			},
			{
				j: '8',
				tr: '19',
				code: '0025',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'ltaocara ',
			},
			{
				j: '8',
				tr: '21',
				code: '0025',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Santana do Livramento',
			},
			{
				j: '8',
				tr: '24',
				code: '0025',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Xanxerê',
			},
			{
				j: '8',
				tr: '26',
				code: '0025',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Angatuba ',
			},
			{
				j: '8',
				tr: '27',
				code: '0025',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Itaguatins',
			},
		],
		'0026': [
			{
				j: '8',
				tr: '02',
				code: '0026',
				courthouse: 'TJAL',
				state: 'AL',
				city: "Olho D'água das Flores",
			},
			{
				j: '8',
				tr: '05',
				code: '0026',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BOA VISTA DO TUPIM',
			},
			{
				j: '8',
				tr: '06',
				code: '0026',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortaleza',
			},
			{
				j: '8',
				tr: '08',
				code: '0026',
				courthouse: 'TJES',
				state: 'ES',
				city: 'GUAÇUI',
			},
			{
				j: '8',
				tr: '09',
				code: '0026',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CAMPOS BELOS',
			},
			{
				j: '8',
				tr: '10',
				code: '0026',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Balsas',
			},
			{
				j: '8',
				tr: '11',
				code: '0026',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Arenápolis',
			},
			{
				j: '8',
				tr: '12',
				code: '0026',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Bataguassu',
			},
			{
				j: '8',
				tr: '13',
				code: '0026',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Andradas',
			},
			{
				j: '8',
				tr: '14',
				code: '0026',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'JACUNDA',
			},
			{
				j: '8',
				tr: '16',
				code: '0026',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CASCAVEL ',
			},
			{
				j: '8',
				tr: '18',
				code: '0026',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Campo Maior',
			},
			{
				j: '8',
				tr: '19',
				code: '0026',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'ltaperuna ',
			},
			{
				j: '8',
				tr: '21',
				code: '0026',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Santa Cruz do Sul',
			},
			{
				j: '8',
				tr: '24',
				code: '0026',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Florianópolis',
			},
			{
				j: '8',
				tr: '27',
				code: '0026',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Miracema do Tocantins',
			},
		],
		'0027': [
			{
				j: '8',
				tr: '02',
				code: '0027',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Santa Luzia do Norte',
			},
			{
				j: '8',
				tr: '05',
				code: '0027',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BOM JESUS DA LAPA',
			},
			{
				j: '8',
				tr: '06',
				code: '0027',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Acarapé',
			},
			{
				j: '8',
				tr: '08',
				code: '0027',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Guarapari',
			},
			{
				j: '8',
				tr: '09',
				code: '0027',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CAMPOS BELOS',
			},
			{
				j: '8',
				tr: '10',
				code: '0027',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Barra do Corda',
			},
			{
				j: '8',
				tr: '11',
				code: '0027',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Itiquira',
			},
			{
				j: '8',
				tr: '12',
				code: '0027',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Batayporã',
			},
			{
				j: '8',
				tr: '13',
				code: '0027',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Betim',
			},
			{
				j: '8',
				tr: '14',
				code: '0027',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'MÃE DO RIO',
			},
			{
				j: '8',
				tr: '16',
				code: '0027',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CASTRO ',
			},
			{
				j: '8',
				tr: '18',
				code: '0027',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Corrente',
			},
			{
				j: '8',
				tr: '19',
				code: '0027',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Laje do Muriaé ',
			},
			{
				j: '8',
				tr: '21',
				code: '0027',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Santa Maria',
			},
			{
				j: '8',
				tr: '24',
				code: '0027',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Criciúma',
			},
			{
				j: '8',
				tr: '27',
				code: '0027',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Miranorte',
			},
		],
		'0028': [
			{
				j: '8',
				tr: '02',
				code: '0028',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Colônia de Leopoldina',
			},
			{
				j: '8',
				tr: '05',
				code: '0028',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BOQUIRA',
			},
			{
				j: '8',
				tr: '06',
				code: '0028',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Acaraú',
			},
			{
				j: '8',
				tr: '08',
				code: '0028',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Ibatiba',
			},
			{
				j: '8',
				tr: '09',
				code: '0028',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CARMO DO RIO VERDE',
			},
			{
				j: '8',
				tr: '10',
				code: '0028',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Buriticupu',
			},
			{
				j: '8',
				tr: '11',
				code: '0028',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Poconé',
			},
			{
				j: '8',
				tr: '12',
				code: '0028',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Bonito',
			},
			{
				j: '8',
				tr: '13',
				code: '0028',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Andrelândia',
			},
			{
				j: '8',
				tr: '14',
				code: '0028',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'MARABÁ',
			},
			{
				j: '8',
				tr: '16',
				code: '0028',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CATANDUVAS ',
			},
			{
				j: '8',
				tr: '18',
				code: '0028',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Floriano',
			},
			{
				j: '8',
				tr: '19',
				code: '0028',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Macaé ',
			},
			{
				j: '8',
				tr: '21',
				code: '0028',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Santa Rosa',
			},
			{
				j: '8',
				tr: '24',
				code: '0028',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Joinville',
			},
			{
				j: '8',
				tr: '26',
				code: '0028',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Aparecida ',
			},
			{
				j: '8',
				tr: '27',
				code: '0028',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Natividade',
			},
		],
		'0029': [
			{
				j: '8',
				tr: '02',
				code: '0029',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Batalha',
			},
			{
				j: '8',
				tr: '05',
				code: '0029',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BOTUPORÃ',
			},
			{
				j: '8',
				tr: '06',
				code: '0029',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Acopiara',
			},
			{
				j: '8',
				tr: '08',
				code: '0029',
				courthouse: 'TJES',
				state: 'ES',
				city: 'IBIRAÇU',
			},
			{
				j: '8',
				tr: '09',
				code: '0029',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CATALAO',
			},
			{
				j: '8',
				tr: '10',
				code: '0029',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Caxias',
			},
			{
				j: '8',
				tr: '11',
				code: '0029',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Canarana',
			},
			{
				j: '8',
				tr: '12',
				code: '0029',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Naviraí',
			},
			{
				j: '8',
				tr: '14',
				code: '0029',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'MARACANÃ',
			},
			{
				j: '8',
				tr: '16',
				code: '0029',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CENTENARIO DO SUL ',
			},
			{
				j: '8',
				tr: '18',
				code: '0029',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'José de Freitas',
			},
			{
				j: '8',
				tr: '21',
				code: '0029',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Santo Ângelo',
			},
			{
				j: '8',
				tr: '24',
				code: '0029',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Lages',
			},
			{
				j: '8',
				tr: '27',
				code: '0029',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Novo Acordo',
			},
		],
		'0030': [
			{
				j: '8',
				tr: '02',
				code: '0030',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Campo Alegre',
			},
			{
				j: '8',
				tr: '05',
				code: '0030',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BREJÕES',
			},
			{
				j: '8',
				tr: '06',
				code: '0030',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Aiuaba',
			},
			{
				j: '8',
				tr: '08',
				code: '0030',
				courthouse: 'TJES',
				state: 'ES',
				city: 'IBIRAÇU',
			},
			{
				j: '8',
				tr: '09',
				code: '0030',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CATALAO',
			},
			{
				j: '8',
				tr: '10',
				code: '0030',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Caxias',
			},
			{
				j: '8',
				tr: '11',
				code: '0030',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Nobres',
			},
			{
				j: '8',
				tr: '12',
				code: '0030',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Brasilândia',
			},
			{
				j: '8',
				tr: '14',
				code: '0030',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'MARAPANIM',
			},
			{
				j: '8',
				tr: '16',
				code: '0030',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CERRO AZUL ',
			},
			{
				j: '8',
				tr: '18',
				code: '0030',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Oeiras',
			},
			{
				j: '8',
				tr: '19',
				code: '0030',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Mangaratiba ',
			},
			{
				j: '8',
				tr: '21',
				code: '0030',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'são Borja',
			},
			{
				j: '8',
				tr: '23',
				code: '0030',
				courthouse: 'TJRR',
				state: 'RR',
				city: 'Mucajaí',
			},
			{
				j: '8',
				tr: '24',
				code: '0030',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Joinville',
			},
			{
				j: '8',
				tr: '25',
				code: '0030',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'São Cristóvão',
			},
			{
				j: '8',
				tr: '26',
				code: '0030',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Apiaí ',
			},
			{
				j: '8',
				tr: '27',
				code: '0030',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Palmeirópolis',
			},
		],
		'0031': [
			{
				j: '8',
				tr: '02',
				code: '0031',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'São José da Tapera',
			},
			{
				j: '8',
				tr: '05',
				code: '0031',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BROTAS DE MACAÚBAS',
			},
			{
				j: '8',
				tr: '06',
				code: '0031',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Alto Santo',
			},
			{
				j: '8',
				tr: '08',
				code: '0031',
				courthouse: 'TJES',
				state: 'ES',
				city: 'IBITIRAMA',
			},
			{
				j: '8',
				tr: '09',
				code: '0031',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CAVALCANTE',
			},
			{
				j: '8',
				tr: '10',
				code: '0031',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Chapadinha',
			},
			{
				j: '8',
				tr: '11',
				code: '0031',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Nortelândia',
			},
			{
				j: '8',
				tr: '12',
				code: '0031',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Caarapó',
			},
			{
				j: '8',
				tr: '14',
				code: '0031',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'MOJU',
			},
			{
				j: '8',
				tr: '15',
				code: '0031',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Alagoa Grande',
			},
			{
				j: '8',
				tr: '16',
				code: '0031',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CHOPINZINHO ',
			},
			{
				j: '8',
				tr: '18',
				code: '0031',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Parnaíba',
			},
			{
				j: '8',
				tr: '19',
				code: '0031',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Maricá ',
			},
			{
				j: '8',
				tr: '21',
				code: '0031',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'São Gabriel',
			},
			{
				j: '8',
				tr: '24',
				code: '0031',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'São José',
			},
			{
				j: '8',
				tr: '25',
				code: '0031',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'São Cristóvão',
			},
			{
				j: '8',
				tr: '27',
				code: '0031',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Paraíso do Tocantins',
			},
		],
		'0032': [
			{
				j: '8',
				tr: '02',
				code: '0032',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Porto Real do Colégio',
			},
			{
				j: '8',
				tr: '05',
				code: '0032',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BRUMADO',
			},
			{
				j: '8',
				tr: '06',
				code: '0032',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Amontada',
			},
			{
				j: '8',
				tr: '08',
				code: '0032',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Iconha',
			},
			{
				j: '8',
				tr: '09',
				code: '0032',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CERES',
			},
			{
				j: '8',
				tr: '10',
				code: '0032',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Coelho Neto',
			},
			{
				j: '8',
				tr: '11',
				code: '0032',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Rosário Oeste',
			},
			{
				j: '8',
				tr: '12',
				code: '0032',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Deodápolis',
			},
			{
				j: '8',
				tr: '14',
				code: '0032',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'MONTE ALEGRE',
			},
			{
				j: '8',
				tr: '16',
				code: '0032',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CIANORTE ',
			},
			{
				j: '8',
				tr: '18',
				code: '0032',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Picos',
			},
			{
				j: '8',
				tr: '19',
				code: '0032',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Mendes ',
			},
			{
				j: '8',
				tr: '21',
				code: '0032',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'São Jerônimo',
			},
			{
				j: '8',
				tr: '24',
				code: '0032',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'São José',
			},
			{
				j: '8',
				tr: '26',
				code: '0032',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Araçatuba ',
			},
			{
				j: '8',
				tr: '27',
				code: '0032',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Paraná',
			},
		],
		'0033': [
			{
				j: '8',
				tr: '02',
				code: '0033',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Joaquim Gomes',
			},
			{
				j: '8',
				tr: '05',
				code: '0033',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'BUERAREMA',
			},
			{
				j: '8',
				tr: '06',
				code: '0033',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Antonina do Norte',
			},
			{
				j: '8',
				tr: '08',
				code: '0033',
				courthouse: 'TJES',
				state: 'ES',
				city: 'ITAGUAÇU',
			},
			{
				j: '8',
				tr: '09',
				code: '0033',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CERES',
			},
			{
				j: '8',
				tr: '10',
				code: '0033',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Colinas',
			},
			{
				j: '8',
				tr: '11',
				code: '0033',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'São José do Rio Claro',
			},
			{
				j: '8',
				tr: '12',
				code: '0033',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Eldourado',
			},
			{
				j: '8',
				tr: '14',
				code: '0033',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'MUANA',
			},
			{
				j: '8',
				tr: '16',
				code: '0033',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CIDADE GAUCHA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0033',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Piripiri',
			},
			{
				j: '8',
				tr: '19',
				code: '0033',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Miguel Pereira ',
			},
			{
				j: '8',
				tr: '21',
				code: '0033',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'São Leopoldo',
			},
			{
				j: '8',
				tr: '24',
				code: '0033',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Indaial',
			},
			{
				j: '8',
				tr: '27',
				code: '0033',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Pedro Afonso',
			},
		],
		'0034': [
			{
				j: '8',
				tr: '02',
				code: '0034',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Piaçabuçu',
			},
			{
				j: '8',
				tr: '05',
				code: '0034',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CACHOEIRA',
			},
			{
				j: '8',
				tr: '06',
				code: '0034',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Aquiraz',
			},
			{
				j: '8',
				tr: '08',
				code: '0034',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Itapemirim',
			},
			{
				j: '8',
				tr: '09',
				code: '0034',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CORUMBA DE GOIAS',
			},
			{
				j: '8',
				tr: '10',
				code: '0034',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Codó',
			},
			{
				j: '8',
				tr: '11',
				code: '0034',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Dom Aquino',
			},
			{
				j: '8',
				tr: '12',
				code: '0034',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Glória de Dourados',
			},
			{
				j: '8',
				tr: '13',
				code: '0034',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Araçuaí',
			},
			{
				j: '8',
				tr: '14',
				code: '0034',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'NOVA TIMBOTEUA',
			},
			{
				j: '8',
				tr: '16',
				code: '0034',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CLEVELANDIA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0034',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Água Branca',
			},
			{
				j: '8',
				tr: '19',
				code: '0034',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Miracema ',
			},
			{
				j: '8',
				tr: '21',
				code: '0034',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'São Luiz Gonzaga',
			},
			{
				j: '8',
				tr: '24',
				code: '0034',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Florianópolis',
			},
			{
				j: '8',
				tr: '27',
				code: '0034',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Peixe',
			},
		],
		'0035': [
			{
				j: '8',
				tr: '02',
				code: '0035',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Piranhas',
			},
			{
				j: '8',
				tr: '05',
				code: '0035',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CACULÉ',
			},
			{
				j: '8',
				tr: '06',
				code: '0035',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Aracati',
			},
			{
				j: '8',
				tr: '08',
				code: '0035',
				courthouse: 'TJES',
				state: 'ES',
				city: 'ITARANA',
			},
			{
				j: '8',
				tr: '09',
				code: '0035',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CORUMBAIBA',
			},
			{
				j: '8',
				tr: '10',
				code: '0035',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Coroatá',
			},
			{
				j: '8',
				tr: '11',
				code: '0035',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Alto Garças',
			},
			{
				j: '8',
				tr: '12',
				code: '0035',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Iguatemi',
			},
			{
				j: '8',
				tr: '13',
				code: '0035',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Araguari',
			},
			{
				j: '8',
				tr: '14',
				code: '0035',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'Óbidos',
			},
			{
				j: '8',
				tr: '16',
				code: '0035',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'COLORADO ',
			},
			{
				j: '8',
				tr: '18',
				code: '0035',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Alto Longá',
			},
			{
				j: '8',
				tr: '19',
				code: '0035',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Natividade ',
			},
			{
				j: '8',
				tr: '21',
				code: '0035',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Sapucaia do Sul',
			},
			{
				j: '8',
				tr: '24',
				code: '0035',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Florianópolis',
			},
			{
				j: '8',
				tr: '26',
				code: '0035',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Águas de Lindóia ',
			},
			{
				j: '8',
				tr: '27',
				code: '0035',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Pium',
			},
		],
		'0036': [
			{
				j: '8',
				tr: '02',
				code: '0036',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Junqueiro',
			},
			{
				j: '8',
				tr: '05',
				code: '0036',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CAETITÉ',
			},
			{
				j: '8',
				tr: '08',
				code: '0036',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Iúna',
			},
			{
				j: '8',
				tr: '09',
				code: '0036',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CRISTALINA',
			},
			{
				j: '8',
				tr: '10',
				code: '0036',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Estreito',
			},
			{
				j: '8',
				tr: '11',
				code: '0036',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Guiratinga',
			},
			{
				j: '8',
				tr: '12',
				code: '0036',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Inocência',
			},
			{
				j: '8',
				tr: '14',
				code: '0036',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'OEIRAS DO PARÁ',
			},
			{
				j: '8',
				tr: '16',
				code: '0036',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CONGONHINHAS ',
			},
			{
				j: '8',
				tr: '18',
				code: '0036',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Altos ',
			},
			{
				j: '8',
				tr: '19',
				code: '0036',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Nilópolis ',
			},
			{
				j: '8',
				tr: '21',
				code: '0036',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Soledade',
			},
			{
				j: '8',
				tr: '24',
				code: '0036',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Florianópolis',
			},
			{
				j: '8',
				tr: '27',
				code: '0036',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Ponte Alta do Tocantins',
			},
		],
		'0037': [
			{
				j: '8',
				tr: '02',
				code: '0037',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Igaci',
			},
			{
				j: '8',
				tr: '05',
				code: '0037',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CALDEIRÃO GRANDE',
			},
			{
				j: '8',
				tr: '08',
				code: '0037',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Jaguaré',
			},
			{
				j: '8',
				tr: '09',
				code: '0037',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CRISTALINA',
			},
			{
				j: '8',
				tr: '10',
				code: '0037',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Grajaú',
			},
			{
				j: '8',
				tr: '11',
				code: '0037',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Primavera do Leste',
			},
			{
				j: '8',
				tr: '12',
				code: '0037',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Itaporã',
			},
			{
				j: '8',
				tr: '14',
				code: '0037',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'ORIXIMINA',
			},
			{
				j: '8',
				tr: '16',
				code: '0037',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CORBELIA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0037',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Amarante',
			},
			{
				j: '8',
				tr: '19',
				code: '0037',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Nova Friburgo ',
			},
			{
				j: '8',
				tr: '21',
				code: '0037',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Uruguaiana',
			},
			{
				j: '8',
				tr: '24',
				code: '0037',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Florianópolis',
			},
			{
				j: '8',
				tr: '26',
				code: '0037',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Araraquara ',
			},
			{
				j: '8',
				tr: '27',
				code: '0037',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Porto Nacional',
			},
		],
		'0038': [
			{
				j: '8',
				tr: '02',
				code: '0038',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Novo Lino',
			},
			{
				j: '8',
				tr: '05',
				code: '0038',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CAMACÃ',
			},
			{
				j: '8',
				tr: '08',
				code: '0038',
				courthouse: 'TJES',
				state: 'ES',
				city: 'JERONIMO MONTEIRO',
			},
			{
				j: '8',
				tr: '09',
				code: '0038',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CRIXAS',
			},
			{
				j: '8',
				tr: '10',
				code: '0038',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'João Lisboa',
			},
			{
				j: '8',
				tr: '11',
				code: '0038',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Araputanga',
			},
			{
				j: '8',
				tr: '12',
				code: '0038',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Nioaque',
			},
			{
				j: '8',
				tr: '14',
				code: '0038',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'OURÉM',
			},
			{
				j: '8',
				tr: '16',
				code: '0038',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CORNELIO PROCOPIO ',
			},
			{
				j: '8',
				tr: '18',
				code: '0038',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Avelino Lopes',
			},
			{
				j: '8',
				tr: '19',
				code: '0038',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Nova Iguaçu ',
			},
			{
				j: '8',
				tr: '21',
				code: '0038',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Vacaria',
			},
			{
				j: '8',
				tr: '24',
				code: '0038',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Chapecó',
			},
			{
				j: '8',
				tr: '26',
				code: '0038',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Araras ',
			},
			{
				j: '8',
				tr: '27',
				code: '0038',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Taguatinga',
			},
		],
		'0039': [
			{
				j: '8',
				tr: '02',
				code: '0039',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Feira Grande',
			},
			{
				j: '8',
				tr: '05',
				code: '0039',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CAMAÇARI',
			},
			{
				j: '8',
				tr: '08',
				code: '0039',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Laranja da Terra',
			},
			{
				j: '8',
				tr: '09',
				code: '0039',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CUMARI',
			},
			{
				j: '8',
				tr: '10',
				code: '0039',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Lago da Pedra',
			},
			{
				j: '8',
				tr: '11',
				code: '0039',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'São José dos Quatro Marcos',
			},
			{
				j: '8',
				tr: '12',
				code: '0039',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Pedro Gomes',
			},
			{
				j: '8',
				tr: '14',
				code: '0039',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'PARAGOMINAS',
			},
			{
				j: '8',
				tr: '16',
				code: '0039',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CORONEL VIVIDA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0039',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Barras',
			},
			{
				j: '8',
				tr: '19',
				code: '0039',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Paracambi ',
			},
			{
				j: '8',
				tr: '21',
				code: '0039',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Viamão',
			},
			{
				j: '8',
				tr: '24',
				code: '0039',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Blumenau',
			},
			{
				j: '8',
				tr: '27',
				code: '0039',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Tocantínia',
			},
		],
		'0040': [
			{
				j: '8',
				tr: '02',
				code: '0040',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Igreja Nova',
			},
			{
				j: '8',
				tr: '05',
				code: '0040',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CAMAMU',
			},
			{
				j: '8',
				tr: '08',
				code: '0040',
				courthouse: 'TJES',
				state: 'ES',
				city: 'JOÃO NEIVA',
			},
			{
				j: '8',
				tr: '09',
				code: '0040',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'EDEIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0040',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Imperatriz',
			},
			{
				j: '8',
				tr: '11',
				code: '0040',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Sorriso',
			},
			{
				j: '8',
				tr: '12',
				code: '0040',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Porto Murtinho',
			},
			{
				j: '8',
				tr: '13',
				code: '0040',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Araxá',
			},
			{
				j: '8',
				tr: '14',
				code: '0040',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'PARAUAPEBAS',
			},
			{
				j: '8',
				tr: '16',
				code: '0040',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CRUZEIRO DO OESTE ',
			},
			{
				j: '8',
				tr: '18',
				code: '0040',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Batalha',
			},
			{
				j: '8',
				tr: '19',
				code: '0040',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Paraíba do Sul ',
			},
			{
				j: '8',
				tr: '21',
				code: '0040',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Caçapava do Sul',
			},
			{
				j: '8',
				tr: '24',
				code: '0040',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Balneário Camburiú',
			},
			{
				j: '8',
				tr: '25',
				code: '0040',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Estância Velha',
			},
			{
				j: '8',
				tr: '26',
				code: '0040',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Araraquara ',
			},
			{
				j: '8',
				tr: '27',
				code: '0040',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Tocantinópolis',
			},
		],
		'0041': [
			{
				j: '8',
				tr: '02',
				code: '0041',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Maravilha',
			},
			{
				j: '8',
				tr: '05',
				code: '0041',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CAMPO FORMOSO',
			},
			{
				j: '8',
				tr: '08',
				code: '0041',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Linhares',
			},
			{
				j: '8',
				tr: '09',
				code: '0041',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ESTRELA DO NORTE',
			},
			{
				j: '8',
				tr: '10',
				code: '0041',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Imperatriz',
			},
			{
				j: '8',
				tr: '11',
				code: '0041',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Cuiabá',
			},
			{
				j: '8',
				tr: '12',
				code: '0041',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Ribas do Rio Pardo',
			},
			{
				j: '8',
				tr: '14',
				code: '0041',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'PEIXE-BOI',
			},
			{
				j: '8',
				tr: '15',
				code: '0041',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Alagoa Nova',
			},
			{
				j: '8',
				tr: '16',
				code: '0041',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CURIUVA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0041',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Beneditinos',
			},
			{
				j: '8',
				tr: '19',
				code: '0041',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Paraty ',
			},
			{
				j: '8',
				tr: '21',
				code: '0041',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Canela',
			},
			{
				j: '8',
				tr: '24',
				code: '0041',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Tubarão',
			},
			{
				j: '8',
				tr: '27',
				code: '0041',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Wanderlândia',
			},
		],
		'0042': [
			{
				j: '8',
				tr: '02',
				code: '0042',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Major Izidoro',
			},
			{
				j: '8',
				tr: '05',
				code: '0042',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CANARANA',
			},
			{
				j: '8',
				tr: '08',
				code: '0042',
				courthouse: 'TJES',
				state: 'ES',
				city: 'MANTENOPOLIS',
			},
			{
				j: '8',
				tr: '09',
				code: '0042',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'FAZENDA NOVA',
			},
			{
				j: '8',
				tr: '10',
				code: '0042',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Imperatriz',
			},
			{
				j: '8',
				tr: '11',
				code: '0042',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Cuiabá',
			},
			{
				j: '8',
				tr: '12',
				code: '0042',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Rio Verde de Mato Grosso',
			},
			{
				j: '8',
				tr: '13',
				code: '0042',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Arcos',
			},
			{
				j: '8',
				tr: '14',
				code: '0042',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'PONTA DE PEDRAS',
			},
			{
				j: '8',
				tr: '16',
				code: '0042',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'DOIS VIZINHOS ',
			},
			{
				j: '8',
				tr: '18',
				code: '0042',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Bom Jesus',
			},
			{
				j: '8',
				tr: '19',
				code: '0042',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Petrópolis ',
			},
			{
				j: '8',
				tr: '21',
				code: '0042',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Canguçu',
			},
			{
				j: '8',
				tr: '24',
				code: '0042',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Curitibanos',
			},
			{
				j: '8',
				tr: '26',
				code: '0042',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Altinópolis ',
			},
			{
				j: '8',
				tr: '27',
				code: '0042',
				courthouse: 'TJTO',
				state: 'TO',
				city: 'Xambioá',
			},
		],
		'0043': [
			{
				j: '8',
				tr: '02',
				code: '0043',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Água Branca',
			},
			{
				j: '8',
				tr: '05',
				code: '0043',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CANAVIEIRAS',
			},
			{
				j: '8',
				tr: '08',
				code: '0043',
				courthouse: 'TJES',
				state: 'ES',
				city: 'MARATAÍZES',
			},
			{
				j: '8',
				tr: '09',
				code: '0043',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'FIRMINOPOLIS',
			},
			{
				j: '8',
				tr: '12',
				code: '0043',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'São Gabriel do Oeste',
			},
			{
				j: '8',
				tr: '13',
				code: '0043',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Areado',
			},
			{
				j: '8',
				tr: '14',
				code: '0043',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'PORTEL',
			},
			{
				j: '8',
				tr: '16',
				code: '0043',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'ENGENHEIRO BELTRÃO ',
			},
			{
				j: '8',
				tr: '18',
				code: '0043',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Buriti dos Lopes',
			},
			{
				j: '8',
				tr: '19',
				code: '0043',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Piraí',
			},
			{
				j: '8',
				tr: '21',
				code: '0043',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Cerro Largo',
			},
			{
				j: '8',
				tr: '24',
				code: '0043',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Imbituba ',
			},
		],
		'0044': [
			{
				j: '8',
				tr: '02',
				code: '0044',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Cajueiro',
			},
			{
				j: '8',
				tr: '05',
				code: '0044',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CANDEIAS',
			},
			{
				j: '8',
				tr: '08',
				code: '0044',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Marechal Floriano',
			},
			{
				j: '8',
				tr: '09',
				code: '0044',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'FORMOSA',
			},
			{
				j: '8',
				tr: '10',
				code: '0044',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Imperatriz',
			},
			{
				j: '8',
				tr: '11',
				code: '0044',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Paranatinga',
			},
			{
				j: '8',
				tr: '12',
				code: '0044',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Sete Quedas',
			},
			{
				j: '8',
				tr: '14',
				code: '0044',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'Primavera ',
			},
			{
				j: '8',
				tr: '16',
				code: '0044',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'FAXINAL ',
			},
			{
				j: '8',
				tr: '18',
				code: '0044',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Canto do Buriti',
			},
			{
				j: '8',
				tr: '19',
				code: '0044',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Porciúncula ',
			},
			{
				j: '8',
				tr: '21',
				code: '0044',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Encantado',
			},
			{
				j: '8',
				tr: '24',
				code: '0044',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Porto União',
			},
		],
		'0045': [
			{
				j: '8',
				tr: '02',
				code: '0045',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Porto de Pedras',
			},
			{
				j: '8',
				tr: '05',
				code: '0045',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CÂNDIDO SALES',
			},
			{
				j: '8',
				tr: '08',
				code: '0045',
				courthouse: 'TJES',
				state: 'ES',
				city: 'MARILÂNDIA',
			},
			{
				j: '8',
				tr: '09',
				code: '0045',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'FORMOSA',
			},
			{
				j: '8',
				tr: '10',
				code: '0045',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Imperatriz',
			},
			{
				j: '8',
				tr: '11',
				code: '0045',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Lucas do Rio Verde',
			},
			{
				j: '8',
				tr: '12',
				code: '0045',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Sidrolândia',
			},
			{
				j: '8',
				tr: '13',
				code: '0045',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Caeté',
			},
			{
				j: '8',
				tr: '14',
				code: '0045',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'REDENÇÃO',
			},
			{
				j: '8',
				tr: '16',
				code: '0045',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'FORMOSA DO OESTE',
			},
			{
				j: '8',
				tr: '18',
				code: '0045',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Castelo do Piauí',
			},
			{
				j: '8',
				tr: '19',
				code: '0045',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Resende ',
			},
			{
				j: '8',
				tr: '21',
				code: '0045',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Encruzilada do Sul',
			},
			{
				j: '8',
				tr: '23',
				code: '0045',
				courthouse: 'TJRR',
				state: 'RR',
				city: 'Pacaraima',
			},
			{
				j: '8',
				tr: '24',
				code: '0045',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Balneário Camburiú',
			},
			{
				j: '8',
				tr: '26',
				code: '0045',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santa Isabel ',
			},
		],
		'0046': [
			{
				j: '8',
				tr: '02',
				code: '0046',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Taquarana',
			},
			{
				j: '8',
				tr: '05',
				code: '0046',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CANSANÇÃO',
			},
			{
				j: '8',
				tr: '08',
				code: '0046',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Mimoso do Sul',
			},
			{
				j: '8',
				tr: '09',
				code: '0046',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'FORMOSO',
			},
			{
				j: '8',
				tr: '10',
				code: '0046',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Imperatriz',
			},
			{
				j: '8',
				tr: '11',
				code: '0046',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Comodoro',
			},
			{
				j: '8',
				tr: '12',
				code: '0046',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Chapadão do Sul',
			},
			{
				j: '8',
				tr: '14',
				code: '0046',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'RONDON DO PARÁ',
			},
			{
				j: '8',
				tr: '16',
				code: '0046',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CURITIBA',
			},
			{
				j: '8',
				tr: '18',
				code: '0046',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Cocal',
			},
			{
				j: '8',
				tr: '19',
				code: '0046',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Rio Bonito ',
			},
			{
				j: '8',
				tr: '21',
				code: '0046',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Espumoso',
			},
			{
				j: '8',
				tr: '24',
				code: '0046',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Jaraguá do Sul',
			},
		],
		'0047': [
			{
				j: '8',
				tr: '02',
				code: '0047',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Traipu',
			},
			{
				j: '8',
				tr: '05',
				code: '0047',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CANUDOS',
			},
			{
				j: '8',
				tr: '08',
				code: '0047',
				courthouse: 'TJES',
				state: 'ES',
				city: 'MONTANHA',
			},
			{
				j: '8',
				tr: '09',
				code: '0047',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANAPOLIS',
			},
			{
				j: '8',
				tr: '10',
				code: '0047',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Imperatriz',
			},
			{
				j: '8',
				tr: '11',
				code: '0047',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Jaurú',
			},
			{
				j: '8',
				tr: '12',
				code: '0047',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Terenos',
			},
			{
				j: '8',
				tr: '14',
				code: '0047',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'RIO MARIA',
			},
			{
				j: '8',
				tr: '16',
				code: '0047',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CURITIBA',
			},
			{
				j: '8',
				tr: '18',
				code: '0047',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Cristino Castro',
			},
			{
				j: '8',
				tr: '19',
				code: '0047',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Rio Claro ',
			},
			{
				j: '8',
				tr: '21',
				code: '0047',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Estrela',
			},
			{
				j: '8',
				tr: '23',
				code: '0047',
				courthouse: 'TJRR',
				state: 'RR',
				city: 'Rorainópois',
			},
			{
				j: '8',
				tr: '24',
				code: '0047',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Itajaí',
			},
			{
				j: '8',
				tr: '26',
				code: '0047',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Assis ',
			},
		],
		'0048': [
			{
				j: '8',
				tr: '02',
				code: '0048',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Matriz do Camaragibe',
			},
			{
				j: '8',
				tr: '05',
				code: '0048',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CAPELA DO ALTO ALEGRE',
			},
			{
				j: '8',
				tr: '08',
				code: '0048',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Mucurici',
			},
			{
				j: '8',
				tr: '09',
				code: '0048',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANDIRA',
			},
			{
				j: '8',
				tr: '10',
				code: '0048',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Itapecuru-Mirim',
			},
			{
				j: '8',
				tr: '11',
				code: '0048',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Juscimeira',
			},
			{
				j: '8',
				tr: '12',
				code: '0048',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Rio Negro',
			},
			{
				j: '8',
				tr: '14',
				code: '0048',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SALINÓPOLIS',
			},
			{
				j: '8',
				tr: '16',
				code: '0048',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CURITIBA',
			},
			{
				j: '8',
				tr: '18',
				code: '0048',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Demerval Lobão',
			},
			{
				j: '8',
				tr: '19',
				code: '0048',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Rio das Flores ',
			},
			{
				j: '8',
				tr: '21',
				code: '0048',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Farroupilha',
			},
			{
				j: '8',
				tr: '24',
				code: '0048',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Rio do Sul',
			},
			{
				j: '8',
				tr: '26',
				code: '0048',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Atibaia ',
			},
		],
		'0049': [
			{
				j: '8',
				tr: '02',
				code: '0049',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Mata Grande',
			},
			{
				j: '8',
				tr: '05',
				code: '0049',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CAPIM GROSSO',
			},
			{
				j: '8',
				tr: '08',
				code: '0049',
				courthouse: 'TJES',
				state: 'ES',
				city: ' MUNIZ FREIRE',
			},
			{
				j: '8',
				tr: '09',
				code: '0049',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANESIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0049',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Paço do Lumiar',
			},
			{
				j: '8',
				tr: '11',
				code: '0049',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Vila Rica',
			},
			{
				j: '8',
				tr: '12',
				code: '0049',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Água Clara',
			},
			{
				j: '8',
				tr: '13',
				code: '0049',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Baependi',
			},
			{
				j: '8',
				tr: '14',
				code: '0049',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SANTA IZABEL',
			},
			{
				j: '8',
				tr: '16',
				code: '0049',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CURITIBA',
			},
			{
				j: '8',
				tr: '18',
				code: '0049',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Elesbão Veloso',
			},
			{
				j: '8',
				tr: '19',
				code: '0049',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Santa Maria Madalena',
			},
			{
				j: '8',
				tr: '21',
				code: '0049',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Frederico Westphalen',
			},
			{
				j: '8',
				tr: '24',
				code: '0049',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Fraiburgo',
			},
		],
		'0050': [
			{
				j: '8',
				tr: '02',
				code: '0050',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Anadia',
			},
			{
				j: '8',
				tr: '05',
				code: '0050',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CARAVELAS',
			},
			{
				j: '8',
				tr: '08',
				code: '0050',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Muqui',
			},
			{
				j: '8',
				tr: '09',
				code: '0050',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANESIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0050',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Paço do Lumiar',
			},
			{
				j: '8',
				tr: '11',
				code: '0050',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Campo Novo do Parecis',
			},
			{
				j: '8',
				tr: '14',
				code: '0050',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SANTARÉM',
			},
			{
				j: '8',
				tr: '16',
				code: '0050',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CURITIBA',
			},
			{
				j: '8',
				tr: '18',
				code: '0050',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Esperantina',
			},
			{
				j: '8',
				tr: '19',
				code: '0050',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Santo Antônio de Pádua',
			},
			{
				j: '8',
				tr: '21',
				code: '0050',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Getúlio Vargas',
			},
			{
				j: '8',
				tr: '24',
				code: '0050',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Joinville',
			},
			{
				j: '8',
				tr: '25',
				code: '0050',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Itabaiana',
			},
			{
				j: '8',
				tr: '26',
				code: '0050',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
		'0051': [
			{
				j: '8',
				tr: '02',
				code: '0051',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Quebrangulo',
			},
			{
				j: '8',
				tr: '05',
				code: '0051',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CARINHANHA',
			},
			{
				j: '8',
				tr: '08',
				code: '0051',
				courthouse: 'TJES',
				state: 'ES',
				city: 'NOVA VENÉCIA',
			},
			{
				j: '8',
				tr: '09',
				code: '0051',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0051',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Pedreiras',
			},
			{
				j: '8',
				tr: '11',
				code: '0051',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Campo Verde',
			},
			{
				j: '8',
				tr: '12',
				code: '0051',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Itaquiraí',
			},
			{
				j: '8',
				tr: '13',
				code: '0051',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Bambuí',
			},
			{
				j: '8',
				tr: '14',
				code: '0051',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SANTARÉM',
			},
			{
				j: '8',
				tr: '15',
				code: '0051',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'São João do Rio do Peixe',
			},
			{
				j: '8',
				tr: '16',
				code: '0051',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CURITIBA',
			},
			{
				j: '8',
				tr: '18',
				code: '0051',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Fronteiras',
			},
			{
				j: '8',
				tr: '19',
				code: '0051',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'São Fidelis ',
			},
			{
				j: '8',
				tr: '21',
				code: '0051',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Garibaldi',
			},
			{
				j: '8',
				tr: '24',
				code: '0051',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Blumenau',
			},
		],
		'0052': [
			{
				j: '8',
				tr: '02',
				code: '0052',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Paripueira',
			},
			{
				j: '8',
				tr: '05',
				code: '0052',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CASA NOVA',
			},
			{
				j: '8',
				tr: '08',
				code: '0052',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Pancas',
			},
			{
				j: '8',
				tr: '09',
				code: '0052',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0052',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Pinheiro',
			},
			{
				j: '8',
				tr: '11',
				code: '0052',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Rio Branco',
			},
			{
				j: '8',
				tr: '12',
				code: '0052',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Anastácio',
			},
			{
				j: '8',
				tr: '14',
				code: '0052',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SÃO DOMINGOS DO CAPIM',
			},
			{
				j: '8',
				tr: '16',
				code: '0052',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CURITIBA',
			},
			{
				j: '8',
				tr: '18',
				code: '0052',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Gilbués',
			},
			{
				j: '8',
				tr: '19',
				code: '0052',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Araruama ',
			},
			{
				j: '8',
				tr: '21',
				code: '0052',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Guaíba',
			},
			{
				j: '8',
				tr: '24',
				code: '0052',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Timbó',
			},
			{
				j: '8',
				tr: '26',
				code: '0052',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
		'0053': [
			{
				j: '8',
				tr: '02',
				code: '0053',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Maribondo',
			},
			{
				j: '8',
				tr: '05',
				code: '0053',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CASTRO ALVES',
			},
			{
				j: '8',
				tr: '08',
				code: '0053',
				courthouse: 'TJES',
				state: 'ES',
				city: 'PEDRO CANÁRIO',
			},
			{
				j: '8',
				tr: '09',
				code: '0053',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0053',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Porto Franco',
			},
			{
				j: '8',
				tr: '11',
				code: '0053',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Santo Antônio do Leverger',
			},
			{
				j: '8',
				tr: '12',
				code: '0053',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Dois Irmãos do Buriti',
			},
			{
				j: '8',
				tr: '14',
				code: '0053',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SÃO FELIX DO XINGU',
			},
			{
				j: '8',
				tr: '16',
				code: '0053',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CURITIBA',
			},
			{
				j: '8',
				tr: '18',
				code: '0053',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Guadalupe',
			},
			{
				j: '8',
				tr: '19',
				code: '0053',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'São João da Barra ',
			},
			{
				j: '8',
				tr: '21',
				code: '0053',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Guaporé',
			},
			{
				j: '8',
				tr: '24',
				code: '0053',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Criciúma',
			},
			{
				j: '8',
				tr: '26',
				code: '0053',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
		'0054': [
			{
				j: '8',
				tr: '02',
				code: '0054',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Limoeiro de Anadia',
			},
			{
				j: '8',
				tr: '05',
				code: '0054',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CATU',
			},
			{
				j: '8',
				tr: '08',
				code: '0054',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Pinheiros',
			},
			{
				j: '8',
				tr: '09',
				code: '0054',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0054',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Presidente Dutra',
			},
			{
				j: '8',
				tr: '11',
				code: '0054',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Cuiabá',
			},
			{
				j: '8',
				tr: '12',
				code: '0054',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Nova Alvorada do Sul',
			},
			{
				j: '8',
				tr: '13',
				code: '0054',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Barão de Cocais',
			},
			{
				j: '8',
				tr: '14',
				code: '0054',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SÃO JOÃO DO ARAGUAIA',
			},
			{
				j: '8',
				tr: '16',
				code: '0054',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CURITIBA',
			},
			{
				j: '8',
				tr: '18',
				code: '0054',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Inhuma',
			},
			{
				j: '8',
				tr: '19',
				code: '0054',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'São João de Meriti ',
			},
			{
				j: '8',
				tr: '21',
				code: '0054',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Itaqui',
			},
			{
				j: '8',
				tr: '24',
				code: '0054',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'São José',
			},
		],
		'0055': [
			{
				j: '8',
				tr: '02',
				code: '0055',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Cacimbinhas',
			},
			{
				j: '8',
				tr: '05',
				code: '0055',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CENTRAL',
			},
			{
				j: '8',
				tr: '08',
				code: '0055',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Piuma',
			},
			{
				j: '8',
				tr: '09',
				code: '0055',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0055',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'SANTA HELENA ',
			},
			{
				j: '8',
				tr: '11',
				code: '0055',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Tangará da Serra',
			},
			{
				j: '8',
				tr: '12',
				code: '0055',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Sonora',
			},
			{
				j: '8',
				tr: '14',
				code: '0055',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SÃO MIGUEL DO GUAMA',
			},
			{
				j: '8',
				tr: '16',
				code: '0055',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'CURITIBA',
			},
			{
				j: '8',
				tr: '18',
				code: '0055',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Itainópolis',
			},
			{
				j: '8',
				tr: '19',
				code: '0055',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'São Pedro da Aldeia',
			},
			{
				j: '8',
				tr: '21',
				code: '0055',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Jaguarão',
			},
			{
				j: '8',
				tr: '24',
				code: '0055',
				courthouse: 'TJSC',
				state: 'SC',
				city: 'Criciúma ',
			},
		],
		'0056': [
			{
				j: '8',
				tr: '02',
				code: '0056',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Fleixeiras',
			},
			{
				j: '8',
				tr: '05',
				code: '0056',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CHORROCHÓ',
			},
			{
				j: '8',
				tr: '08',
				code: '0056',
				courthouse: 'TJES',
				state: 'ES',
				city: 'PRESIDENTE KENNEDY',
			},
			{
				j: '8',
				tr: '09',
				code: '0056',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0056',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Santa Inês',
			},
			{
				j: '8',
				tr: '13',
				code: '0056',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Barbacena ',
			},
			{
				j: '8',
				tr: '14',
				code: '0056',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SÃO SEBASTIÃO DA BOA VISTA',
			},
			{
				j: '8',
				tr: '16',
				code: '0056',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'FOZ DO IGUACU ',
			},
			{
				j: '8',
				tr: '18',
				code: '0056',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Itaueira',
			},
			{
				j: '8',
				tr: '19',
				code: '0056',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'São Sebastião do Alto',
			},
			{
				j: '8',
				tr: '21',
				code: '0056',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Julio de Castilhoa ',
			},
		],
		'0057': [
			{
				j: '8',
				tr: '02',
				code: '0057',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Messias',
			},
			{
				j: '8',
				tr: '05',
				code: '0057',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CÍCERO DANTAS',
			},
			{
				j: '8',
				tr: '08',
				code: '0057',
				courthouse: 'TJES',
				state: 'ES',
				city: 'RIO BANANAL',
			},
			{
				j: '8',
				tr: '09',
				code: '0057',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0057',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Santa Luzia',
			},
			{
				j: '8',
				tr: '11',
				code: '0057',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Cuiabá',
			},
			{
				j: '8',
				tr: '14',
				code: '0057',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SANTANA DO ARAGUAIA',
			},
			{
				j: '8',
				tr: '16',
				code: '0057',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'FRANCISCO BELTRÃO ',
			},
			{
				j: '8',
				tr: '18',
				code: '0057',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Jaicós',
			},
			{
				j: '8',
				tr: '19',
				code: '0057',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Sapucaia',
			},
			{
				j: '8',
				tr: '21',
				code: '0057',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Logoa Vermelha ',
			},
		],
		'0058': [
			{
				j: '8',
				tr: '02',
				code: '0058',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Canapi',
			},
			{
				j: '8',
				tr: '05',
				code: '0058',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CIPÓ',
			},
			{
				j: '8',
				tr: '08',
				code: '0058',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Rio Novo do Sul',
			},
			{
				j: '8',
				tr: '09',
				code: '0058',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0058',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São José de Ribamar',
			},
			{
				j: '8',
				tr: '11',
				code: '0058',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Sinop',
			},
			{
				j: '8',
				tr: '13',
				code: '0058',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Três Marias',
			},
			{
				j: '8',
				tr: '14',
				code: '0058',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SENADOR JOSÉ PORFÍRIO ',
			},
			{
				j: '8',
				tr: '16',
				code: '0058',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'GOIOERE ',
			},
			{
				j: '8',
				tr: '18',
				code: '0058',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Jerumenha',
			},
			{
				j: '8',
				tr: '19',
				code: '0058',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Saquarema ',
			},
			{
				j: '8',
				tr: '21',
				code: '0058',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Nova Patra',
			},
			{
				j: '8',
				tr: '26',
				code: '0058',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Agudos ',
			},
		],
		'0059': [
			{
				j: '8',
				tr: '02',
				code: '0059',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Paulo Jacinto',
			},
			{
				j: '8',
				tr: '05',
				code: '0059',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'COARACI',
			},
			{
				j: '8',
				tr: '08',
				code: '0059',
				courthouse: 'TJES',
				state: 'ES',
				city: 'SANTA LEOPOLDINA',
			},
			{
				j: '8',
				tr: '09',
				code: '0059',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0059',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São José de Ribamar',
			},
			{
				j: '8',
				tr: '11',
				code: '0059',
				courthouse: 'TJMT',
				state: 'MT',
				city: 'Porto Alegre do Norte',
			},
			{
				j: '8',
				tr: '13',
				code: '0059',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Barroso',
			},
			{
				j: '8',
				tr: '14',
				code: '0059',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SOURE',
			},
			{
				j: '8',
				tr: '16',
				code: '0059',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'GRANDES RIOS ',
			},
			{
				j: '8',
				tr: '18',
				code: '0059',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Luiz Correia',
			},
			{
				j: '8',
				tr: '19',
				code: '0059',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Silva Jardim ',
			},
			{
				j: '8',
				tr: '21',
				code: '0059',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Osório ',
			},
			{
				j: '8',
				tr: '26',
				code: '0059',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Bananal ',
			},
		],
		'0060': [
			{
				j: '8',
				tr: '02',
				code: '0060',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'Passo de Camaragibe',
			},
			{
				j: '8',
				tr: '05',
				code: '0060',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CÔCOS',
			},
			{
				j: '8',
				tr: '08',
				code: '0060',
				courthouse: 'TJES',
				state: 'ES',
				city: 'SÃO DOMINGOS DO NORTE',
			},
			{
				j: '8',
				tr: '09',
				code: '0060',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0060',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Timon',
			},
			{
				j: '8',
				tr: '14',
				code: '0060',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'TOMÉ AÇU',
			},
			{
				j: '8',
				tr: '16',
				code: '0060',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'GUAIRA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0060',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Luzilândia',
			},
			{
				j: '8',
				tr: '19',
				code: '0060',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Sumidouro ',
			},
			{
				j: '8',
				tr: '21',
				code: '0060',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Panambi',
			},
			{
				j: '8',
				tr: '23',
				code: '0060',
				courthouse: 'TJRR',
				state: 'RR',
				city: 'São Luis',
			},
			{
				j: '8',
				tr: '25',
				code: '0060',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Lagarto',
			},
			{
				j: '8',
				tr: '26',
				code: '0060',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Auriflama ',
			},
		],
		'0061': [
			{
				j: '8',
				tr: '02',
				code: '0061',
				courthouse: 'TJAL',
				state: 'AL',
				city: 'São Brás',
			},
			{
				j: '8',
				tr: '05',
				code: '0061',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CONCEIÇÃO DA FEIRA',
			},
			{
				j: '8',
				tr: '08',
				code: '0061',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Santa Maria de Jetibá',
			},
			{
				j: '8',
				tr: '09',
				code: '0061',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0061',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Viana',
			},
			{
				j: '8',
				tr: '14',
				code: '0061',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'TUCURUI',
			},
			{
				j: '8',
				tr: '15',
				code: '0061',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Araruna',
			},
			{
				j: '8',
				tr: '16',
				code: '0061',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'GUARANIACU ',
			},
			{
				j: '8',
				tr: '18',
				code: '0061',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Miguel Alves',
			},
			{
				j: '8',
				tr: '19',
				code: '0061',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Teresópolis ',
			},
			{
				j: '8',
				tr: '21',
				code: '0061',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Quaraí',
			},
		],
		'0062': [
			{
				j: '8',
				tr: '05',
				code: '0062',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CONCEIÇÃO DO ALMEIDA',
			},
			{
				j: '8',
				tr: '08',
				code: '0062',
				courthouse: 'TJES',
				state: 'ES',
				city: 'São Gabriel da Palha',
			},
			{
				j: '8',
				tr: '09',
				code: '0062',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0062',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Vitorino Freire',
			},
			{
				j: '8',
				tr: '14',
				code: '0062',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'TUCUMÃ',
			},
			{
				j: '8',
				tr: '16',
				code: '0062',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'GUARAPUAVA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0062',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Padre Marcos',
			},
			{
				j: '8',
				tr: '19',
				code: '0062',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Trajano de Moraes ',
			},
			{
				j: '8',
				tr: '21',
				code: '0062',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Rosária do Sul',
			},
			{
				j: '8',
				tr: '26',
				code: '0062',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Bariri ',
			},
		],
		'0063': [
			{
				j: '8',
				tr: '05',
				code: '0063',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CONCEIÇÃO DO COITÉ',
			},
			{
				j: '8',
				tr: '08',
				code: '0063',
				courthouse: 'TJES',
				state: 'ES',
				city: 'SÃO JOSÉ DO CALÇADO',
			},
			{
				j: '8',
				tr: '09',
				code: '0063',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0063',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Zé Doca',
			},
			{
				j: '8',
				tr: '14',
				code: '0063',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'VIGIA',
			},
			{
				j: '8',
				tr: '16',
				code: '0063',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'GUARA TUBA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0063',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Palmeirais',
			},
			{
				j: '8',
				tr: '19',
				code: '0063',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Três Rios ',
			},
			{
				j: '8',
				tr: '21',
				code: '0063',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Santa Vitória do Palmar',
			},
			{
				j: '8',
				tr: '26',
				code: '0063',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Barra Bonita ',
			},
		],
		'0064': [
			{
				j: '8',
				tr: '05',
				code: '0064',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CONCEIÇÃO DO JACUÍPE',
			},
			{
				j: '8',
				tr: '08',
				code: '0064',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Vargem Alta',
			},
			{
				j: '8',
				tr: '09',
				code: '0064',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIANIRA',
			},
			{
				j: '8',
				tr: '10',
				code: '0064',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Alcantara',
			},
			{
				j: '8',
				tr: '13',
				code: '0064',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Belo Vale',
			},
			{
				j: '8',
				tr: '14',
				code: '0064',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'VISEU',
			},
			{
				j: '8',
				tr: '16',
				code: '0064',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'IBAITI ',
			},
			{
				j: '8',
				tr: '18',
				code: '0064',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Paulistana',
			},
			{
				j: '8',
				tr: '19',
				code: '0064',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Valença ',
			},
			{
				j: '8',
				tr: '21',
				code: '0064',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Santiago',
			},
		],
		'0065': [
			{
				j: '8',
				tr: '05',
				code: '0065',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CONDE',
			},
			{
				j: '8',
				tr: '08',
				code: '0065',
				courthouse: 'TJES',
				state: 'ES',
				city: 'VENDA NOVA DO IMIGRANTE',
			},
			{
				j: '8',
				tr: '09',
				code: '0065',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIAS',
			},
			{
				j: '8',
				tr: '10',
				code: '0065',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Alto Parnaíba',
			},
			{
				j: '8',
				tr: '14',
				code: '0065',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'XINGUARA',
			},
			{
				j: '8',
				tr: '16',
				code: '0065',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'IBIPORA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0065',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Pedro II',
			},
			{
				j: '8',
				tr: '19',
				code: '0065',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Vassouras ',
			},
			{
				j: '8',
				tr: '21',
				code: '0065',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Santo Antônio da Patrulha',
			},
		],
		'0066': [
			{
				j: '8',
				tr: '05',
				code: '0066',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CONDEÚBA',
			},
			{
				j: '8',
				tr: '08',
				code: '0066',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Vitória',
			},
			{
				j: '8',
				tr: '09',
				code: '0066',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIAS',
			},
			{
				j: '8',
				tr: '10',
				code: '0066',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Amarante do Maranhão',
			},
			{
				j: '8',
				tr: '14',
				code: '0066',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'URUARA',
			},
			{
				j: '8',
				tr: '16',
				code: '0066',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'ICARAIMA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0066',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Pio IX',
			},
			{
				j: '8',
				tr: '19',
				code: '0066',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Volta Redonda ',
			},
			{
				j: '8',
				tr: '21',
				code: '0066',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'São Francisco de Paulo',
			},
			{
				j: '8',
				tr: '26',
				code: '0066',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Barretos ',
			},
		],
		'0067': [
			{
				j: '8',
				tr: '05',
				code: '0067',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CORAÇÃO DE MARIA',
			},
			{
				j: '8',
				tr: '08',
				code: '0067',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Vitória',
			},
			{
				j: '8',
				tr: '09',
				code: '0067',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIATUBA',
			},
			{
				j: '8',
				tr: '10',
				code: '0067',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Anajatuba',
			},
			{
				j: '8',
				tr: '14',
				code: '0067',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'MOCAJUBA',
			},
			{
				j: '8',
				tr: '16',
				code: '0067',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'IMBITUVA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0067',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Piracuruca',
			},
			{
				j: '8',
				tr: '19',
				code: '0067',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Queimados',
			},
			{
				j: '8',
				tr: '21',
				code: '0067',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'São Lourenço do Sul',
			},
			{
				j: '8',
				tr: '26',
				code: '0067',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Borborema ',
			},
		],
		'0068': [
			{
				j: '8',
				tr: '05',
				code: '0068',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CORIBE',
			},
			{
				j: '8',
				tr: '08',
				code: '0068',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Vitória',
			},
			{
				j: '8',
				tr: '09',
				code: '0068',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GOIATUBA',
			},
			{
				j: '8',
				tr: '10',
				code: '0068',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Arame',
			},
			{
				j: '8',
				tr: '14',
				code: '0068',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'AUGUSTO CORREA',
			},
			{
				j: '8',
				tr: '16',
				code: '0068',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'IPIRANGA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0068',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Porto',
			},
			{
				j: '8',
				tr: '19',
				code: '0068',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Rio das Ostras ',
			},
			{
				j: '8',
				tr: '21',
				code: '0068',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'São Sebastião do Caraí ',
			},
			{
				j: '8',
				tr: '26',
				code: '0068',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Barueri ',
			},
		],
		'0069': [
			{
				j: '8',
				tr: '05',
				code: '0069',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CORRENTINA',
			},
			{
				j: '8',
				tr: '08',
				code: '0069',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Vitória',
			},
			{
				j: '8',
				tr: '09',
				code: '0069',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'GUAPO',
			},
			{
				j: '8',
				tr: '10',
				code: '0069',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Araioses',
			},
			{
				j: '8',
				tr: '13',
				code: '0069',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Bicas',
			},
			{
				j: '8',
				tr: '14',
				code: '0069',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'PACAJÁ',
			},
			{
				j: '8',
				tr: '16',
				code: '0069',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'IPORA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0069',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Regeneração',
			},
			{
				j: '8',
				tr: '19',
				code: '0069',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'lguaba Grande ',
			},
			{
				j: '8',
				tr: '21',
				code: '0069',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Sarandi',
			},
			{
				j: '8',
				tr: '26',
				code: '0069',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Tupã ',
			},
		],
		'0071': [
			{
				j: '8',
				tr: '05',
				code: '0071',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CRISTÓPOLIS',
			},
			{
				j: '8',
				tr: '08',
				code: '0071',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Vitória',
			},
			{
				j: '8',
				tr: '09',
				code: '0071',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'HIDROLANDIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0071',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Bacuri',
			},
			{
				j: '8',
				tr: '13',
				code: '0071',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Boa Esperança',
			},
			{
				j: '8',
				tr: '14',
				code: '0071',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'BRASIL NOVO',
			},
			{
				j: '8',
				tr: '15',
				code: '0071',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Areia',
			},
			{
				j: '8',
				tr: '16',
				code: '0071',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'IRETAMA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0071',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'São Miguel do Tapuio',
			},
			{
				j: '8',
				tr: '19',
				code: '0071',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Porto Real  ',
			},
			{
				j: '8',
				tr: '21',
				code: '0071',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Taquari',
			},
			{
				j: '8',
				tr: '26',
				code: '0071',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Bauru ',
			},
		],
		'0072': [
			{
				j: '8',
				tr: '05',
				code: '0072',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CRUZ DAS ALMAS',
			},
			{
				j: '8',
				tr: '08',
				code: '0072',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Vitória',
			},
			{
				j: '8',
				tr: '09',
				code: '0072',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'INHUMAS',
			},
			{
				j: '8',
				tr: '10',
				code: '0072',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Barão de Grajaú',
			},
			{
				j: '8',
				tr: '14',
				code: '0072',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'MEDICILÂNDIA',
			},
			{
				j: '8',
				tr: '16',
				code: '0072',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'IVAIPORA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0072',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'São Pedro do Piauí',
			},
			{
				j: '8',
				tr: '19',
				code: '0072',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Paty do Alferes ',
			},
			{
				j: '8',
				tr: '21',
				code: '0072',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Torres',
			},
			{
				j: '8',
				tr: '26',
				code: '0072',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Bebedouro ',
			},
		],
		'0073': [
			{
				j: '8',
				tr: '05',
				code: '0073',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'CURAÇÁ',
			},
			{
				j: '8',
				tr: '08',
				code: '0073',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Vitória',
			},
			{
				j: '8',
				tr: '09',
				code: '0073',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'INHUMAS',
			},
			{
				j: '8',
				tr: '10',
				code: '0073',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Barreirinhas',
			},
			{
				j: '8',
				tr: '13',
				code: '0073',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Bocaiúva',
			},
			{
				j: '8',
				tr: '14',
				code: '0073',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'RURÓPOLIS',
			},
			{
				j: '8',
				tr: '16',
				code: '0073',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'JACAREZINHO ',
			},
			{
				j: '8',
				tr: '18',
				code: '0073',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'São Raimundo Nonato',
			},
			{
				j: '8',
				tr: '19',
				code: '0073',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Guapimirim ',
			},
			{
				j: '8',
				tr: '21',
				code: '0073',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Tramandai',
			},
			{
				j: '8',
				tr: '26',
				code: '0073',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Avaré ',
			},
		],
		'0074': [
			{
				j: '8',
				tr: '05',
				code: '0074',
				courthouse: 'TJBA',
				state: 'BA',
				city: "DIAS D'ÁVILA",
			},
			{
				j: '8',
				tr: '08',
				code: '0074',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Vitória',
			},
			{
				j: '8',
				tr: '09',
				code: '0074',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'IPAMERI',
			},
			{
				j: '8',
				tr: '10',
				code: '0074',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Bom Jardim',
			},
			{
				j: '8',
				tr: '13',
				code: '0074',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Bom Despacho',
			},
			{
				j: '8',
				tr: '14',
				code: '0074',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'TAILÂNDIA',
			},
			{
				j: '8',
				tr: '16',
				code: '0074',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'JAGUAPITA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0074',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Simões',
			},
			{
				j: '8',
				tr: '21',
				code: '0074',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Três de Maio',
			},
		],
		'0075': [
			{
				j: '8',
				tr: '05',
				code: '0075',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ENCRUZILHADA',
			},
			{
				j: '8',
				tr: '06',
				code: '0075',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Eusébio',
			},
			{
				j: '8',
				tr: '08',
				code: '0075',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Vitória',
			},
			{
				j: '8',
				tr: '09',
				code: '0075',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'IPAMERI',
			},
			{
				j: '8',
				tr: '10',
				code: '0075',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Bequimão',
			},
			{
				j: '8',
				tr: '14',
				code: '0075',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'PORTO DE MOZ',
			},
			{
				j: '8',
				tr: '16',
				code: '0075',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'JAGUARIAIVA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0075',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Simplício Mendes',
			},
			{
				j: '8',
				tr: '19',
				code: '0075',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Magé ',
			},
			{
				j: '8',
				tr: '21',
				code: '0075',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Três Passos',
			},
			{
				j: '8',
				tr: '26',
				code: '0075',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santos ',
			},
		],
		'0076': [
			{
				j: '8',
				tr: '05',
				code: '0076',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ENTRE RIOS',
			},
			{
				j: '8',
				tr: '06',
				code: '0076',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Farias Brito',
			},
			{
				j: '8',
				tr: '08',
				code: '0076',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Viana',
			},
			{
				j: '8',
				tr: '09',
				code: '0076',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'IPORA',
			},
			{
				j: '8',
				tr: '10',
				code: '0076',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Brejo',
			},
			{
				j: '8',
				tr: '14',
				code: '0076',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'Acará',
			},
			{
				j: '8',
				tr: '16',
				code: '0076',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'JANDAIA DO SUL ',
			},
			{
				j: '8',
				tr: '18',
				code: '0076',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'União',
			},
			{
				j: '8',
				tr: '19',
				code: '0076',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'São José do Vale do Rio Preto ',
			},
			{
				j: '8',
				tr: '21',
				code: '0076',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Tupancierã',
			},
			{
				j: '8',
				tr: '26',
				code: '0076',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Bilac ',
			},
		],
		'0077': [
			{
				j: '8',
				tr: '05',
				code: '0077',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ESPLANADA',
			},
			{
				j: '8',
				tr: '06',
				code: '0077',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Forquilha',
			},
			{
				j: '8',
				tr: '09',
				code: '0077',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'IPORA',
			},
			{
				j: '8',
				tr: '10',
				code: '0077',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Buriti',
			},
			{
				j: '8',
				tr: '16',
				code: '0077',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'JOAQUIM TAVORA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0077',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Uruçuí',
			},
			{
				j: '8',
				tr: '19',
				code: '0077',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Seropédica ',
			},
			{
				j: '8',
				tr: '21',
				code: '0077',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Venâncio Aires',
			},
			{
				j: '8',
				tr: '26',
				code: '0077',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Birigüi ',
			},
		],
		'0078': [
			{
				j: '8',
				tr: '05',
				code: '0078',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'EUCLIDES DA CUNHA',
			},
			{
				j: '8',
				tr: '06',
				code: '0078',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Fortim',
			},
			{
				j: '8',
				tr: '08',
				code: '0078',
				courthouse: 'TJES',
				state: 'ES',
				city: 'SANTA TERESA',
			},
			{
				j: '8',
				tr: '09',
				code: '0078',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ISRAELANDIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0078',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Buriti Bravo',
			},
			{
				j: '8',
				tr: '16',
				code: '0078',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'LAPA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0078',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Valença',
			},
			{
				j: '8',
				tr: '19',
				code: '0078',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Búzios',
			},
			{
				j: '8',
				tr: '21',
				code: '0078',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Veranópolis ',
			},
		],
		'0079': [
			{
				j: '8',
				tr: '05',
				code: '0079',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'EUNÁPOLIS',
			},
			{
				j: '8',
				tr: '06',
				code: '0079',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Frecheirinha',
			},
			{
				j: '8',
				tr: '08',
				code: '0079',
				courthouse: 'TJES',
				state: 'ES',
				city: 'SANTA TERESA',
			},
			{
				j: '8',
				tr: '09',
				code: '0079',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ITABERAI',
			},
			{
				j: '8',
				tr: '10',
				code: '0079',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Cândido Mendes',
			},
			{
				j: '8',
				tr: '13',
				code: '0079',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Contagem',
			},
			{
				j: '8',
				tr: '16',
				code: '0079',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'LARANJEIRAS DO SUL ',
			},
			{
				j: '8',
				tr: '18',
				code: '0079',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Angical do Piauí',
			},
			{
				j: '8',
				tr: '19',
				code: '0079',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'ltaipava ',
			},
			{
				j: '8',
				tr: '21',
				code: '0079',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Antônio Prado',
			},
			{
				j: '8',
				tr: '26',
				code: '0079',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Botucatu ',
			},
		],
		'0080': [
			{
				j: '8',
				tr: '05',
				code: '0080',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'FEIRA DE SANTANA',
			},
			{
				j: '8',
				tr: '06',
				code: '0080',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Graça',
			},
			{
				j: '8',
				tr: '08',
				code: '0080',
				courthouse: 'TJES',
				state: 'ES',
				city: 'São Mateus',
			},
			{
				j: '8',
				tr: '09',
				code: '0080',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ITABERAI',
			},
			{
				j: '8',
				tr: '10',
				code: '0080',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Cantanhede',
			},
			{
				j: '8',
				tr: '13',
				code: '0080',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Bom Sucesso',
			},
			{
				j: '8',
				tr: '14',
				code: '0080',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'BONITO',
			},
			{
				j: '8',
				tr: '16',
				code: '0080',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'LOANDA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0080',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Anísio de Abreu',
			},
			{
				j: '8',
				tr: '19',
				code: '0080',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'ltalva ',
			},
			{
				j: '8',
				tr: '21',
				code: '0080',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Arroió do Meio',
			},
			{
				j: '8',
				tr: '26',
				code: '0080',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cabreúva ',
			},
		],
		'0082': [
			{
				j: '8',
				tr: '05',
				code: '0082',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'GANDU',
			},
			{
				j: '8',
				tr: '06',
				code: '0082',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Groairas',
			},
			{
				j: '8',
				tr: '08',
				code: '0082',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Serra',
			},
			{
				j: '8',
				tr: '09',
				code: '0082',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ITAJA',
			},
			{
				j: '8',
				tr: '10',
				code: '0082',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Carutapera',
			},
			{
				j: '8',
				tr: '12',
				code: '0082',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Campo Grande',
			},
			{
				j: '8',
				tr: '13',
				code: '0082',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Bonfinópolis de Minas',
			},
			{
				j: '8',
				tr: '16',
				code: '0082',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'MALLET ',
			},
			{
				j: '8',
				tr: '18',
				code: '0082',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Aroazes',
			},
			{
				j: '8',
				tr: '19',
				code: '0082',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Pinheiral ',
			},
			{
				j: '8',
				tr: '21',
				code: '0082',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Arvorezinha',
			},
			{
				j: '8',
				tr: '26',
				code: '0082',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Boituva ',
			},
		],
		'0083': [
			{
				j: '8',
				tr: '05',
				code: '0083',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'GAVIÃO',
			},
			{
				j: '8',
				tr: '06',
				code: '0083',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Guaiuba',
			},
			{
				j: '8',
				tr: '08',
				code: '0083',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Vila Velha',
			},
			{
				j: '8',
				tr: '09',
				code: '0083',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ITAPACI',
			},
			{
				j: '8',
				tr: '10',
				code: '0083',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Cedral',
			},
			{
				j: '8',
				tr: '12',
				code: '0083',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Campo Grande',
			},
			{
				j: '8',
				tr: '13',
				code: '0083',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Borda da Mata',
			},
			{
				j: '8',
				tr: '14',
				code: '0083',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'CURRALINHO',
			},
			{
				j: '8',
				tr: '16',
				code: '0083',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'MAMBORE ',
			},
			{
				j: '8',
				tr: '18',
				code: '0083',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Arraial do Piauí',
			},
			{
				j: '8',
				tr: '19',
				code: '0083',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Japeri ',
			},
			{
				j: '8',
				tr: '21',
				code: '0083',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Bom Jesus',
			},
			{
				j: '8',
				tr: '26',
				code: '0083',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Aguaí ',
			},
		],
		'0084': [
			{
				j: '8',
				tr: '05',
				code: '0084',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'GENTIO DO OURO',
			},
			{
				j: '8',
				tr: '06',
				code: '0084',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Guaraciaba do Norte',
			},
			{
				j: '8',
				tr: '08',
				code: '0084',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Vila Velha',
			},
			{
				j: '8',
				tr: '09',
				code: '0084',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ITAPIRAPUA',
			},
			{
				j: '8',
				tr: '10',
				code: '0084',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Cururupu',
			},
			{
				j: '8',
				tr: '13',
				code: '0084',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Botelhos',
			},
			{
				j: '8',
				tr: '14',
				code: '0084',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'FARO',
			},
			{
				j: '8',
				tr: '16',
				code: '0084',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'MANDAGUACU ',
			},
			{
				j: '8',
				tr: '18',
				code: '0084',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Barro Duro',
			},
			{
				j: '8',
				tr: '19',
				code: '0084',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Carapebus ',
			},
			{
				j: '8',
				tr: '19',
				code: '0084',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Quissamã',
			},
			{
				j: '8',
				tr: '21',
				code: '0084',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Butiá',
			},
			{
				j: '8',
				tr: '26',
				code: '0084',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Campinas ',
			},
		],
		'0085': [
			{
				j: '8',
				tr: '05',
				code: '0085',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'GLÓRIA',
			},
			{
				j: '8',
				tr: '06',
				code: '0085',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Hidrolândia',
			},
			{
				j: '8',
				tr: '08',
				code: '0085',
				courthouse: 'TJES',
				state: 'ES',
				city: 'Vila Velha',
			},
			{
				j: '8',
				tr: '09',
				code: '0085',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ITAPURANGA',
			},
			{
				j: '8',
				tr: '10',
				code: '0085',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Dom Pedro',
			},
			{
				j: '8',
				tr: '12',
				code: '0085',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Campo Grande',
			},
			{
				j: '8',
				tr: '14',
				code: '0085',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'INHANGAPI',
			},
			{
				j: '8',
				tr: '16',
				code: '0085',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'MANDAGUARI ',
			},
			{
				j: '8',
				tr: '18',
				code: '0085',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Bertolínia',
			},
			{
				j: '8',
				tr: '21',
				code: '0085',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Cacequi',
			},
			{
				j: '8',
				tr: '26',
				code: '0085',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
		'0086': [
			{
				j: '8',
				tr: '05',
				code: '0086',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'GOVERNADOR LOMANTO JÚNIOR',
			},
			{
				j: '8',
				tr: '06',
				code: '0086',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Horizonte',
			},
			{
				j: '8',
				tr: '09',
				code: '0086',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ITAUCU',
			},
			{
				j: '8',
				tr: '10',
				code: '0086',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Esperantinópolis',
			},
			{
				j: '8',
				tr: '13',
				code: '0086',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Brasília de Minas',
			},
			{
				j: '8',
				tr: '16',
				code: '0086',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'MANGUEIRINHA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0086',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Bocaína',
			},
			{
				j: '8',
				tr: '21',
				code: '0086',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Cachoeirinha ',
			},
			{
				j: '8',
				tr: '26',
				code: '0086',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
		'0087': [
			{
				j: '8',
				tr: '05',
				code: '0087',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'GOVERNADOR MANGABEIRA',
			},
			{
				j: '8',
				tr: '06',
				code: '0087',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Ibiapina',
			},
			{
				j: '8',
				tr: '09',
				code: '0087',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ITUMBIARA',
			},
			{
				j: '8',
				tr: '10',
				code: '0087',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Governador Eugênio Barros',
			},
			{
				j: '8',
				tr: '14',
				code: '0087',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'LIMOEIRO DO AJURU',
			},
			{
				j: '8',
				tr: '16',
				code: '0087',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'MANOEL RIBAS ',
			},
			{
				j: '8',
				tr: '18',
				code: '0087',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Campinas do Piauí',
			},
			{
				j: '8',
				tr: '19',
				code: '0087',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Alcântara ',
			},
			{
				j: '8',
				tr: '21',
				code: '0087',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Campo Bom',
			},
			{
				j: '8',
				tr: '26',
				code: '0087',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
		'0088': [
			{
				j: '8',
				tr: '05',
				code: '0088',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'GUANAMBI',
			},
			{
				j: '8',
				tr: '06',
				code: '0088',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Ibicuitinga',
			},
			{
				j: '8',
				tr: '09',
				code: '0088',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ITUMBIARA',
			},
			{
				j: '8',
				tr: '10',
				code: '0088',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Governador Nunes Freire',
			},
			{
				j: '8',
				tr: '16',
				code: '0088',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'MARECHAL CÂNDIDO RONDON',
			},
			{
				j: '8',
				tr: '18',
				code: '0088',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Capitão de Campos',
			},
			{
				j: '8',
				tr: '21',
				code: '0088',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Campo Novo',
			},
			{
				j: '8',
				tr: '26',
				code: '0088',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
		'0089': [
			{
				j: '8',
				tr: '05',
				code: '0089',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'GUARATINGA',
			},
			{
				j: '8',
				tr: '06',
				code: '0089',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Icapuí',
			},
			{
				j: '8',
				tr: '09',
				code: '0089',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'IVOLANDIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0089',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Guimarães',
			},
			{
				j: '8',
				tr: '13',
				code: '0089',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Brazópolis',
			},
			{
				j: '8',
				tr: '14',
				code: '0089',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'Melgaço',
			},
			{
				j: '8',
				tr: '16',
				code: '0089',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'MARIALVA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0089',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Caracol',
			},
			{
				j: '8',
				tr: '21',
				code: '0089',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Candelária',
			},
			{
				j: '8',
				tr: '26',
				code: '0089',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
		'0090': [
			{
				j: '8',
				tr: '05',
				code: '0090',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IAÇU',
			},
			{
				j: '8',
				tr: '06',
				code: '0090',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Icó',
			},
			{
				j: '8',
				tr: '09',
				code: '0090',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'JANDAIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0090',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Humbero de Campos',
			},
			{
				j: '8',
				tr: '13',
				code: '0090',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Brumadinho',
			},
			{
				j: '8',
				tr: '14',
				code: '0090',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'PRAINHA',
			},
			{
				j: '8',
				tr: '16',
				code: '0090',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'MARILÂNDIA DO SUL ',
			},
			{
				j: '8',
				tr: '18',
				code: '0090',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Conceição do Canindé',
			},
			{
				j: '8',
				tr: '21',
				code: '0090',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Casca',
			},
			{
				j: '8',
				tr: '23',
				code: '0090',
				courthouse: 'TJRR',
				state: 'RR',
				city: 'Bonfim',
			},
			{
				j: '8',
				tr: '26',
				code: '0090',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
		'0091': [
			{
				j: '8',
				tr: '05',
				code: '0091',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IBICARAÍ',
			},
			{
				j: '8',
				tr: '06',
				code: '0091',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Iguatu',
			},
			{
				j: '8',
				tr: '09',
				code: '0091',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'JARAGUA',
			},
			{
				j: '8',
				tr: '10',
				code: '0091',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Icatu',
			},
			{
				j: '8',
				tr: '13',
				code: '0091',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Bueno Brandão',
			},
			{
				j: '8',
				tr: '14',
				code: '0091',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SALVATERRA',
			},
			{
				j: '8',
				tr: '15',
				code: '0091',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Taperoá',
			},
			{
				j: '8',
				tr: '16',
				code: '0091',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'MARINGA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0091',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Cristalândia do Piauí',
			},
			{
				j: '8',
				tr: '21',
				code: '0091',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Catuípe ',
			},
			{
				j: '8',
				tr: '26',
				code: '0091',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mogi das Cruzes ',
			},
		],
		'0092': [
			{
				j: '8',
				tr: '05',
				code: '0092',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IBICUÍ',
			},
			{
				j: '8',
				tr: '06',
				code: '0092',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Independência ',
			},
			{
				j: '8',
				tr: '09',
				code: '0092',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'JARAGUA',
			},
			{
				j: '8',
				tr: '10',
				code: '0092',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Igarapé Grande',
			},
			{
				j: '8',
				tr: '13',
				code: '0092',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Buenópolis',
			},
			{
				j: '8',
				tr: '16',
				code: '0092',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'MATELANDIA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0092',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Curimatá',
			},
			{
				j: '8',
				tr: '21',
				code: '0092',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Constantina',
			},
		],
		'0093': [
			{
				j: '8',
				tr: '05',
				code: '0093',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IBIQUERA',
			},
			{
				j: '8',
				tr: '06',
				code: '0093',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Ipaporanga',
			},
			{
				j: '8',
				tr: '09',
				code: '0093',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'JATAI',
			},
			{
				j: '8',
				tr: '10',
				code: '0093',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Itinga do Maranhão',
			},
			{
				j: '8',
				tr: '13',
				code: '0093',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Buritis',
			},
			{
				j: '8',
				tr: '14',
				code: '0093',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SANTARÉM',
			},
			{
				j: '8',
				tr: '16',
				code: '0093',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'MATINHOS ',
			},
			{
				j: '8',
				tr: '18',
				code: '0093',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Elizeu Martins',
			},
			{
				j: '8',
				tr: '21',
				code: '0093',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Coronel Bicaco',
			},
			{
				j: '8',
				tr: '26',
				code: '0093',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Guarujá ',
			},
		],
		'0094': [
			{
				j: '8',
				tr: '05',
				code: '0094',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IBIRAPITANGA',
			},
			{
				j: '8',
				tr: '06',
				code: '0094',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Ipaumirim',
			},
			{
				j: '8',
				tr: '09',
				code: '0094',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'JATAI',
			},
			{
				j: '8',
				tr: '10',
				code: '0094',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Loreto',
			},
			{
				j: '8',
				tr: '14',
				code: '0094',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SANTO ANTÔNIO DO TAUÁ',
			},
			{
				j: '8',
				tr: '16',
				code: '0094',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'MEDIANEIRA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0094',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Francinópolis',
			},
			{
				j: '8',
				tr: '21',
				code: '0094',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Crissiumal ',
			},
			{
				j: '8',
				tr: '26',
				code: '0094',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Brodowski ',
			},
		],
		'0095': [
			{
				j: '8',
				tr: '05',
				code: '0095',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IBIRAPUÃ',
			},
			{
				j: '8',
				tr: '06',
				code: '0095',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Ipu',
			},
			{
				j: '8',
				tr: '09',
				code: '0095',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'JOVIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0095',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Magalhães de Almeida',
			},
			{
				j: '8',
				tr: '13',
				code: '0095',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Cabo Verde',
			},
			{
				j: '8',
				tr: '14',
				code: '0095',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SÃO CAETANO DE ODIVELAS',
			},
			{
				j: '8',
				tr: '16',
				code: '0095',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'MORRETES ',
			},
			{
				j: '8',
				tr: '18',
				code: '0095',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Francisco Santos',
			},
			{
				j: '8',
				tr: '21',
				code: '0095',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Estância Velha',
			},
			{
				j: '8',
				tr: '26',
				code: '0095',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Brotas ',
			},
		],
		'0096': [
			{
				j: '8',
				tr: '05',
				code: '0096',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IBIRATAIA',
			},
			{
				j: '8',
				tr: '06',
				code: '0096',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Ipueiras',
			},
			{
				j: '8',
				tr: '09',
				code: '0096',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'JOVIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0096',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Maracaçume',
			},
			{
				j: '8',
				tr: '14',
				code: '0096',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SÃO FRANCISCO DO PARÁ',
			},
			{
				j: '8',
				tr: '16',
				code: '0096',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'NOVA ESPERANCA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0096',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Ipiranga do Piauí',
			},
			{
				j: '8',
				tr: '21',
				code: '0096',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Faxinal do Soturno',
			},
		],
		'0097': [
			{
				j: '8',
				tr: '05',
				code: '0097',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IBITIARA',
			},
			{
				j: '8',
				tr: '06',
				code: '0097',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Iracema',
			},
			{
				j: '8',
				tr: '09',
				code: '0097',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'JUSSARA',
			},
			{
				j: '8',
				tr: '10',
				code: '0097',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Matinha',
			},
			{
				j: '8',
				tr: '13',
				code: '0097',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Cachoeira de Minas',
			},
			{
				j: '8',
				tr: '14',
				code: '0097',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'BENEVIDES',
			},
			{
				j: '8',
				tr: '16',
				code: '0097',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'NOVA FATIMA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0097',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Isaias Coelho',
			},
			{
				j: '8',
				tr: '21',
				code: '0097',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Flores da Cunha',
			},
			{
				j: '8',
				tr: '26',
				code: '0097',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Buritama ',
			},
		],
		'0098': [
			{
				j: '8',
				tr: '05',
				code: '0098',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IBITITÁ',
			},
			{
				j: '8',
				tr: '06',
				code: '0098',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Irauçuba',
			},
			{
				j: '8',
				tr: '09',
				code: '0098',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'JUSSARA',
			},
			{
				j: '8',
				tr: '10',
				code: '0098',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Matões',
			},
			{
				j: '8',
				tr: '16',
				code: '0098',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'NOVA LONDRINA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0098',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Joaquim Pires',
			},
			{
				j: '8',
				tr: '21',
				code: '0098',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Gaurama',
			},
		],
		'0099': [
			{
				j: '8',
				tr: '05',
				code: '0099',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IBOTIRAMA',
			},
			{
				j: '8',
				tr: '06',
				code: '0099',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Itaitinga',
			},
			{
				j: '8',
				tr: '09',
				code: '0099',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'LEOPOLDO DE BULHOES',
			},
			{
				j: '8',
				tr: '10',
				code: '0099',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Mirador',
			},
			{
				j: '8',
				tr: '16',
				code: '0099',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'ORTIGUEIRA ',
			},
			{
				j: '8',
				tr: '21',
				code: '0099',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'General Câmara',
			},
			{
				j: '8',
				tr: '26',
				code: '0099',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Bragança Paulista ',
			},
		],
		'0100': [
			{
				j: '8',
				tr: '05',
				code: '0100',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ICHU',
			},
			{
				j: '8',
				tr: '06',
				code: '0100',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Itapajé',
			},
			{
				j: '8',
				tr: '09',
				code: '0100',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'LUZIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0100',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Mirinzal',
			},
			{
				j: '8',
				tr: '14',
				code: '0100',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'AURORA DO PARÁ',
			},
			{
				j: '8',
				tr: '16',
				code: '0100',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PALMAS ',
			},
			{
				j: '8',
				tr: '21',
				code: '0100',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Giruá',
			},
			{
				j: '8',
				tr: '25',
				code: '0100',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Aquidabã',
			},
			{
				j: '8',
				tr: '26',
				code: '0100',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
		'0101': [
			{
				j: '8',
				tr: '05',
				code: '0101',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IGAPORÃ',
			},
			{
				j: '8',
				tr: '06',
				code: '0101',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Itapipoca',
			},
			{
				j: '8',
				tr: '09',
				code: '0101',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'LUZIANIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0101',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Monção',
			},
			{
				j: '8',
				tr: '12',
				code: '0101',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Dourados',
			},
			{
				j: '8',
				tr: '15',
				code: '0101',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Brejo do Cruz',
			},
			{
				j: '8',
				tr: '16',
				code: '0101',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PALMEIRA ',
			},
			{
				j: '8',
				tr: '21',
				code: '0101',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Gramado',
			},
			{
				j: '8',
				tr: '22',
				code: '0101',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Porto Velho',
			},
			{
				j: '8',
				tr: '25',
				code: '0101',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Amparo do São Francisco',
			},
			{
				j: '8',
				tr: '26',
				code: '0101',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Caçapava ',
			},
		],
		'0102': [
			{
				j: '8',
				tr: '05',
				code: '0102',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IGUAÍ',
			},
			{
				j: '8',
				tr: '06',
				code: '0102',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Itapipoca',
			},
			{
				j: '8',
				tr: '09',
				code: '0102',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'MARA ROSA',
			},
			{
				j: '8',
				tr: '10',
				code: '0102',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Montes Altos',
			},
			{
				j: '8',
				tr: '12',
				code: '0102',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Dourados',
			},
			{
				j: '8',
				tr: '16',
				code: '0102',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PALMITAL ',
			},
			{
				j: '8',
				tr: '21',
				code: '0102',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Guarani Das Missões ',
			},
			{
				j: '8',
				tr: '25',
				code: '0102',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Arauá',
			},
			{
				j: '8',
				tr: '26',
				code: '0102',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cachoeira Paulista ',
			},
		],
		'0103': [
			{
				j: '8',
				tr: '05',
				code: '0103',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ILHÉUS',
			},
			{
				j: '8',
				tr: '06',
				code: '0103',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Itapiúna',
			},
			{
				j: '8',
				tr: '09',
				code: '0103',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'MINACU',
			},
			{
				j: '8',
				tr: '10',
				code: '0103',
				courthouse: 'TJMA',
				state: 'MA',
				city: "Olho D'água das Cunhãs",
			},
			{
				j: '8',
				tr: '13',
				code: '0103',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Caldas',
			},
			{
				j: '8',
				tr: '16',
				code: '0103',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PALOTINA ',
			},
			{
				j: '8',
				tr: '21',
				code: '0103',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Herval',
			},
			{
				j: '8',
				tr: '25',
				code: '0103',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Areia Branca',
			},
			{
				j: '8',
				tr: '26',
				code: '0103',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Caconde ',
			},
		],
		'0104': [
			{
				j: '8',
				tr: '05',
				code: '0104',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'INHAMBUPE',
			},
			{
				j: '8',
				tr: '06',
				code: '0104',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Itarema',
			},
			{
				j: '8',
				tr: '09',
				code: '0104',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'MINACU',
			},
			{
				j: '8',
				tr: '10',
				code: '0104',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Paraibano ',
			},
			{
				j: '8',
				tr: '12',
				code: '0104',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Campo Grande',
			},
			{
				j: '8',
				tr: '14',
				code: '0104',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'BREU BRANCO',
			},
			{
				j: '8',
				tr: '16',
				code: '0104',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PARAÍSO DO NORTE ',
			},
			{
				j: '8',
				tr: '21',
				code: '0104',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Horizontina',
			},
			{
				j: '8',
				tr: '25',
				code: '0104',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Barra dos Coqueiros',
			},
			{
				j: '8',
				tr: '26',
				code: '0104',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cafelândia ',
			},
		],
		'0105': [
			{
				j: '8',
				tr: '05',
				code: '0105',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IPIAÚ',
			},
			{
				j: '8',
				tr: '06',
				code: '0105',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Itatira',
			},
			{
				j: '8',
				tr: '09',
				code: '0105',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'MINEIROS',
			},
			{
				j: '8',
				tr: '10',
				code: '0105',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Parnarama',
			},
			{
				j: '8',
				tr: '12',
				code: '0105',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Campo Grande',
			},
			{
				j: '8',
				tr: '13',
				code: '0105',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Governador Valadares',
			},
			{
				j: '8',
				tr: '14',
				code: '0105',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'CONCÓRDIA DO PARÁ',
			},
			{
				j: '8',
				tr: '16',
				code: '0105',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PARANACITY ',
			},
			{
				j: '8',
				tr: '21',
				code: '0105',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Ibiruba ',
			},
			{
				j: '8',
				tr: '25',
				code: '0105',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Boquim',
			},
		],
		'0106': [
			{
				j: '8',
				tr: '05',
				code: '0106',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IPIRÁ',
			},
			{
				j: '8',
				tr: '06',
				code: '0106',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Jaguaretama',
			},
			{
				j: '8',
				tr: '09',
				code: '0106',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'MINEIROS',
			},
			{
				j: '8',
				tr: '10',
				code: '0106',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Passagem Franca',
			},
			{
				j: '8',
				tr: '13',
				code: '0106',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Cambuí',
			},
			{
				j: '8',
				tr: '16',
				code: '0106',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PARANAGUA ',
			},
			{
				j: '8',
				tr: '21',
				code: '0106',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Iraí',
			},
			{
				j: '8',
				tr: '25',
				code: '0106',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Brejo Grande',
			},
			{
				j: '8',
				tr: '26',
				code: '0106',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Franco da Rocha ',
			},
		],
		'0107': [
			{
				j: '8',
				tr: '05',
				code: '0107',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IRAMAIA',
			},
			{
				j: '8',
				tr: '06',
				code: '0107',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Jaguaribe',
			},
			{
				j: '8',
				tr: '09',
				code: '0107',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'MORRINHOS',
			},
			{
				j: '8',
				tr: '10',
				code: '0107',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Passos Bons',
			},
			{
				j: '8',
				tr: '13',
				code: '0107',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Cambuquira',
			},
			{
				j: '8',
				tr: '14',
				code: '0107',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'DOM ELIZEU',
			},
			{
				j: '8',
				tr: '16',
				code: '0107',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PARANAVAI ',
			},
			{
				j: '8',
				tr: '21',
				code: '0107',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Jaguari',
			},
			{
				j: '8',
				tr: '25',
				code: '0107',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Campo do Brito',
			},
		],
		'0108': [
			{
				j: '8',
				tr: '05',
				code: '0108',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IRAQUARA',
			},
			{
				j: '8',
				tr: '06',
				code: '0108',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Jaguaruana',
			},
			{
				j: '8',
				tr: '09',
				code: '0108',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'MORRINHOS',
			},
			{
				j: '8',
				tr: '10',
				code: '0108',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Pindaré-Mirim',
			},
			{
				j: '8',
				tr: '12',
				code: '0108',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Campo Grande',
			},
			{
				j: '8',
				tr: '16',
				code: '0108',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PATO BRANCO ',
			},
			{
				j: '8',
				tr: '21',
				code: '0108',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Lavras do Sul',
			},
			{
				j: '8',
				tr: '25',
				code: '0108',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Canhoba ',
			},
			{
				j: '8',
				tr: '26',
				code: '0108',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Jundiaí ',
			},
		],
		'0109': [
			{
				j: '8',
				tr: '05',
				code: '0109',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IRARÁ',
			},
			{
				j: '8',
				tr: '06',
				code: '0109',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Jardim',
			},
			{
				j: '8',
				tr: '09',
				code: '0109',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'MOSSAMEDES',
			},
			{
				j: '8',
				tr: '10',
				code: '0109',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Paulo Ramos',
			},
			{
				j: '8',
				tr: '12',
				code: '0109',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Campo Grande',
			},
			{
				j: '8',
				tr: '13',
				code: '0109',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Campanha',
			},
			{
				j: '8',
				tr: '14',
				code: '0109',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'GARRAFÃO DO NORTE',
			},
			{
				j: '8',
				tr: '16',
				code: '0109',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PEABIRU ',
			},
			{
				j: '8',
				tr: '18',
				code: '0109',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Parnaguá',
			},
			{
				j: '8',
				tr: '21',
				code: '0109',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Marau',
			},
			{
				j: '8',
				tr: '25',
				code: '0109',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Canindé de São Francisco',
			},
		],
		'0110': [
			{
				j: '8',
				tr: '05',
				code: '0110',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'IRECÊ',
			},
			{
				j: '8',
				tr: '06',
				code: '0110',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Jati',
			},
			{
				j: '8',
				tr: '09',
				code: '0110',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'MOZARLANDIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0110',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Penalva',
			},
			{
				j: '8',
				tr: '12',
				code: '0110',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Campo Grande',
			},
			{
				j: '8',
				tr: '13',
				code: '0110',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Campestre',
			},
			{
				j: '8',
				tr: '14',
				code: '0110',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'GOIANÉSIA DO PARÁ',
			},
			{
				j: '8',
				tr: '16',
				code: '0110',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PÉROLA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0110',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Pimenteiras',
			},
			{
				j: '8',
				tr: '21',
				code: '0110',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Marcelino Ramos ',
			},
			{
				j: '8',
				tr: '25',
				code: '0110',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Capela',
			},
		],
		'0111': [
			{
				j: '8',
				tr: '05',
				code: '0111',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITABELA',
			},
			{
				j: '8',
				tr: '06',
				code: '0111',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Jijoca de Jericoacoara',
			},
			{
				j: '8',
				tr: '09',
				code: '0111',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'NAZARIO',
			},
			{
				j: '8',
				tr: '10',
				code: '0111',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Pio XII',
			},
			{
				j: '8',
				tr: '13',
				code: '0111',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Campina Verde',
			},
			{
				j: '8',
				tr: '15',
				code: '0111',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Cabaceiras',
			},
			{
				j: '8',
				tr: '16',
				code: '0111',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PINHÃO ',
			},
			{
				j: '8',
				tr: '18',
				code: '0111',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Redenção do Gurgueia',
			},
			{
				j: '8',
				tr: '21',
				code: '0111',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Mostardas ',
			},
			{
				j: '8',
				tr: '25',
				code: '0111',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Carira',
			},
			{
				j: '8',
				tr: '26',
				code: '0111',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cajuru ',
			},
		],
		'0112': [
			{
				j: '8',
				tr: '05',
				code: '0112',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITABERABA',
			},
			{
				j: '8',
				tr: '06',
				code: '0112',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Juazeiro do Norte',
			},
			{
				j: '8',
				tr: '09',
				code: '0112',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'NEROPOLIS',
			},
			{
				j: '8',
				tr: '10',
				code: '0112',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Poção de Pedras',
			},
			{
				j: '8',
				tr: '13',
				code: '0112',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Campo Belo',
			},
			{
				j: '8',
				tr: '14',
				code: '0112',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'JACAREACANGA',
			},
			{
				j: '8',
				tr: '16',
				code: '0112',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PIRAI DO SUL  ',
			},
			{
				j: '8',
				tr: '18',
				code: '0112',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Ribeiro Gonçalves',
			},
			{
				j: '8',
				tr: '21',
				code: '0112',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Não-Me-Toque',
			},
			{
				j: '8',
				tr: '25',
				code: '0112',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Carmópolis',
			},
		],
		'0113': [
			{
				j: '8',
				tr: '05',
				code: '0113',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITABUNA',
			},
			{
				j: '8',
				tr: '06',
				code: '0113',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Jucás',
			},
			{
				j: '8',
				tr: '09',
				code: '0113',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'NIQUELANDIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0113',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Raposa',
			},
			{
				j: '8',
				tr: '12',
				code: '0113',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Corumbá',
			},
			{
				j: '8',
				tr: '16',
				code: '0113',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PITANGA',
			},
			{
				j: '8',
				tr: '18',
				code: '0113',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Santa Cruz do Piauí',
			},
			{
				j: '8',
				tr: '21',
				code: '0113',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Nonoai',
			},
			{
				j: '8',
				tr: '25',
				code: '0113',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Cedri de São Paulo',
			},
		],
		'0114': [
			{
				j: '8',
				tr: '05',
				code: '0114',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITACARÉ',
			},
			{
				j: '8',
				tr: '06',
				code: '0114',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Lavras de Mangabeira',
			},
			{
				j: '8',
				tr: '09',
				code: '0114',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'NIQUELANDIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0114',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Riachão',
			},
			{
				j: '8',
				tr: '12',
				code: '0114',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Três Lagoas',
			},
			{
				j: '8',
				tr: '13',
				code: '0114',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Ibirité',
			},
			{
				j: '8',
				tr: '16',
				code: '0114',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PONTA GROSSA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0114',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Santa Filomena',
			},
			{
				j: '8',
				tr: '21',
				code: '0114',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Nova Petrópolis ',
			},
			{
				j: '8',
				tr: '25',
				code: '0114',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Cistinápolis',
			},
			{
				j: '8',
				tr: '26',
				code: '0114',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Campinas ',
			},
		],
		'0115': [
			{
				j: '8',
				tr: '05',
				code: '0115',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITAETÉ',
			},
			{
				j: '8',
				tr: '06',
				code: '0115',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Limoeiro do Norte',
			},
			{
				j: '8',
				tr: '09',
				code: '0115',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ORIZONA',
			},
			{
				j: '8',
				tr: '10',
				code: '0115',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Rosário',
			},
			{
				j: '8',
				tr: '12',
				code: '0115',
				courthouse: 'TJMS',
				state: 'MS',
				city: 'Campo Grande',
			},
			{
				j: '8',
				tr: '13',
				code: '0115',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Campos Altos',
			},
			{
				j: '8',
				tr: '14',
				code: '0115',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'NOVO PROGRESSO',
			},
			{
				j: '8',
				tr: '16',
				code: '0115',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PORECATU',
			},
			{
				j: '8',
				tr: '18',
				code: '0115',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'São Felix do Piauí',
			},
			{
				j: '8',
				tr: '21',
				code: '0115',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Pedro Osório',
			},
			{
				j: '8',
				tr: '25',
				code: '0115',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Cumbe',
			},
			{
				j: '8',
				tr: '26',
				code: '0115',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Jundiaí ',
			},
		],
		'0116': [
			{
				j: '8',
				tr: '05',
				code: '0116',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITAGI',
			},
			{
				j: '8',
				tr: '06',
				code: '0116',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Madalena',
			},
			{
				j: '8',
				tr: '09',
				code: '0116',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PADRE BERNARDO',
			},
			{
				j: '8',
				tr: '10',
				code: '0116',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Santa Luzia do Paruá',
			},
			{
				j: '8',
				tr: '13',
				code: '0116',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Campos Gerais',
			},
			{
				j: '8',
				tr: '14',
				code: '0116',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'OUROLÂNDIA DO NORTE',
			},
			{
				j: '8',
				tr: '16',
				code: '0116',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PRIMEIRO DE MAIO',
			},
			{
				j: '8',
				tr: '18',
				code: '0116',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'São Gonçalo do Piauí',
			},
			{
				j: '8',
				tr: '21',
				code: '0116',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Planalto',
			},
			{
				j: '8',
				tr: '25',
				code: '0116',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Divina Pastora',
			},
			{
				j: '8',
				tr: '26',
				code: '0116',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Campos do Jordão ',
			},
		],
		'0117': [
			{
				j: '8',
				tr: '05',
				code: '0117',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITAGIBÁ',
			},
			{
				j: '8',
				tr: '06',
				code: '0117',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Maracanaú',
			},
			{
				j: '8',
				tr: '09',
				code: '0117',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PALMEIRAS DE GOIAS',
			},
			{
				j: '8',
				tr: '10',
				code: '0117',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Santa Quitéria do Maranhão',
			},
			{
				j: '8',
				tr: '16',
				code: '0117',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'PRUDENTÓPOLIS',
			},
			{
				j: '8',
				tr: '18',
				code: '0117',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Socorro do Piauí',
			},
			{
				j: '8',
				tr: '21',
				code: '0117',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Pinheiro Machado ',
			},
			{
				j: '8',
				tr: '25',
				code: '0117',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Feira Nova',
			},
		],
		'0118': [
			{
				j: '8',
				tr: '05',
				code: '0118',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITAGIMIRIM',
			},
			{
				j: '8',
				tr: '06',
				code: '0118',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Maracanaú',
			},
			{
				j: '8',
				tr: '09',
				code: '0118',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PANAMA',
			},
			{
				j: '8',
				tr: '10',
				code: '0118',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Santa Rita',
			},
			{
				j: '8',
				tr: '13',
				code: '0118',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Canápolis',
			},
			{
				j: '8',
				tr: '16',
				code: '0118',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'QUEDAS DO IGUAÇU',
			},
			{
				j: '8',
				tr: '18',
				code: '0118',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Várzea Grande',
			},
			{
				j: '8',
				tr: '21',
				code: '0118',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Piratini',
			},
			{
				j: '8',
				tr: '25',
				code: '0118',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Frei Paulo',
			},
			{
				j: '8',
				tr: '26',
				code: '0118',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cananéia ',
			},
		],
		'0119': [
			{
				j: '8',
				tr: '05',
				code: '0119',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITAJUÍPE',
			},
			{
				j: '8',
				tr: '06',
				code: '0119',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Maranguape',
			},
			{
				j: '8',
				tr: '09',
				code: '0119',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PARANAIGUARA',
			},
			{
				j: '8',
				tr: '10',
				code: '0119',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Santo Antônio dos Lopes',
			},
			{
				j: '8',
				tr: '16',
				code: '0119',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'REALEZA',
			},
			{
				j: '8',
				tr: '18',
				code: '0119',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Corrente',
			},
			{
				j: '8',
				tr: '21',
				code: '0119',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Porto Xavier',
			},
			{
				j: '8',
				tr: '25',
				code: '0119',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Garau',
			},
		],
		'0120': [
			{
				j: '8',
				tr: '05',
				code: '0120',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITAMARAJU',
			},
			{
				j: '8',
				tr: '06',
				code: '0120',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Marco',
			},
			{
				j: '8',
				tr: '09',
				code: '0120',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PARAUNA',
			},
			{
				j: '8',
				tr: '10',
				code: '0120',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Bento ',
			},
			{
				j: '8',
				tr: '13',
				code: '0120',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Candeias',
			},
			{
				j: '8',
				tr: '16',
				code: '0120',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'REBOUÇAS',
			},
			{
				j: '8',
				tr: '18',
				code: '0120',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Corrente',
			},
			{
				j: '8',
				tr: '21',
				code: '0120',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Sananduva',
			},
			{
				j: '8',
				tr: '25',
				code: '0120',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'General Maynard',
			},
			{
				j: '8',
				tr: '26',
				code: '0120',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cândido Mota ',
			},
		],
		'0121': [
			{
				j: '8',
				tr: '05',
				code: '0121',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITAMARI',
			},
			{
				j: '8',
				tr: '06',
				code: '0121',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Massapê',
			},
			{
				j: '8',
				tr: '09',
				code: '0121',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PARAUNA',
			},
			{
				j: '8',
				tr: '10',
				code: '0121',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Bernardo',
			},
			{
				j: '8',
				tr: '14',
				code: '0121',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SANTA LUZIA DO PARÁ',
			},
			{
				j: '8',
				tr: '15',
				code: '0121',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Caiçara',
			},
			{
				j: '8',
				tr: '16',
				code: '0121',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'RESERVA',
			},
			{
				j: '8',
				tr: '18',
				code: '0121',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Floriano',
			},
			{
				j: '8',
				tr: '21',
				code: '0121',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Santa Bárbara do Sul',
			},
			{
				j: '8',
				tr: '25',
				code: '0121',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Graccho Cardoso',
			},
		],
		'0122': [
			{
				j: '8',
				tr: '05',
				code: '0122',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITAMBÉ',
			},
			{
				j: '8',
				tr: '06',
				code: '0122',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Mauriti',
			},
			{
				j: '8',
				tr: '09',
				code: '0122',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PETROLINA DE GOIAS',
			},
			{
				j: '8',
				tr: '10',
				code: '0122',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Domingos do Azeitão',
			},
			{
				j: '8',
				tr: '16',
				code: '0122',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'RIBEIRAO CLARO',
			},
			{
				j: '8',
				tr: '18',
				code: '0122',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Floriano',
			},
			{
				j: '8',
				tr: '21',
				code: '0122',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Santo Antônio das Missões',
			},
			{
				j: '8',
				tr: '25',
				code: '0122',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Ilha das Flores',
			},
		],
		'0123': [
			{
				j: '8',
				tr: '05',
				code: '0123',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITANHÉM',
			},
			{
				j: '8',
				tr: '06',
				code: '0123',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Meruoca',
			},
			{
				j: '8',
				tr: '09',
				code: '0123',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PIRACANJUBA',
			},
			{
				j: '8',
				tr: '10',
				code: '0123',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Domingos do Maranhão',
			},
			{
				j: '8',
				tr: '13',
				code: '0123',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Capelinha',
			},
			{
				j: '8',
				tr: '14',
				code: '0123',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'NOVO REPARTIMENTO',
			},
			{
				j: '8',
				tr: '16',
				code: '0123',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'RIBEIRÃO DO PINHAL',
			},
			{
				j: '8',
				tr: '18',
				code: '0123',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'José de Freitas',
			},
			{
				j: '8',
				tr: '21',
				code: '0123',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Santo Augusto',
			},
			{
				j: '8',
				tr: '25',
				code: '0123',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Indiaroba',
			},
			{
				j: '8',
				tr: '26',
				code: '0123',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Capão Bonito ',
			},
		],
		'0124': [
			{
				j: '8',
				tr: '05',
				code: '0124',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITAPARICA',
			},
			{
				j: '8',
				tr: '06',
				code: '0124',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Milagres',
			},
			{
				j: '8',
				tr: '09',
				code: '0124',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PIRACANJUBA',
			},
			{
				j: '8',
				tr: '10',
				code: '0124',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Francisco do Maranhão',
			},
			{
				j: '8',
				tr: '14',
				code: '0124',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SÃO DOMINGOS DO ARAGUAIA',
			},
			{
				j: '8',
				tr: '16',
				code: '0124',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'RIO BRANCO DO SUL ',
			},
			{
				j: '8',
				tr: '18',
				code: '0124',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Parnaíba',
			},
			{
				j: '8',
				tr: '21',
				code: '0124',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Santo Cristo',
			},
			{
				j: '8',
				tr: '25',
				code: '0124',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Itabaininha',
			},
		],
		'0125': [
			{
				j: '8',
				tr: '05',
				code: '0125',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITAPEBI',
			},
			{
				j: '8',
				tr: '06',
				code: '0125',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Missão Velha',
			},
			{
				j: '8',
				tr: '09',
				code: '0125',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PIRANHAS',
			},
			{
				j: '8',
				tr: '10',
				code: '0125',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São João Batista',
			},
			{
				j: '8',
				tr: '14',
				code: '0125',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'SÃO GERALDO DO ARAGUAIA',
			},
			{
				j: '8',
				tr: '16',
				code: '0125',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'RIO NEGRO ',
			},
			{
				j: '8',
				tr: '18',
				code: '0125',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Parnaíba',
			},
			{
				j: '8',
				tr: '21',
				code: '0125',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'São Francisco de Assis',
			},
			{
				j: '8',
				tr: '25',
				code: '0125',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Itabi',
			},
			{
				j: '8',
				tr: '26',
				code: '0125',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Capivari ',
			},
		],
		'0126': [
			{
				j: '8',
				tr: '05',
				code: '0126',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITAPETINGA',
			},
			{
				j: '8',
				tr: '06',
				code: '0126',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Mombaça',
			},
			{
				j: '8',
				tr: '09',
				code: '0126',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PIRENOPOLIS',
			},
			{
				j: '8',
				tr: '10',
				code: '0126',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São João dos Patos',
			},
			{
				j: '8',
				tr: '13',
				code: '0126',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Capinópolis',
			},
			{
				j: '8',
				tr: '16',
				code: '0126',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'ROLANDIA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0126',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Parnaíba',
			},
			{
				j: '8',
				tr: '21',
				code: '0126',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'São José do Norte',
			},
			{
				j: '8',
				tr: '25',
				code: '0126',
				courthouse: 'TJSE',
				state: 'SE',
				city: "Itaporanga D'Ajuda ",
			},
			{
				j: '8',
				tr: '26',
				code: '0126',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Caraguatatuba ',
			},
		],
		'0127': [
			{
				j: '8',
				tr: '05',
				code: '0127',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITAPICURU',
			},
			{
				j: '8',
				tr: '06',
				code: '0127',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Monsenhor Tabosa',
			},
			{
				j: '8',
				tr: '09',
				code: '0127',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PIRES DO RIO',
			},
			{
				j: '8',
				tr: '10',
				code: '0127',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Luis Gonzaga do Maranhão',
			},
			{
				j: '8',
				tr: '16',
				code: '0127',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SAL TO DO LONTRA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0127',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Altos ',
			},
			{
				j: '8',
				tr: '21',
				code: '0127',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'São José do Ouro',
			},
			{
				j: '8',
				tr: '25',
				code: '0127',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Japaratuba',
			},
			{
				j: '8',
				tr: '26',
				code: '0127',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Carapicuíba ',
			},
		],
		'0128': [
			{
				j: '8',
				tr: '05',
				code: '0128',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITAPITANGA',
			},
			{
				j: '8',
				tr: '06',
				code: '0128',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Morada Nova',
			},
			{
				j: '8',
				tr: '09',
				code: '0128',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PLANALTINA',
			},
			{
				j: '8',
				tr: '10',
				code: '0128',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Mateus',
			},
			{
				j: '8',
				tr: '14',
				code: '0128',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'TERRA SANTA',
			},
			{
				j: '8',
				tr: '16',
				code: '0128',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SANTA FÉ',
			},
			{
				j: '8',
				tr: '18',
				code: '0128',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Barras',
			},
			{
				j: '8',
				tr: '21',
				code: '0128',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'São Marcos',
			},
			{
				j: '8',
				tr: '25',
				code: '0128',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Japoatá',
			},
			{
				j: '8',
				tr: '26',
				code: '0128',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cardoso ',
			},
		],
		'0129': [
			{
				j: '8',
				tr: '05',
				code: '0129',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITAQUARA',
			},
			{
				j: '8',
				tr: '06',
				code: '0129',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Morrinhos',
			},
			{
				j: '8',
				tr: '09',
				code: '0129',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PONTALINA',
			},
			{
				j: '8',
				tr: '10',
				code: '0129',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Raimundo das Mangabeiras',
			},
			{
				j: '8',
				tr: '16',
				code: '0129',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SANTA HELENA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0129',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Barras',
			},
			{
				j: '8',
				tr: '21',
				code: '0129',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'São Pedro do Sul',
			},
			{
				j: '8',
				tr: '25',
				code: '0129',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Laranjeiras',
			},
			{
				j: '8',
				tr: '26',
				code: '0129',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Casa Branca ',
			},
		],
		'0130': [
			{
				j: '8',
				tr: '05',
				code: '0130',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITARANTIM',
			},
			{
				j: '8',
				tr: '06',
				code: '0130',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Mucambo',
			},
			{
				j: '8',
				tr: '09',
				code: '0130',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PORANGATU',
			},
			{
				j: '8',
				tr: '10',
				code: '0130',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'São Vicente Ferrer',
			},
			{
				j: '8',
				tr: '14',
				code: '0130',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'ULIANÓPOLIS',
			},
			{
				j: '8',
				tr: '16',
				code: '0130',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SANTA IZABEL DO IVAI ',
			},
			{
				j: '8',
				tr: '18',
				code: '0130',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Bom Jesus',
			},
			{
				j: '8',
				tr: '21',
				code: '0130',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'São Sepé',
			},
			{
				j: '8',
				tr: '25',
				code: '0130',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Macambira',
			},
		],
		'0131': [
			{
				j: '8',
				tr: '05',
				code: '0131',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITIRUÇU',
			},
			{
				j: '8',
				tr: '06',
				code: '0131',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Mulungu',
			},
			{
				j: '8',
				tr: '09',
				code: '0131',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'PORANGATU',
			},
			{
				j: '8',
				tr: '10',
				code: '0131',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Senador La Roque',
			},
			{
				j: '8',
				tr: '15',
				code: '0131',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Cajazeiras',
			},
			{
				j: '8',
				tr: '16',
				code: '0131',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SANTA MARIANA ',
			},
			{
				j: '8',
				tr: '18',
				code: '0131',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Paulistana ',
			},
			{
				j: '8',
				tr: '21',
				code: '0131',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'São Vicente do Sul',
			},
			{
				j: '8',
				tr: '25',
				code: '0131',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Malhada dos Bois',
			},
		],
		'0132': [
			{
				j: '8',
				tr: '05',
				code: '0132',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITIÚBA',
			},
			{
				j: '8',
				tr: '06',
				code: '0132',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Nova Olinda',
			},
			{
				j: '8',
				tr: '09',
				code: '0132',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'POSSE',
			},
			{
				j: '8',
				tr: '10',
				code: '0132',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Sucupira do Norte',
			},
			{
				j: '8',
				tr: '13',
				code: '0132',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Carandaí',
			},
			{
				j: '8',
				tr: '16',
				code: '0132',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SANTO ANTÔNIO DA PLATINA',
			},
			{
				j: '8',
				tr: '18',
				code: '0132',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Pedro II',
			},
			{
				j: '8',
				tr: '21',
				code: '0132',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Sapiranga ',
			},
			{
				j: '8',
				tr: '25',
				code: '0132',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Malhador ',
			},
			{
				j: '8',
				tr: '26',
				code: '0132',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Catanduva ',
			},
		],
		'0133': [
			{
				j: '8',
				tr: '05',
				code: '0133',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITORORÓ',
			},
			{
				j: '8',
				tr: '06',
				code: '0133',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Nova Russas',
			},
			{
				j: '8',
				tr: '09',
				code: '0133',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'POSSE',
			},
			{
				j: '8',
				tr: '10',
				code: '0133',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Tasso Fragoso',
			},
			{
				j: '8',
				tr: '13',
				code: '0133',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Carangola',
			},
			{
				j: '8',
				tr: '14',
				code: '0133',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'MARITUBA',
			},
			{
				j: '8',
				tr: '16',
				code: '0133',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SANTO ANTÔNIO DO SUDOESTE',
			},
			{
				j: '8',
				tr: '18',
				code: '0133',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'São Raimundo Nonato',
			},
			{
				j: '8',
				tr: '21',
				code: '0133',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Seberi',
			},
			{
				j: '8',
				tr: '25',
				code: '0133',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Maruim',
			},
		],
		'0134': [
			{
				j: '8',
				tr: '05',
				code: '0134',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITUAÇU',
			},
			{
				j: '8',
				tr: '06',
				code: '0134',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Novo Oriente',
			},
			{
				j: '8',
				tr: '09',
				code: '0134',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'QUIRINOPOLIS',
			},
			{
				j: '8',
				tr: '10',
				code: '0134',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Timbiras',
			},
			{
				j: '8',
				tr: '13',
				code: '0134',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Caratinga',
			},
			{
				j: '8',
				tr: '16',
				code: '0134',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SÃO JERÔNIMO DA SERRA',
			},
			{
				j: '8',
				tr: '18',
				code: '0134',
				courthouse: 'TJPI',
				state: 'PI',
				city: 'Valença',
			},
			{
				j: '8',
				tr: '21',
				code: '0134',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Sobradinho',
			},
			{
				j: '8',
				tr: '25',
				code: '0134',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Moita Bonita',
			},
		],
		'0135': [
			{
				j: '8',
				tr: '05',
				code: '0135',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'ITUBERÁ',
			},
			{
				j: '8',
				tr: '06',
				code: '0135',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Orós',
			},
			{
				j: '8',
				tr: '09',
				code: '0135',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'QUIRINOPOLIS',
			},
			{
				j: '8',
				tr: '10',
				code: '0135',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Tuntum',
			},
			{
				j: '8',
				tr: '16',
				code: '0135',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SAO JOAO DO IVAI ',
			},
			{
				j: '8',
				tr: '21',
				code: '0135',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Tapejara',
			},
			{
				j: '8',
				tr: '25',
				code: '0135',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Monte Alegre',
			},
		],
		'0136': [
			{
				j: '8',
				tr: '05',
				code: '0136',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'JACARACI',
			},
			{
				j: '8',
				tr: '06',
				code: '0136',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Pacajus',
			},
			{
				j: '8',
				tr: '09',
				code: '0136',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'RIALMA',
			},
			{
				j: '8',
				tr: '10',
				code: '0136',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Turiaçu',
			},
			{
				j: '8',
				tr: '14',
				code: '0136',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'CANAÃ DOS CARAJAS',
			},
			{
				j: '8',
				tr: '16',
				code: '0136',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SÃO JOÃO DO TRIUNFO',
			},
			{
				j: '8',
				tr: '21',
				code: '0136',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Tapera',
			},
			{
				j: '8',
				tr: '25',
				code: '0136',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Muribeca',
			},
			{
				j: '8',
				tr: '26',
				code: '0136',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cerqueira César ',
			},
		],
		'0137': [
			{
				j: '8',
				tr: '05',
				code: '0137',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'JACOBINA',
			},
			{
				j: '8',
				tr: '06',
				code: '0137',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Pacatuba',
			},
			{
				j: '8',
				tr: '09',
				code: '0137',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'RIO VERDE',
			},
			{
				j: '8',
				tr: '10',
				code: '0137',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Tutoia',
			},
			{
				j: '8',
				tr: '13',
				code: '0137',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Carlos Chagas',
			},
			{
				j: '8',
				tr: '16',
				code: '0137',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SAO MATEUS DO SUL ',
			},
			{
				j: '8',
				tr: '21',
				code: '0137',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Tapes',
			},
			{
				j: '8',
				tr: '25',
				code: '0137',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Nossa Senhora da Glória',
			},
			{
				j: '8',
				tr: '26',
				code: '0137',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cerquilho ',
			},
		],
		'0138': [
			{
				j: '8',
				tr: '05',
				code: '0138',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'JAGUAQUARA',
			},
			{
				j: '8',
				tr: '06',
				code: '0138',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Pacoti',
			},
			{
				j: '8',
				tr: '09',
				code: '0138',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'RIO VERDE',
			},
			{
				j: '8',
				tr: '10',
				code: '0138',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Urbano Santos',
			},
			{
				j: '8',
				tr: '16',
				code: '0138',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SÃO MIGUEL DO IGUAÇU',
			},
			{
				j: '8',
				tr: '21',
				code: '0138',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Tenente Portela',
			},
			{
				j: '8',
				tr: '25',
				code: '0138',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Nossa Senhora das Dores',
			},
		],
		'0139': [
			{
				j: '8',
				tr: '05',
				code: '0139',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'JAGUARARI',
			},
			{
				j: '8',
				tr: '06',
				code: '0139',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Palmácia',
			},
			{
				j: '8',
				tr: '09',
				code: '0139',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'RUBIATABA',
			},
			{
				j: '8',
				tr: '10',
				code: '0139',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Vargem Grande',
			},
			{
				j: '8',
				tr: '16',
				code: '0139',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SARANDI ',
			},
			{
				j: '8',
				tr: '21',
				code: '0139',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Triunfo',
			},
			{
				j: '8',
				tr: '25',
				code: '0139',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Nossa Senhora de Lourdes ',
			},
		],
		'0140': [
			{
				j: '8',
				tr: '05',
				code: '0140',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'JAGUARIPE',
			},
			{
				j: '8',
				tr: '06',
				code: '0140',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Paracuru',
			},
			{
				j: '8',
				tr: '09',
				code: '0140',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'SANCLERLANDIA',
			},
			{
				j: '8',
				tr: '10',
				code: '0140',
				courthouse: 'TJMA',
				state: 'MA',
				city: 'Vitória do Mearim',
			},
			{
				j: '8',
				tr: '13',
				code: '0140',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Carmo da Mata',
			},
			{
				j: '8',
				tr: '16',
				code: '0140',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SENGES ',
			},
			{
				j: '8',
				tr: '21',
				code: '0140',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Barra do Ribeiro ',
			},
			{
				j: '8',
				tr: '25',
				code: '0140',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Nossa Senhora de Aparecida ',
			},
			{
				j: '8',
				tr: '26',
				code: '0140',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Chavantes ',
			},
		],
		'0141': [
			{
				j: '8',
				tr: '05',
				code: '0141',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'JEQUIÉ',
			},
			{
				j: '8',
				tr: '06',
				code: '0141',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Paraipaba',
			},
			{
				j: '8',
				tr: '09',
				code: '0141',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'SANTA CRUZ DE GOIAS',
			},
			{
				j: '8',
				tr: '13',
				code: '0141',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Carmo de Minas',
			},
			{
				j: '8',
				tr: '15',
				code: '0141',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Catolé do Rocha',
			},
			{
				j: '8',
				tr: '16',
				code: '0141',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SERTANÓPOLIS ',
			},
			{
				j: '8',
				tr: '21',
				code: '0141',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Capão da Canoa',
			},
			{
				j: '8',
				tr: '25',
				code: '0141',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Néopolis',
			},
		],
		'0142': [
			{
				j: '8',
				tr: '05',
				code: '0142',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'JEREMOABO',
			},
			{
				j: '8',
				tr: '06',
				code: '0142',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Parambu',
			},
			{
				j: '8',
				tr: '09',
				code: '0142',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'SANTA HELENA DE GOIAS',
			},
			{
				j: '8',
				tr: '13',
				code: '0142',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Carmo de Cajuru',
			},
			{
				j: '8',
				tr: '16',
				code: '0142',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'SIQUEIRA CAMPOS ',
			},
			{
				j: '8',
				tr: '21',
				code: '0142',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Igrejinha ',
			},
			{
				j: '8',
				tr: '25',
				code: '0142',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Pacatuba',
			},
			{
				j: '8',
				tr: '26',
				code: '0142',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Colina ',
			},
		],
		'0143': [
			{
				j: '8',
				tr: '05',
				code: '0143',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'JIQUIRIÇÁ',
			},
			{
				j: '8',
				tr: '06',
				code: '0143',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Pedra Branca',
			},
			{
				j: '8',
				tr: '09',
				code: '0143',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'SAO MIGUEL DO ARAGUAIA',
			},
			{
				j: '8',
				tr: '13',
				code: '0143',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Carmo do Paranaíba',
			},
			{
				j: '8',
				tr: '16',
				code: '0143',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'TEIXEIRA SOARES ',
			},
			{
				j: '8',
				tr: '21',
				code: '0143',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Arroio do Tigre',
			},
			{
				j: '8',
				tr: '25',
				code: '0143',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Pedra Mole',
			},
		],
		'0144': [
			{
				j: '8',
				tr: '05',
				code: '0144',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'JITAÚNA',
			},
			{
				j: '8',
				tr: '06',
				code: '0144',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Pentecoste',
			},
			{
				j: '8',
				tr: '09',
				code: '0144',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'SILVANIA',
			},
			{
				j: '8',
				tr: '13',
				code: '0144',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Carmo do Rio Claro',
			},
			{
				j: '8',
				tr: '16',
				code: '0144',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'TELÊMACO BORBA ',
			},
			{
				j: '8',
				tr: '21',
				code: '0144',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Carlos Barbosa',
			},
			{
				j: '8',
				tr: '25',
				code: '0144',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Pedrinhas',
			},
			{
				j: '8',
				tr: '26',
				code: '0144',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mogi-Mirim ',
			},
		],
		'0145': [
			{
				j: '8',
				tr: '05',
				code: '0145',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'JOÃO DOURADO',
			},
			{
				j: '8',
				tr: '06',
				code: '0145',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Pereiro',
			},
			{
				j: '8',
				tr: '09',
				code: '0145',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'SAO DOMINGOS',
			},
			{
				j: '8',
				tr: '13',
				code: '0145',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Juiz de Fora',
			},
			{
				j: '8',
				tr: '16',
				code: '0145',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'TERRA BOA ',
			},
			{
				j: '8',
				tr: '21',
				code: '0145',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Dois Irmãos',
			},
			{
				j: '8',
				tr: '25',
				code: '0145',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Pinhão',
			},
			{
				j: '8',
				tr: '26',
				code: '0145',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Conchas ',
			},
		],
		'0146': [
			{
				j: '8',
				tr: '05',
				code: '0146',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'JUAZEIRO',
			},
			{
				j: '8',
				tr: '06',
				code: '0146',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Pindoretama',
			},
			{
				j: '8',
				tr: '09',
				code: '0146',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'SAO LUIS DE MONTES BELOS',
			},
			{
				j: '8',
				tr: '16',
				code: '0146',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'TERRA RICA ',
			},
			{
				j: '8',
				tr: '21',
				code: '0146',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Feliz',
			},
			{
				j: '8',
				tr: '25',
				code: '0146',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Pirambu',
			},
			{
				j: '8',
				tr: '26',
				code: '0146',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cordeirópolis ',
			},
		],
		'0147': [
			{
				j: '8',
				tr: '05',
				code: '0147',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'JUSSARA',
			},
			{
				j: '8',
				tr: '06',
				code: '0147',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Piquet Carneiro',
			},
			{
				j: '8',
				tr: '09',
				code: '0147',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'SAO LUIS DE MONTES BELOS',
			},
			{
				j: '8',
				tr: '16',
				code: '0147',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'TERRA ROXA ',
			},
			{
				j: '8',
				tr: '21',
				code: '0147',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Restinga Seca ',
			},
			{
				j: '8',
				tr: '25',
				code: '0147',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Poço Redondo',
			},
		],
		'0148': [
			{
				j: '8',
				tr: '05',
				code: '0148',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'LAJE',
			},
			{
				j: '8',
				tr: '06',
				code: '0148',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Poranga',
			},
			{
				j: '8',
				tr: '09',
				code: '0148',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'TAQUARAL DE GOIAS',
			},
			{
				j: '8',
				tr: '13',
				code: '0148',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Lagoa Santa',
			},
			{
				j: '8',
				tr: '16',
				code: '0148',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'TIBAGI ',
			},
			{
				j: '8',
				tr: '21',
				code: '0148',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Ronda Alta ',
			},
			{
				j: '8',
				tr: '25',
				code: '0148',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Poço Verde',
			},
		],
		'0149': [
			{
				j: '8',
				tr: '05',
				code: '0149',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'LAPÃO',
			},
			{
				j: '8',
				tr: '06',
				code: '0149',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Porteiras',
			},
			{
				j: '8',
				tr: '09',
				code: '0149',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'TRINDADE',
			},
			{
				j: '8',
				tr: '16',
				code: '0149',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'TOLEDO ',
			},
			{
				j: '8',
				tr: '21',
				code: '0149',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Augusto Pestana',
			},
			{
				j: '8',
				tr: '25',
				code: '0149',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Porto da Folha',
			},
		],
		'0150': [
			{
				j: '8',
				tr: '05',
				code: '0150',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'LAURO DE FREITAS',
			},
			{
				j: '8',
				tr: '06',
				code: '0150',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Quiterianópolis',
			},
			{
				j: '8',
				tr: '09',
				code: '0150',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'TRINDADE',
			},
			{
				j: '8',
				tr: '16',
				code: '0150',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'TOMAZINA ',
			},
			{
				j: '8',
				tr: '21',
				code: '0150',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Campina das Missões',
			},
			{
				j: '8',
				tr: '25',
				code: '0150',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Propriá',
			},
			{
				j: '8',
				tr: '26',
				code: '0150',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cosmópolis ',
			},
		],
		'0151': [
			{
				j: '8',
				tr: '05',
				code: '0151',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'LENÇÓIS',
			},
			{
				j: '8',
				tr: '06',
				code: '0151',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Quixadá',
			},
			{
				j: '8',
				tr: '09',
				code: '0151',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'TURVANIA',
			},
			{
				j: '8',
				tr: '13',
				code: '0151',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Cássia',
			},
			{
				j: '8',
				tr: '15',
				code: '0151',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Conceição',
			},
			{
				j: '8',
				tr: '16',
				code: '0151',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'UBIRATA ',
			},
			{
				j: '8',
				tr: '21',
				code: '0151',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Palmares do Sul',
			},
			{
				j: '8',
				tr: '25',
				code: '0151',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Riachão do Dantas',
			},
		],
		'0152': [
			{
				j: '8',
				tr: '05',
				code: '0152',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'LICÍNIO DE ALMEIDA',
			},
			{
				j: '8',
				tr: '06',
				code: '0152',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Quixadá',
			},
			{
				j: '8',
				tr: '09',
				code: '0152',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'URUACU',
			},
			{
				j: '8',
				tr: '16',
				code: '0152',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'UMUARAMA ',
			},
			{
				j: '8',
				tr: '21',
				code: '0152',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'São Valentim',
			},
			{
				j: '8',
				tr: '25',
				code: '0152',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Riachuelo',
			},
			{
				j: '8',
				tr: '26',
				code: '0152',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cotia ',
			},
		],
		'0153': [
			{
				j: '8',
				tr: '05',
				code: '0153',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'LIVRAMENTO DE NOSSA SENHORA',
			},
			{
				j: '8',
				tr: '06',
				code: '0153',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Quixelô',
			},
			{
				j: '8',
				tr: '09',
				code: '0153',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'URUACU',
			},
			{
				j: '8',
				tr: '13',
				code: '0153',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Cataguases',
			},
			{
				j: '8',
				tr: '16',
				code: '0153',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'UNIAO DA VITORIA ',
			},
			{
				j: '8',
				tr: '21',
				code: '0153',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Tucunduva',
			},
			{
				j: '8',
				tr: '25',
				code: '0153',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Ribeirópolis ',
			},
			{
				j: '8',
				tr: '25',
				code: '0153',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Rosário do Catete',
			},
			{
				j: '8',
				tr: '26',
				code: '0153',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cravinhos ',
			},
		],
		'0154': [
			{
				j: '8',
				tr: '05',
				code: '0154',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'LUIS EDUARDO MAGALHÃES',
			},
			{
				j: '8',
				tr: '06',
				code: '0154',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Quixeramobim',
			},
			{
				j: '8',
				tr: '09',
				code: '0154',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'URUANA',
			},
			{
				j: '8',
				tr: '16',
				code: '0154',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'URAI ',
			},
			{
				j: '8',
				tr: '21',
				code: '0154',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Agudo',
			},
		],
		'0155': [
			{
				j: '8',
				tr: '05',
				code: '0155',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MACARANI',
			},
			{
				j: '8',
				tr: '06',
				code: '0155',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Quixeré',
			},
			{
				j: '8',
				tr: '09',
				code: '0155',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'URUTAI',
			},
			{
				j: '8',
				tr: '13',
				code: '0155',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Caxambu',
			},
			{
				j: '8',
				tr: '16',
				code: '0155',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'WENCESLAU BRAZ ',
			},
			{
				j: '8',
				tr: '21',
				code: '0155',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Portão',
			},
			{
				j: '8',
				tr: '25',
				code: '0155',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Salgado',
			},
		],
		'0156': [
			{
				j: '8',
				tr: '05',
				code: '0156',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MACAÚBAS',
			},
			{
				j: '8',
				tr: '06',
				code: '0156',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Redenção',
			},
			{
				j: '8',
				tr: '09',
				code: '0156',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'VARJAO',
			},
			{
				j: '8',
				tr: '16',
				code: '0156',
				courthouse: 'TJPR',
				state: 'PR',
				city: 'XANBRÊ',
			},
			{
				j: '8',
				tr: '21',
				code: '0156',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Charqueadas',
			},
			{
				j: '8',
				tr: '25',
				code: '0156',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Santa Rosa de Lima',
			},
			{
				j: '8',
				tr: '26',
				code: '0156',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cruzeiro ',
			},
		],
		'0157': [
			{
				j: '8',
				tr: '05',
				code: '0157',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MACURURÉ',
			},
			{
				j: '8',
				tr: '06',
				code: '0157',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Reriutaba',
			},
			{
				j: '8',
				tr: '09',
				code: '0157',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'VIANOPOLIS',
			},
			{
				j: '8',
				tr: '21',
				code: '0157',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Parobé',
			},
			{
				j: '8',
				tr: '25',
				code: '0157',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Santana do São Francisco',
			},
			{
				j: '8',
				tr: '26',
				code: '0157',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cubatão ',
			},
		],
		'0158': [
			{
				j: '8',
				tr: '05',
				code: '0158',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MAIRI',
			},
			{
				j: '8',
				tr: '06',
				code: '0158',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Russas',
			},
			{
				j: '8',
				tr: '09',
				code: '0158',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'SANTO ANTONIO DO DESCOBERTO',
			},
			{
				j: '8',
				tr: '21',
				code: '0158',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Rodeio Bonito',
			},
			{
				j: '8',
				tr: '25',
				code: '0158',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Santos Amaro das Brotas',
			},
		],
		'0159': [
			{
				j: '8',
				tr: '05',
				code: '0159',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MALHADA',
			},
			{
				j: '8',
				tr: '06',
				code: '0159',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Saboeiro',
			},
			{
				j: '8',
				tr: '09',
				code: '0159',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'SANTO ANTONIO DO DESCOBERTO',
			},
			{
				j: '8',
				tr: '21',
				code: '0159',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Teutônia',
			},
			{
				j: '8',
				tr: '25',
				code: '0159',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'São Domingos',
			},
			{
				j: '8',
				tr: '26',
				code: '0159',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cunha ',
			},
		],
		'0160': [
			{
				j: '8',
				tr: '05',
				code: '0160',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MARACÁS',
			},
			{
				j: '8',
				tr: '06',
				code: '0160',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Santa Quitéria',
			},
			{
				j: '8',
				tr: '09',
				code: '0160',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'NOVO GAMA',
			},
			{
				j: '8',
				tr: '21',
				code: '0160',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Vera Cruz ',
			},
			{
				j: '8',
				tr: '25',
				code: '0160',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'São Francisco',
			},
			{
				j: '8',
				tr: '26',
				code: '0160',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Descalvado ',
			},
		],
		'0161': [
			{
				j: '8',
				tr: '05',
				code: '0161',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MARAGOGIPE',
			},
			{
				j: '8',
				tr: '06',
				code: '0161',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Santana do Acaraú',
			},
			{
				j: '8',
				tr: '09',
				code: '0161',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'NOVO GAMA',
			},
			{
				j: '8',
				tr: '15',
				code: '0161',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Cuité',
			},
			{
				j: '8',
				tr: '21',
				code: '0161',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Salto do Jacuí',
			},
			{
				j: '8',
				tr: '25',
				code: '0161',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'São Miguel do Aleixo',
			},
			{
				j: '8',
				tr: '26',
				code: '0161',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Diadema ',
			},
		],
		'0162': [
			{
				j: '8',
				tr: '05',
				code: '0162',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MARAÚ',
			},
			{
				j: '8',
				tr: '06',
				code: '0162',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Santana do Cariri',
			},
			{
				j: '8',
				tr: '09',
				code: '0162',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'VALPARAISO DE GOIAS',
			},
			{
				j: '8',
				tr: '25',
				code: '0162',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Simão Dias',
			},
		],
		'0163': [
			{
				j: '8',
				tr: '05',
				code: '0163',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MARCIONÍLIO SOUZA',
			},
			{
				j: '8',
				tr: '06',
				code: '0163',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'São Benedito',
			},
			{
				j: '8',
				tr: '09',
				code: '0163',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'VALPARAISO DE GOIAS',
			},
			{
				j: '8',
				tr: '21',
				code: '0163',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Osório ',
			},
			{
				j: '8',
				tr: '25',
				code: '0163',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Siriri',
			},
		],
		'0164': [
			{
				j: '8',
				tr: '05',
				code: '0164',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MATA DE SÃO JOÃO',
			},
			{
				j: '8',
				tr: '06',
				code: '0164',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'São Gonçalo do Amarante',
			},
			{
				j: '8',
				tr: '09',
				code: '0164',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CIDADE OCIDENTAL',
			},
			{
				j: '8',
				tr: '21',
				code: '0164',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Três Coroas',
			},
			{
				j: '8',
				tr: '25',
				code: '0164',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Santa Luzia do Itanhy',
			},
		],
		'0165': [
			{
				j: '8',
				tr: '05',
				code: '0165',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MEDEIROS NETO',
			},
			{
				j: '8',
				tr: '06',
				code: '0165',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'São Luis do Curu',
			},
			{
				j: '8',
				tr: '09',
				code: '0165',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CIDADE OCIDENTAL',
			},
			{
				j: '8',
				tr: '21',
				code: '0165',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Eldorado do Sul',
			},
			{
				j: '8',
				tr: '21',
				code: '0165',
				courthouse: 'TJRS ',
				state: 'RS ',
				city: 'Ivoti',
			},
			{
				j: '8',
				tr: '25',
				code: '0165',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Telha',
			},
			{
				j: '8',
				tr: '26',
				code: '0165',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Dois Córregos ',
			},
		],
		'0166': [
			{
				j: '8',
				tr: '05',
				code: '0166',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MIGUEL CALMON',
			},
			{
				j: '8',
				tr: '06',
				code: '0166',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Senador Pompeu',
			},
			{
				j: '8',
				tr: '09',
				code: '0166',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'MONTES CLAROS DE GOIAS',
			},
			{
				j: '8',
				tr: '13',
				code: '0166',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Cláudio',
			},
			{
				j: '8',
				tr: '25',
				code: '0166',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Tobias Barreto',
			},
		],
		'0167': [
			{
				j: '8',
				tr: '05',
				code: '0167',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MILAGRES',
			},
			{
				j: '8',
				tr: '06',
				code: '0167',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Sobral',
			},
			{
				j: '8',
				tr: '09',
				code: '0167',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CROMINIA',
			},
			{
				j: '8',
				tr: '25',
				code: '0167',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Tomar do Geru',
			},
		],
		'0168': [
			{
				j: '8',
				tr: '05',
				code: '0168',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MONTE SANTO',
			},
			{
				j: '8',
				tr: '06',
				code: '0168',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Solonópole',
			},
			{
				j: '8',
				tr: '09',
				code: '0168',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'AGUAS LINDAS DE GOIAS',
			},
			{
				j: '8',
				tr: '25',
				code: '0168',
				courthouse: 'TJSE',
				state: 'SE',
				city: 'Umbaúba',
			},
			{
				j: '8',
				tr: '26',
				code: '0168',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Dracena ',
			},
		],
		'0169': [
			{
				j: '8',
				tr: '05',
				code: '0169',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MORPARÁ',
			},
			{
				j: '8',
				tr: '06',
				code: '0169',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Tabuleiro do Norte',
			},
			{
				j: '8',
				tr: '09',
				code: '0169',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'AGUAS LINDAS DE GOIAS',
			},
			{
				j: '8',
				tr: '26',
				code: '0169',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Duartina ',
			},
		],
		'0170': [
			{
				j: '8',
				tr: '05',
				code: '0170',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MORRO DO CHAPÉU',
			},
			{
				j: '8',
				tr: '06',
				code: '0170',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Tamboril',
			},
			{
				j: '8',
				tr: '09',
				code: '0170',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'CAMPINORTE',
			},
		],
		'0171': [
			{
				j: '8',
				tr: '05',
				code: '0171',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MUCUGÊ',
			},
			{
				j: '8',
				tr: '06',
				code: '0171',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Tauá',
			},
			{
				j: '8',
				tr: '09',
				code: '0171',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'IACIARA',
			},
			{
				j: '8',
				tr: '15',
				code: '0171',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Esperança',
			},
		],
		'0172': [
			{
				j: '8',
				tr: '05',
				code: '0172',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MUCURI',
			},
			{
				j: '8',
				tr: '06',
				code: '0172',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Tauá',
			},
			{
				j: '8',
				tr: '09',
				code: '0172',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'SANTA TEREZINHA DE GOIAS',
			},
			{
				j: '8',
				tr: '13',
				code: '0172',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Conceição das Alagoas',
			},
			{
				j: '8',
				tr: '26',
				code: '0172',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Eldorado ',
			},
		],
		'0173': [
			{
				j: '8',
				tr: '05',
				code: '0173',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MUNDO NOVO',
			},
			{
				j: '8',
				tr: '06',
				code: '0173',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Tianguá',
			},
			{
				j: '8',
				tr: '09',
				code: '0173',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'SAO SIMAO',
			},
		],
		'0174': [
			{
				j: '8',
				tr: '05',
				code: '0174',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MURITIBA',
			},
			{
				j: '8',
				tr: '06',
				code: '0174',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Tianguá',
			},
			{
				j: '8',
				tr: '09',
				code: '0174',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'SENADOR CANEDO',
			},
		],
		'0175': [
			{
				j: '8',
				tr: '05',
				code: '0175',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'MUTUÍPE',
			},
			{
				j: '8',
				tr: '06',
				code: '0175',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Trairi',
			},
			{
				j: '8',
				tr: '09',
				code: '0175',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'ARUANA',
			},
			{
				j: '8',
				tr: '13',
				code: '0175',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Conceição do Mato Dentro',
			},
		],
		'0176': [
			{
				j: '8',
				tr: '05',
				code: '0176',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'NAZARÉ',
			},
			{
				j: '8',
				tr: '06',
				code: '0176',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Ubajara',
			},
			{
				j: '8',
				tr: '09',
				code: '0176',
				courthouse: 'TJGO',
				state: 'GO',
				city: 'NOVA CRIXAS',
			},
			{
				j: '8',
				tr: '26',
				code: '0176',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Embu ',
			},
		],
		'0177': [
			{
				j: '8',
				tr: '05',
				code: '0177',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'NILO PEÇANHA',
			},
			{
				j: '8',
				tr: '06',
				code: '0177',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Umirim',
			},
			{
				j: '8',
				tr: '13',
				code: '0177',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Conceição do Rio Verde',
			},
			{
				j: '8',
				tr: '26',
				code: '0177',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itapecerica da Serra ',
			},
		],
		'0178': [
			{
				j: '8',
				tr: '05',
				code: '0178',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'NORDESTINA',
			},
			{
				j: '8',
				tr: '06',
				code: '0178',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Uruburetama',
			},
		],
		'0179': [
			{
				j: '8',
				tr: '05',
				code: '0179',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'NOVA CANAÃ',
			},
			{
				j: '8',
				tr: '06',
				code: '0179',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Uruoca',
			},
		],
		'0180': [
			{
				j: '8',
				tr: '05',
				code: '0180',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'NOVA FÁTIMA',
			},
			{
				j: '8',
				tr: '06',
				code: '0180',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Varjota',
			},
			{
				j: '8',
				tr: '13',
				code: '0180',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Congonhas',
			},
			{
				j: '8',
				tr: '26',
				code: '0180',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Espírito Santo do Pinhal ',
			},
		],
		'0181': [
			{
				j: '8',
				tr: '05',
				code: '0181',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'NOVA SOURE',
			},
			{
				j: '8',
				tr: '06',
				code: '0181',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Várzea Alegre',
			},
			{
				j: '8',
				tr: '15',
				code: '0181',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Guarabira',
			},
		],
		'0182': [
			{
				j: '8',
				tr: '05',
				code: '0182',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'NOVA VIÇOSA',
			},
			{
				j: '8',
				tr: '06',
				code: '0182',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Viçosa do Ceará',
			},
			{
				j: '8',
				tr: '13',
				code: '0182',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Conquista',
			},
		],
		'0183': [
			{
				j: '8',
				tr: '05',
				code: '0183',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'OLINDINA',
			},
			{
				j: '8',
				tr: '06',
				code: '0183',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Abaiara',
			},
			{
				j: '8',
				tr: '13',
				code: '0183',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Conselheiro Lafaiete',
			},
		],
		'0184': [
			{
				j: '8',
				tr: '05',
				code: '0184',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'OLIVEIRA DOS BREJINHOS',
			},
			{
				j: '8',
				tr: '06',
				code: '0184',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Alcântaras',
			},
			{
				j: '8',
				tr: '13',
				code: '0184',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Conselheiro Pena',
			},
		],
		'0185': [
			{
				j: '8',
				tr: '05',
				code: '0185',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PALMAS DE MONTE ALTO',
			},
			{
				j: '8',
				tr: '06',
				code: '0185',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Altaneira',
			},
			{
				j: '8',
				tr: '26',
				code: '0185',
				courthouse: 'TJSP',
				state: 'SP',
				city: "Estrela D'Oeste ",
			},
		],
		'0186': [
			{
				j: '8',
				tr: '05',
				code: '0186',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PALMEIRAS',
			},
			{
				j: '8',
				tr: '06',
				code: '0186',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Apuiarés',
			},
		],
		'0187': [
			{
				j: '8',
				tr: '05',
				code: '0187',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PARAMIRIM',
			},
			{
				j: '8',
				tr: '06',
				code: '0187',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Arneiróz',
			},
			{
				j: '8',
				tr: '26',
				code: '0187',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Fartura ',
			},
		],
		'0188': [
			{
				j: '8',
				tr: '05',
				code: '0188',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PARATINGA',
			},
			{
				j: '8',
				tr: '06',
				code: '0188',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Banabuiu',
			},
			{
				j: '8',
				tr: '13',
				code: '0188',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Nova Lima',
			},
		],
		'0189': [
			{
				j: '8',
				tr: '05',
				code: '0189',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PARIPIRANGA',
			},
			{
				j: '8',
				tr: '06',
				code: '0189',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Catunda',
			},
			{
				j: '8',
				tr: '26',
				code: '0189',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Fernandópolis ',
			},
		],
		'0190': [
			{
				j: '8',
				tr: '05',
				code: '0190',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PAU BRASIL',
			},
			{
				j: '8',
				tr: '06',
				code: '0190',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Choró Limão',
			},
		],
		'0191': [
			{
				j: '8',
				tr: '05',
				code: '0191',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PAULO AFONSO',
			},
			{
				j: '8',
				tr: '06',
				code: '0191',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Deputado Irapuan Pinheiro',
			},
			{
				j: '8',
				tr: '13',
				code: '0191',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Corinto',
			},
			{
				j: '8',
				tr: '15',
				code: '0191',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Soledade',
			},
			{
				j: '8',
				tr: '26',
				code: '0191',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Poá ',
			},
		],
		'0192': [
			{
				j: '8',
				tr: '05',
				code: '0192',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PÉ DE SERRA',
			},
			{
				j: '8',
				tr: '06',
				code: '0192',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Ererê',
			},
		],
		'0193': [
			{
				j: '8',
				tr: '05',
				code: '0193',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PIATÃ',
			},
			{
				j: '8',
				tr: '06',
				code: '0193',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'General Sampaio',
			},
			{
				j: '8',
				tr: '13',
				code: '0193',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Coromandel',
			},
		],
		'0194': [
			{
				j: '8',
				tr: '05',
				code: '0194',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PILÃO ARCADO',
			},
			{
				j: '8',
				tr: '06',
				code: '0194',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Granjeiro',
			},
			{
				j: '8',
				tr: '13',
				code: '0194',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Coronel Fabriciano',
			},
		],
		'0195': [
			{
				j: '8',
				tr: '05',
				code: '0195',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PINDAÍ',
			},
			{
				j: '8',
				tr: '06',
				code: '0195',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Guaramiranga',
			},
		],
		'0196': [
			{
				j: '8',
				tr: '05',
				code: '0196',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PINDOBAÇU',
			},
			{
				j: '8',
				tr: '06',
				code: '0196',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Ibaretama',
			},
			{
				j: '8',
				tr: '26',
				code: '0196',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Franca ',
			},
		],
		'0197': [
			{
				j: '8',
				tr: '05',
				code: '0197',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PIRITIBA',
			},
			{
				j: '8',
				tr: '06',
				code: '0197',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Itaiçaba',
			},
			{
				j: '8',
				tr: '26',
				code: '0197',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Francisco Morato ',
			},
		],
		'0198': [
			{
				j: '8',
				tr: '05',
				code: '0198',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PLANALTO',
			},
			{
				j: '8',
				tr: '06',
				code: '0198',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Jaguaribara',
			},
			{
				j: '8',
				tr: '26',
				code: '0198',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Franco da Rocha ',
			},
		],
		'0199': [
			{
				j: '8',
				tr: '05',
				code: '0199',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'POÇÕES',
			},
			{
				j: '8',
				tr: '06',
				code: '0199',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Martinópole',
			},
		],
		'0200': [
			{
				j: '8',
				tr: '05',
				code: '0200',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'POJUCA',
			},
			{
				j: '8',
				tr: '06',
				code: '0200',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Milhã',
			},
			{
				j: '8',
				tr: '26',
				code: '0200',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Gália ',
			},
		],
		'0201': [
			{
				j: '8',
				tr: '05',
				code: '0201',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PORTO SEGURO',
			},
			{
				j: '8',
				tr: '06',
				code: '0201',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Miraima',
			},
			{
				j: '8',
				tr: '14',
				code: '0201',
				courthouse: 'TJPA',
				state: 'PA',
				city: 'ICOARACI',
			},
			{
				j: '8',
				tr: '15',
				code: '0201',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Ingá',
			},
			{
				j: '8',
				tr: '26',
				code: '0201',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Garça ',
			},
		],
		'0202': [
			{
				j: '8',
				tr: '05',
				code: '0202',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'POTIRAGUÁ',
			},
			{
				j: '8',
				tr: '06',
				code: '0202',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Moraujo',
			},
			{
				j: '8',
				tr: '19',
				code: '0202',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Madureira ',
			},
		],
		'0203': [
			{
				j: '8',
				tr: '05',
				code: '0203',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PRADO',
			},
			{
				j: '8',
				tr: '06',
				code: '0203',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Ocara',
			},
			{
				j: '8',
				tr: '19',
				code: '0203',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Jacarepaguá ',
			},
		],
		'0204': [
			{
				j: '8',
				tr: '05',
				code: '0204',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PRESIDENTE DUTRA',
			},
			{
				j: '8',
				tr: '06',
				code: '0204',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Pacujá',
			},
			{
				j: '8',
				tr: '19',
				code: '0204',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Bangu ',
			},
			{
				j: '8',
				tr: '26',
				code: '0204',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'General Salgado ',
			},
		],
		'0205': [
			{
				j: '8',
				tr: '05',
				code: '0205',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'PRESIDENTE JÂNIO QUADROS',
			},
			{
				j: '8',
				tr: '06',
				code: '0205',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Palhano',
			},
			{
				j: '8',
				tr: '13',
				code: '0205',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Cristina',
			},
			{
				j: '8',
				tr: '19',
				code: '0205',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Campo Grande ',
			},
			{
				j: '8',
				tr: '26',
				code: '0205',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Getulina ',
			},
		],
		'0206': [
			{
				j: '8',
				tr: '05',
				code: '0206',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'QUEIMADAS',
			},
			{
				j: '8',
				tr: '06',
				code: '0206',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Paramoti',
			},
			{
				j: '8',
				tr: '19',
				code: '0206',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Santa Cruz ',
			},
		],
		'0207': [
			{
				j: '8',
				tr: '05',
				code: '0207',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'QUIXABEIRA',
			},
			{
				j: '8',
				tr: '06',
				code: '0207',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Penaforte',
			},
			{
				j: '8',
				tr: '19',
				code: '0207',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Ilha do Governador ',
			},
		],
		'0208': [
			{
				j: '8',
				tr: '05',
				code: '0208',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'REMANSO',
			},
			{
				j: '8',
				tr: '06',
				code: '0208',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Pires Ferreira',
			},
			{
				j: '8',
				tr: '13',
				code: '0208',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Cruzília',
			},
			{
				j: '8',
				tr: '19',
				code: '0208',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Méier ',
			},
		],
		'0209': [
			{
				j: '8',
				tr: '05',
				code: '0209',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'RETIROLÂNDIA',
			},
			{
				j: '8',
				tr: '06',
				code: '0209',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Potengi',
			},
			{
				j: '8',
				tr: '13',
				code: '0209',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Curvelo',
			},
			{
				j: '8',
				tr: '19',
				code: '0209',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Barra da Tijuca ',
			},
		],
		'0210': [
			{
				j: '8',
				tr: '05',
				code: '0210',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'RIACHÃO DAS NEVES',
			},
			{
				j: '8',
				tr: '06',
				code: '0210',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Potiretama',
			},
			{
				j: '8',
				tr: '13',
				code: '0210',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Pedro Leopoldo',
			},
			{
				j: '8',
				tr: '19',
				code: '0210',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Leopoldina ',
			},
			{
				j: '8',
				tr: '26',
				code: '0210',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Guaíra ',
			},
		],
		'0211': [
			{
				j: '8',
				tr: '05',
				code: '0211',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'RIACHÃO DO JACUÍPE',
			},
			{
				j: '8',
				tr: '06',
				code: '0211',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Salitre',
			},
			{
				j: '8',
				tr: '15',
				code: '0211',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Itaporanga',
			},
			{
				j: '8',
				tr: '19',
				code: '0211',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Pavuna ',
			},
		],
		'0212': [
			{
				j: '8',
				tr: '05',
				code: '0212',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'RIACHO DE SANTANA',
			},
			{
				j: '8',
				tr: '06',
				code: '0212',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'São João do Jaguaribe',
			},
			{
				j: '8',
				tr: '19',
				code: '0212',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Região Oceânica ',
			},
		],
		'0213': [
			{
				j: '8',
				tr: '05',
				code: '0213',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'RIBEIRA DO POMBAL',
			},
			{
				j: '8',
				tr: '06',
				code: '0213',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Senador Sá',
			},
			{
				j: '8',
				tr: '26',
				code: '0213',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Guará ',
			},
		],
		'0214': [
			{
				j: '8',
				tr: '05',
				code: '0214',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'RIO DE CONTAS',
			},
			{
				j: '8',
				tr: '06',
				code: '0214',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Tarrafas',
			},
		],
		'0215': [
			{
				j: '8',
				tr: '05',
				code: '0215',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'RIO DO ANTÔNIO',
			},
			{
				j: '8',
				tr: '06',
				code: '0215',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Tejuçuoca',
			},
		],
		'0216': [
			{
				j: '8',
				tr: '05',
				code: '0216',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'RIO REAL',
			},
			{
				j: '8',
				tr: '06',
				code: '0216',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Tururu',
			},
			{
				j: '8',
				tr: '13',
				code: '0216',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Diamantina',
			},
		],
		'0217': [
			{
				j: '8',
				tr: '05',
				code: '0217',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'RODELAS',
			},
			{
				j: '8',
				tr: '06',
				code: '0217',
				courthouse: 'TJCE',
				state: 'CE',
				city: 'Umari',
			},
		],
		'0218': [
			{
				j: '8',
				tr: '05',
				code: '0218',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'RUY BARBOSA',
			},
			{
				j: '8',
				tr: '26',
				code: '0218',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Guararapes ',
			},
		],
		'0219': [
			{
				j: '8',
				tr: '05',
				code: '0219',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SANTA BÁRBARA',
			},
			{
				j: '8',
				tr: '26',
				code: '0219',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mogi das Cruzes ',
			},
		],
		'0220': [
			{
				j: '8',
				tr: '05',
				code: '0220',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SANTA CRUZ  CABRÁLIA',
			},
			{
				j: '8',
				tr: '13',
				code: '0220',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Divino ',
			},
			{
				j: '8',
				tr: '26',
				code: '0220',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Guaratinguetá ',
			},
		],
		'0221': [
			{
				j: '8',
				tr: '05',
				code: '0221',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SANTA INÊS',
			},
			{
				j: '8',
				tr: '15',
				code: '0221',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'São José de Piranhas',
			},
		],
		'0222': [
			{
				j: '8',
				tr: '05',
				code: '0222',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SANTA LUZIA',
			},
			{
				j: '8',
				tr: '26',
				code: '0222',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Guariba ',
			},
		],
		'0223': [
			{
				j: '8',
				tr: '05',
				code: '0223',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SANTA MARIA DA VITÓRIA',
			},
			{
				j: '8',
				tr: '13',
				code: '0223',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Divinópolis',
			},
			{
				j: '8',
				tr: '26',
				code: '0223',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Guarujá ',
			},
		],
		'0224': [
			{
				j: '8',
				tr: '05',
				code: '0224',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SANTA RITA DE CÁSSIA',
			},
			{
				j: '8',
				tr: '26',
				code: '0224',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Guarulhos ',
			},
		],
		'0225': [
			{
				j: '8',
				tr: '05',
				code: '0225',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SANTA TEREZINHA',
			},
		],
		'0226': [
			{
				j: '8',
				tr: '05',
				code: '0226',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SANTALUZ',
			},
		],
		'0227': [
			{
				j: '8',
				tr: '05',
				code: '0227',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SANTANA',
			},
		],
		'0228': [
			{
				j: '8',
				tr: '05',
				code: '0228',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SANTO AMARO',
			},
		],
		'0229': [
			{
				j: '8',
				tr: '05',
				code: '0229',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SANTO ANTÔNIO DE JESUS',
			},
			{
				j: '8',
				tr: '26',
				code: '0229',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Sumaré ',
			},
		],
		'0230': [
			{
				j: '8',
				tr: '05',
				code: '0230',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SANTO ESTEVÃO',
			},
		],
		'0231': [
			{
				j: '8',
				tr: '05',
				code: '0231',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SÃO DESIDÉRIO',
			},
			{
				j: '8',
				tr: '13',
				code: '0231',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Ribeirão das Neves',
			},
			{
				j: '8',
				tr: '15',
				code: '0231',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Mamanguape',
			},
		],
		'0232': [
			{
				j: '8',
				tr: '05',
				code: '0232',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SÃO DOMINGOS',
			},
			{
				j: '8',
				tr: '13',
				code: '0232',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Dores do Indaiá',
			},
		],
		'0233': [
			{
				j: '8',
				tr: '05',
				code: '0233',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SÃO FELIPE',
			},
			{
				j: '8',
				tr: '26',
				code: '0233',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Carlos ',
			},
		],
		'0234': [
			{
				j: '8',
				tr: '05',
				code: '0234',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SÃO FÉLIX',
			},
		],
		'0235': [
			{
				j: '8',
				tr: '05',
				code: '0235',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SÃO FRANCISCO DO CONDE',
			},
		],
		'0236': [
			{
				j: '8',
				tr: '05',
				code: '0236',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SÃO GABRIEL',
			},
			{
				j: '8',
				tr: '13',
				code: '0236',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Elói Mendes',
			},
			{
				j: '8',
				tr: '26',
				code: '0236',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Ibitinga ',
			},
		],
		'0237': [
			{
				j: '8',
				tr: '05',
				code: '0237',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SÃO GONÇALO DOS CAMPOS',
			},
		],
		'0238': [
			{
				j: '8',
				tr: '05',
				code: '0238',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SÃO JOSÉ DO JACUÍPE',
			},
			{
				j: '8',
				tr: '26',
				code: '0238',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Ibiúna ',
			},
		],
		'0239': [
			{
				j: '8',
				tr: '05',
				code: '0239',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SÃO SEBASTIÃO DO PASSÉ',
			},
			{
				j: '8',
				tr: '13',
				code: '0239',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Entre-Rios de Minas',
			},
		],
		'0240': [
			{
				j: '8',
				tr: '05',
				code: '0240',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SAPEAÇU',
			},
			{
				j: '8',
				tr: '13',
				code: '0240',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Ervália',
			},
			{
				j: '8',
				tr: '26',
				code: '0240',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Rancharia ',
			},
		],
		'0241': [
			{
				j: '8',
				tr: '05',
				code: '0241',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SÁTIRO DIAS',
			},
			{
				j: '8',
				tr: '13',
				code: '0241',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Esmeraldas',
			},
			{
				j: '8',
				tr: '15',
				code: '0241',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Monteiro',
			},
		],
		'0242': [
			{
				j: '8',
				tr: '05',
				code: '0242',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SAÚDE',
			},
			{
				j: '8',
				tr: '13',
				code: '0242',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Espera Feliz',
			},
			{
				j: '8',
				tr: '26',
				code: '0242',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Igarapava ',
			},
		],
		'0243': [
			{
				j: '8',
				tr: '05',
				code: '0243',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SEABRA',
			},
			{
				j: '8',
				tr: '13',
				code: '0243',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Espinosa',
			},
		],
		'0244': [
			{
				j: '8',
				tr: '05',
				code: '0244',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SENHOR DO BONFIM',
			},
			{
				j: '8',
				tr: '26',
				code: '0244',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Iguape ',
			},
		],
		'0245': [
			{
				j: '8',
				tr: '05',
				code: '0245',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SENTO SÉ',
			},
			{
				j: '8',
				tr: '13',
				code: '0245',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Santa Luzia',
			},
		],
		'0246': [
			{
				j: '8',
				tr: '05',
				code: '0246',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SERRA DOURADA',
			},
			{
				j: '8',
				tr: '26',
				code: '0246',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Ilha Solteira ',
			},
		],
		'0247': [
			{
				j: '8',
				tr: '05',
				code: '0247',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SERRA PRETA',
			},
			{
				j: '8',
				tr: '26',
				code: '0247',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Sebastião ',
			},
		],
		'0248': [
			{
				j: '8',
				tr: '05',
				code: '0248',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SERRINHA',
			},
			{
				j: '8',
				tr: '13',
				code: '0248',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Estrela do Sul',
			},
			{
				j: '8',
				tr: '26',
				code: '0248',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Indaiatuba ',
			},
		],
		'0249': [
			{
				j: '8',
				tr: '05',
				code: '0249',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SERROLÂNDIA',
			},
			{
				j: '8',
				tr: '13',
				code: '0249',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Eugenópolis',
			},
		],
		'0250': [
			{
				j: '8',
				tr: '05',
				code: '0250',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SIMÕES FILHO',
			},
		],
		'0251': [
			{
				j: '8',
				tr: '05',
				code: '0251',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SOBRADINHO',
			},
			{
				j: '8',
				tr: '13',
				code: '0251',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Extrema',
			},
			{
				j: '8',
				tr: '15',
				code: '0251',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Patos',
			},
		],
		'0252': [
			{
				j: '8',
				tr: '05',
				code: '0252',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'SOUTO SOARES',
			},
			{
				j: '8',
				tr: '13',
				code: '0252',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Januária',
			},
			{
				j: '8',
				tr: '26',
				code: '0252',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Ipauçu ',
			},
		],
		'0253': [
			{
				j: '8',
				tr: '05',
				code: '0253',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'TANHAÇU',
			},
		],
		'0254': [
			{
				j: '8',
				tr: '05',
				code: '0254',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'TANQUE NOVO',
			},
		],
		'0255': [
			{
				j: '8',
				tr: '05',
				code: '0255',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'TAPEROÁ',
			},
		],
		'0256': [
			{
				j: '8',
				tr: '05',
				code: '0256',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'TEIXEIRA DE FREITAS',
			},
		],
		'0257': [
			{
				j: '8',
				tr: '05',
				code: '0257',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'TEODORO SAMPAIO',
			},
			{
				j: '8',
				tr: '26',
				code: '0257',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Ipuã ',
			},
		],
		'0258': [
			{
				j: '8',
				tr: '05',
				code: '0258',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'TEOFILÂNDIA',
			},
		],
		'0259': [
			{
				j: '8',
				tr: '05',
				code: '0259',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'TERRA NOVA',
			},
			{
				j: '8',
				tr: '13',
				code: '0259',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Ferros',
			},
		],
		'0260': [
			{
				j: '8',
				tr: '05',
				code: '0260',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'TREMEDAL',
			},
		],
		'0261': [
			{
				j: '8',
				tr: '05',
				code: '0261',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'TUCANO',
			},
			{
				j: '8',
				tr: '13',
				code: '0261',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Formigas',
			},
			{
				j: '8',
				tr: '15',
				code: '0261',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Piancó',
			},
		],
		'0262': [
			{
				j: '8',
				tr: '05',
				code: '0262',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'UAUÁ',
			},
			{
				j: '8',
				tr: '26',
				code: '0262',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itapeva ',
			},
		],
		'0263': [
			{
				j: '8',
				tr: '05',
				code: '0263',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'UBAÍRA',
			},
			{
				j: '8',
				tr: '26',
				code: '0263',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itaí ',
			},
		],
		'0264': [
			{
				j: '8',
				tr: '05',
				code: '0264',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'UBAITABA',
			},
			{
				j: '8',
				tr: '26',
				code: '0264',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Novo Horizonte ',
			},
		],
		'0265': [
			{
				j: '8',
				tr: '05',
				code: '0265',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'UBATÃ',
			},
		],
		'0266': [
			{
				j: '8',
				tr: '05',
				code: '0266',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'UIBAÍ',
			},
			{
				j: '8',
				tr: '26',
				code: '0266',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itanhaém ',
			},
		],
		'0267': [
			{
				j: '8',
				tr: '05',
				code: '0267',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'UNA',
			},
			{
				j: '8',
				tr: '13',
				code: '0267',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Francisco Sá',
			},
		],
		'0268': [
			{
				j: '8',
				tr: '05',
				code: '0268',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'URANDI',
			},
			{
				j: '8',
				tr: '26',
				code: '0268',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itapecerica da Serra ',
			},
		],
		'0269': [
			{
				j: '8',
				tr: '05',
				code: '0269',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'URUÇUCA',
			},
			{
				j: '8',
				tr: '26',
				code: '0269',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itapetininga ',
			},
		],
		'0270': [
			{
				j: '8',
				tr: '05',
				code: '0270',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'UTINGA',
			},
			{
				j: '8',
				tr: '26',
				code: '0270',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itapeva ',
			},
		],
		'0271': [
			{
				j: '8',
				tr: '05',
				code: '0271',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'VALENÇA',
			},
			{
				j: '8',
				tr: '13',
				code: '0271',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Frutal',
			},
			{
				j: '8',
				tr: '15',
				code: '0271',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Picuí',
			},
			{
				j: '8',
				tr: '26',
				code: '0271',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itapevi ',
			},
		],
		'0272': [
			{
				j: '8',
				tr: '05',
				code: '0272',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'VALENTE',
			},
			{
				j: '8',
				tr: '26',
				code: '0272',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itapira ',
			},
		],
		'0273': [
			{
				j: '8',
				tr: '05',
				code: '0273',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'VÁRZEA DO POÇO',
			},
			{
				j: '8',
				tr: '13',
				code: '0273',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Galiléia',
			},
		],
		'0274': [
			{
				j: '8',
				tr: '05',
				code: '0274',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'VITÓRIA DA CONQUISTA',
			},
			{
				j: '8',
				tr: '26',
				code: '0274',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itápolis ',
			},
		],
		'0275': [
			{
				j: '8',
				tr: '05',
				code: '0275',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'WANDERLEY',
			},
			{
				j: '8',
				tr: '26',
				code: '0275',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itaporanga ',
			},
		],
		'0276': [
			{
				j: '8',
				tr: '05',
				code: '0276',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'WENCESLAU GUIMARÃES',
			},
		],
		'0277': [
			{
				j: '8',
				tr: '05',
				code: '0277',
				courthouse: 'TJBA',
				state: 'BA',
				city: 'XIQUE-XIQUE',
			},
		],
		'0778': [
			{
				j: '8',
				tr: '13',
				code: '0778',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Arinos',
			},
		],
		'0878': [
			{
				j: '8',
				tr: '13',
				code: '0878',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Camanducaia',
			},
		],
		'0879': [
			{
				j: '8',
				tr: '13',
				code: '0879',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Carmópolis de Minas',
			},
		],
		'0775': [
			{
				j: '8',
				tr: '13',
				code: '0775',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Coração de Jesus',
			},
		],
		'0278': [
			{
				j: '8',
				tr: '13',
				code: '0278',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Grão-Mogol',
			},
			{
				j: '8',
				tr: '26',
				code: '0278',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itaquaquecetuba ',
			},
		],
		'0280': [
			{
				j: '8',
				tr: '13',
				code: '0280',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Guanhães',
			},
			{
				j: '8',
				tr: '26',
				code: '0280',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itanhaém ',
			},
		],
		'0281': [
			{
				j: '8',
				tr: '13',
				code: '0281',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Guapé',
			},
			{
				j: '8',
				tr: '15',
				code: '0281',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Pilar',
			},
			{
				j: '8',
				tr: '26',
				code: '0281',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itatiba ',
			},
		],
		'0283': [
			{
				j: '8',
				tr: '13',
				code: '0283',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Guaranésia',
			},
			{
				j: '8',
				tr: '26',
				code: '0283',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Rio Claro ',
			},
		],
		'0284': [
			{
				j: '8',
				tr: '13',
				code: '0284',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Guarani',
			},
		],
		'0287': [
			{
				j: '8',
				tr: '13',
				code: '0287',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Guaxupé',
			},
		],
		'0295': [
			{
				j: '8',
				tr: '13',
				code: '0295',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Ibiá',
			},
		],
		'0297': [
			{
				j: '8',
				tr: '13',
				code: '0297',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Ibiraci',
			},
			{
				j: '8',
				tr: '26',
				code: '0297',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Jales ',
			},
		],
		'0301': [
			{
				j: '8',
				tr: '13',
				code: '0301',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Igarapé ',
			},
			{
				j: '8',
				tr: '15',
				code: '0301',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Pombal',
			},
			{
				j: '8',
				tr: '26',
				code: '0301',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Atibaia ',
			},
		],
		'0303': [
			{
				j: '8',
				tr: '13',
				code: '0303',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Iguatama',
			},
		],
		'0309': [
			{
				j: '8',
				tr: '13',
				code: '0309',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Inhapim',
			},
			{
				j: '8',
				tr: '26',
				code: '0309',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Jundiaí ',
			},
		],
		'0312': [
			{
				j: '8',
				tr: '13',
				code: '0312',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Ipanema',
			},
			{
				j: '8',
				tr: '26',
				code: '0312',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Juquiá ',
			},
		],
		'0313': [
			{
				j: '8',
				tr: '13',
				code: '0313',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Ipatinga',
			},
		],
		'0317': [
			{
				j: '8',
				tr: '13',
				code: '0317',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Itabira',
			},
		],
		'0319': [
			{
				j: '8',
				tr: '13',
				code: '0319',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Itabirito',
			},
			{
				j: '8',
				tr: '26',
				code: '0319',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Lençóis Paulista ',
			},
		],
		'0322': [
			{
				j: '8',
				tr: '13',
				code: '0322',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Itaguara',
			},
			{
				j: '8',
				tr: '26',
				code: '0322',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Lins ',
			},
		],
		'0324': [
			{
				j: '8',
				tr: '13',
				code: '0324',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Itajubá',
			},
		],
		'0325': [
			{
				j: '8',
				tr: '13',
				code: '0325',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Itamarandiba',
			},
		],
		'0327': [
			{
				j: '8',
				tr: '13',
				code: '0327',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Itambacuri',
			},
		],
		'0329': [
			{
				j: '8',
				tr: '13',
				code: '0329',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Itamoji',
			},
		],
		'0330': [
			{
				j: '8',
				tr: '13',
				code: '0330',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Itamonte',
			},
		],
		'0331': [
			{
				j: '8',
				tr: '13',
				code: '0331',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Itanhandu',
			},
			{
				j: '8',
				tr: '15',
				code: '0331',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Santa Rita',
			},
		],
		'0332': [
			{
				j: '8',
				tr: '13',
				code: '0332',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Itanhomi',
			},
		],
		'0334': [
			{
				j: '8',
				tr: '13',
				code: '0334',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Itapajipe',
			},
			{
				j: '8',
				tr: '26',
				code: '0334',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Monte Aprazível ',
			},
		],
		'0335': [
			{
				j: '8',
				tr: '13',
				code: '0335',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Itapecerica',
			},
		],
		'0338': [
			{
				j: '8',
				tr: '13',
				code: '0338',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Itaúna',
			},
			{
				j: '8',
				tr: '26',
				code: '0338',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mairiporã ',
			},
		],
		'0342': [
			{
				j: '8',
				tr: '13',
				code: '0342',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Ituiutaba',
			},
		],
		'0343': [
			{
				j: '8',
				tr: '13',
				code: '0343',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Itumirim',
			},
		],
		'0344': [
			{
				j: '8',
				tr: '13',
				code: '0344',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Iturama',
			},
			{
				j: '8',
				tr: '26',
				code: '0344',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Marília ',
			},
		],
		'0346': [
			{
				j: '8',
				tr: '13',
				code: '0346',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Jaboticatubas',
			},
			{
				j: '8',
				tr: '26',
				code: '0346',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Martinópolis ',
			},
		],
		'0347': [
			{
				j: '8',
				tr: '13',
				code: '0347',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Jacinto',
			},
			{
				j: '8',
				tr: '26',
				code: '0347',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Matão ',
			},
		],
		'0348': [
			{
				j: '8',
				tr: '13',
				code: '0348',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Jacuí',
			},
			{
				j: '8',
				tr: '26',
				code: '0348',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mauá ',
			},
		],
		'0349': [
			{
				j: '8',
				tr: '13',
				code: '0349',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Jacutinga',
			},
		],
		'0351': [
			{
				j: '8',
				tr: '13',
				code: '0351',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Janaúba',
			},
			{
				j: '8',
				tr: '15',
				code: '0351',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Sapé',
			},
		],
		'0355': [
			{
				j: '8',
				tr: '13',
				code: '0355',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Jequeri',
			},
			{
				j: '8',
				tr: '26',
				code: '0355',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Miracatu ',
			},
		],
		'0358': [
			{
				j: '8',
				tr: '13',
				code: '0358',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Jequitimonha',
			},
			{
				j: '8',
				tr: '26',
				code: '0358',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mirassol ',
			},
		],
		'0362': [
			{
				j: '8',
				tr: '13',
				code: '0362',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'João Monlevade',
			},
			{
				j: '8',
				tr: '26',
				code: '0362',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mogi-Guaçu ',
			},
		],
		'0363': [
			{
				j: '8',
				tr: '13',
				code: '0363',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'João Pinheiro',
			},
			{
				j: '8',
				tr: '26',
				code: '0363',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mogi-Mirim ',
			},
		],
		'0740': [
			{
				j: '8',
				tr: '13',
				code: '0740',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Juatuba',
			},
		],
		'0372': [
			{
				j: '8',
				tr: '13',
				code: '0372',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Lagoa da Prata',
			},
			{
				j: '8',
				tr: '26',
				code: '0372',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Monte Mor ',
			},
		],
		'0377': [
			{
				j: '8',
				tr: '13',
				code: '0377',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Lajinha',
			},
		],
		'0378': [
			{
				j: '8',
				tr: '13',
				code: '0378',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Lambari',
			},
		],
		'0382': [
			{
				j: '8',
				tr: '13',
				code: '0382',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Lavras',
			},
			{
				j: '8',
				tr: '26',
				code: '0382',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mirassol ',
			},
		],
		'0384': [
			{
				j: '8',
				tr: '13',
				code: '0384',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Leopoldina',
			},
		],
		'0386': [
			{
				j: '8',
				tr: '13',
				code: '0386',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Lima Duarte',
			},
		],
		'0388': [
			{
				j: '8',
				tr: '13',
				code: '0388',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Luz',
			},
		],
		'0390': [
			{
				j: '8',
				tr: '13',
				code: '0390',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Machado',
			},
			{
				j: '8',
				tr: '26',
				code: '0390',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Nova Granada ',
			},
		],
		'0392': [
			{
				j: '8',
				tr: '13',
				code: '0392',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Malacacheta',
			},
		],
		'0393': [
			{
				j: '8',
				tr: '13',
				code: '0393',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Manga',
			},
		],
		'0394': [
			{
				j: '8',
				tr: '13',
				code: '0394',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Manhuaçu',
			},
			{
				j: '8',
				tr: '26',
				code: '0394',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Nova Odessa ',
			},
		],
		'0395': [
			{
				j: '8',
				tr: '13',
				code: '0395',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Manhumirim',
			},
		],
		'0396': [
			{
				j: '8',
				tr: '13',
				code: '0396',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Mantena',
			},
			{
				j: '8',
				tr: '26',
				code: '0396',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Novo Horizonte ',
			},
		],
		'0398': [
			{
				j: '8',
				tr: '13',
				code: '0398',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Mar de Espanha',
			},
		],
		'0400': [
			{
				j: '8',
				tr: '13',
				code: '0400',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Mariana',
			},
			{
				j: '8',
				tr: '26',
				code: '0400',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Olímpia ',
			},
		],
		'0405': [
			{
				j: '8',
				tr: '13',
				code: '0405',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Martinho Campos',
			},
			{
				j: '8',
				tr: '26',
				code: '0405',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Osasco ',
			},
		],
		'0407': [
			{
				j: '8',
				tr: '13',
				code: '0407',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Mateus Leme',
			},
			{
				j: '8',
				tr: '26',
				code: '0407',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Osvaldo Cruz ',
			},
		],
		'0408': [
			{
				j: '8',
				tr: '13',
				code: '0408',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Matias Barbosa',
			},
			{
				j: '8',
				tr: '26',
				code: '0408',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Ourinhos ',
			},
		],
		'0411': [
			{
				j: '8',
				tr: '13',
				code: '0411',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Matozinhos',
			},
			{
				j: '8',
				tr: '15',
				code: '0411',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Alhandra',
			},
			{
				j: '8',
				tr: '26',
				code: '0411',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Pacaembu ',
			},
		],
		'0414': [
			{
				j: '8',
				tr: '13',
				code: '0414',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Medina',
			},
			{
				j: '8',
				tr: '26',
				code: '0414',
				courthouse: 'TJSP',
				state: 'SP',
				city: "Palmeira D'Oeste ",
			},
		],
		'0416': [
			{
				j: '8',
				tr: '13',
				code: '0416',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Mercês',
			},
			{
				j: '8',
				tr: '26',
				code: '0416',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Panorama ',
			},
		],
		'0417': [
			{
				j: '8',
				tr: '13',
				code: '0417',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Mesquita',
			},
			{
				j: '8',
				tr: '26',
				code: '0417',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Paraguaçu Paulista ',
			},
		],
		'0418': [
			{
				j: '8',
				tr: '13',
				code: '0418',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Minas Novas',
			},
			{
				j: '8',
				tr: '26',
				code: '0418',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Paraibuna ',
			},
		],
		'0421': [
			{
				j: '8',
				tr: '13',
				code: '0421',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Miradouro',
			},
			{
				j: '8',
				tr: '15',
				code: '0421',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Bonito de Santa Fé',
			},
		],
		'0422': [
			{
				j: '8',
				tr: '13',
				code: '0422',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Miraí',
			},
		],
		'0427': [
			{
				j: '8',
				tr: '13',
				code: '0427',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Montalvânia',
			},
		],
		'0428': [
			{
				j: '8',
				tr: '13',
				code: '0428',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Monte Alegre de Minas',
			},
			{
				j: '8',
				tr: '26',
				code: '0428',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Campinas ',
			},
		],
		'0429': [
			{
				j: '8',
				tr: '13',
				code: '0429',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Monte Azul',
			},
		],
		'0430': [
			{
				j: '8',
				tr: '13',
				code: '0430',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Monte Belo',
			},
			{
				j: '8',
				tr: '26',
				code: '0430',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Paulo de Faria ',
			},
		],
		'0431': [
			{
				j: '8',
				tr: '13',
				code: '0431',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Monte Carmelo',
			},
			{
				j: '8',
				tr: '26',
				code: '0431',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Pederneiras ',
			},
		],
		'0432': [
			{
				j: '8',
				tr: '13',
				code: '0432',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Monte Santo de Minas',
			},
		],
		'0434': [
			{
				j: '8',
				tr: '13',
				code: '0434',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Monte Sião',
			},
			{
				j: '8',
				tr: '26',
				code: '0434',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Pedregulho ',
			},
		],
		'0433': [
			{
				j: '8',
				tr: '13',
				code: '0433',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Montes Claros',
			},
		],
		'0435': [
			{
				j: '8',
				tr: '13',
				code: '0435',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Morada Nova de Minas',
			},
			{
				j: '8',
				tr: '26',
				code: '0435',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Pedreira ',
			},
		],
		'0439': [
			{
				j: '8',
				tr: '13',
				code: '0439',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Muriaé',
			},
			{
				j: '8',
				tr: '26',
				code: '0439',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Pereira Barreto ',
			},
		],
		'0440': [
			{
				j: '8',
				tr: '13',
				code: '0440',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Mutum',
			},
		],
		'0441': [
			{
				j: '8',
				tr: '13',
				code: '0441',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Muzambinho',
			},
			{
				j: '8',
				tr: '26',
				code: '0441',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Peruíbe ',
			},
		],
		'0443': [
			{
				j: '8',
				tr: '13',
				code: '0443',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Nanuque',
			},
			{
				j: '8',
				tr: '26',
				code: '0443',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Piedade ',
			},
		],
		'0444': [
			{
				j: '8',
				tr: '13',
				code: '0444',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Natércia',
			},
			{
				j: '8',
				tr: '26',
				code: '0444',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Pilar do Sul ',
			},
		],
		'0446': [
			{
				j: '8',
				tr: '13',
				code: '0446',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Nepomuceno',
			},
		],
		'0447': [
			{
				j: '8',
				tr: '13',
				code: '0447',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Nova Era',
			},
			{
				j: '8',
				tr: '26',
				code: '0447',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Bragança Paulista ',
			},
		],
		'0450': [
			{
				j: '8',
				tr: '13',
				code: '0450',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Nova Ponte',
			},
			{
				j: '8',
				tr: '26',
				code: '0450',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Piracaia ',
			},
		],
		'0451': [
			{
				j: '8',
				tr: '13',
				code: '0451',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Nova Resende',
			},
			{
				j: '8',
				tr: '15',
				code: '0451',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Sumé',
			},
			{
				j: '8',
				tr: '26',
				code: '0451',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Piracicaba ',
			},
		],
		'0452': [
			{
				j: '8',
				tr: '13',
				code: '0452',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Nova Serrana',
			},
			{
				j: '8',
				tr: '26',
				code: '0452',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Piraju ',
			},
		],
		'0453': [
			{
				j: '8',
				tr: '13',
				code: '0453',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Novo Cruzeiro',
			},
			{
				j: '8',
				tr: '26',
				code: '0453',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Pirajuí ',
			},
		],
		'0456': [
			{
				j: '8',
				tr: '13',
				code: '0456',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Oliveira',
			},
			{
				j: '8',
				tr: '26',
				code: '0456',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Pirapozinho ',
			},
		],
		'0459': [
			{
				j: '8',
				tr: '13',
				code: '0459',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Ouro Branco',
			},
			{
				j: '8',
				tr: '26',
				code: '0459',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Pitangueiras ',
			},
		],
		'0460': [
			{
				j: '8',
				tr: '13',
				code: '0460',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Ouro Fino',
			},
		],
		'0461': [
			{
				j: '8',
				tr: '13',
				code: '0461',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Ouro Preto',
			},
			{
				j: '8',
				tr: '15',
				code: '0461',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Solânea',
			},
		],
		'0467': [
			{
				j: '8',
				tr: '13',
				code: '0467',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Palma',
			},
		],
		'0471': [
			{
				j: '8',
				tr: '13',
				code: '0471',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Pará de Minas',
			},
			{
				j: '8',
				tr: '15',
				code: '0471',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Aroeiras',
			},
			{
				j: '8',
				tr: '26',
				code: '0471',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Porto Feliz ',
			},
		],
		'0470': [
			{
				j: '8',
				tr: '13',
				code: '0470',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Paracatu',
			},
			{
				j: '8',
				tr: '26',
				code: '0470',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Porangaba ',
			},
		],
		'0472': [
			{
				j: '8',
				tr: '13',
				code: '0472',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Paraguaçu',
			},
			{
				j: '8',
				tr: '26',
				code: '0472',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Porto Ferreira ',
			},
		],
		'0473': [
			{
				j: '8',
				tr: '13',
				code: '0473',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Paraisópolis',
			},
		],
		'0474': [
			{
				j: '8',
				tr: '13',
				code: '0474',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Paraopeba',
			},
			{
				j: '8',
				tr: '26',
				code: '0474',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Potirendaba ',
			},
		],
		'0476': [
			{
				j: '8',
				tr: '13',
				code: '0476',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Passa-Quatro',
			},
		],
		'0477': [
			{
				j: '8',
				tr: '13',
				code: '0477',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Passa-Tempo',
			},
			{
				j: '8',
				tr: '26',
				code: '0477',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Praia Grande ',
			},
		],
		'0479': [
			{
				j: '8',
				tr: '13',
				code: '0479',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Passos',
			},
		],
		'0480': [
			{
				j: '8',
				tr: '13',
				code: '0480',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Patos de Minas',
			},
			{
				j: '8',
				tr: '26',
				code: '0480',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Presidente Bernardes ',
			},
		],
		'0481': [
			{
				j: '8',
				tr: '13',
				code: '0481',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Patrocínio',
			},
			{
				j: '8',
				tr: '15',
				code: '0481',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Pilões',
			},
			{
				j: '8',
				tr: '26',
				code: '0481',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Presidente Epitácio ',
			},
		],
		'0486': [
			{
				j: '8',
				tr: '13',
				code: '0486',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Peçanha',
			},
			{
				j: '8',
				tr: '26',
				code: '0486',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Quatá ',
			},
		],
		'0487': [
			{
				j: '8',
				tr: '13',
				code: '0487',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Pedra Azul',
			},
		],
		'0491': [
			{
				j: '8',
				tr: '13',
				code: '0491',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Pedralva',
			},
			{
				j: '8',
				tr: '15',
				code: '0491',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Uiraúna',
			},
			{
				j: '8',
				tr: '26',
				code: '0491',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Rancharia ',
			},
		],
		'0498': [
			{
				j: '8',
				tr: '13',
				code: '0498',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Perdizes',
			},
			{
				j: '8',
				tr: '26',
				code: '0498',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Ribeirão Bonito ',
			},
		],
		'0499': [
			{
				j: '8',
				tr: '13',
				code: '0499',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Perdões',
			},
		],
		'0508': [
			{
				j: '8',
				tr: '13',
				code: '0508',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Piranga',
			},
		],
		'0511': [
			{
				j: '8',
				tr: '13',
				code: '0511',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Pirapetinga',
			},
			{
				j: '8',
				tr: '15',
				code: '0511',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Pirpirituba',
			},
			{
				j: '8',
				tr: '26',
				code: '0511',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Piracicaba ',
			},
		],
		'0512': [
			{
				j: '8',
				tr: '13',
				code: '0512',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Pirapora',
			},
			{
				j: '8',
				tr: '26',
				code: '0512',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Ribeirão Pires ',
			},
		],
		'0514': [
			{
				j: '8',
				tr: '13',
				code: '0514',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Pitangui',
			},
		],
		'0515': [
			{
				j: '8',
				tr: '13',
				code: '0515',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Piumhi',
			},
			{
				j: '8',
				tr: '26',
				code: '0515',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Rosana ',
			},
		],
		'0517': [
			{
				j: '8',
				tr: '13',
				code: '0517',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Poço Fundo',
			},
		],
		'0518': [
			{
				j: '8',
				tr: '13',
				code: '0518',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Poços de Caldas',
			},
		],
		'0520': [
			{
				j: '8',
				tr: '13',
				code: '0520',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Pompeu',
			},
		],
		'0521': [
			{
				j: '8',
				tr: '13',
				code: '0521',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Ponte Nova',
			},
			{
				j: '8',
				tr: '15',
				code: '0521',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Alagoinha',
			},
		],
		'0522': [
			{
				j: '8',
				tr: '13',
				code: '0522',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Porteirinha',
			},
		],
		'0525': [
			{
				j: '8',
				tr: '13',
				code: '0525',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Pouso Alegre',
			},
		],
		'0527': [
			{
				j: '8',
				tr: '13',
				code: '0527',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Prados',
			},
		],
		'0528': [
			{
				j: '8',
				tr: '13',
				code: '0528',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Prata',
			},
		],
		'0529': [
			{
				j: '8',
				tr: '13',
				code: '0529',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Pratápolis',
			},
		],
		'0534': [
			{
				j: '8',
				tr: '13',
				code: '0534',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Presidente Olegário',
			},
			{
				j: '8',
				tr: '26',
				code: '0534',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santa Branca ',
			},
		],
		'0540': [
			{
				j: '8',
				tr: '13',
				code: '0540',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Raul Soares',
			},
		],
		'0542': [
			{
				j: '8',
				tr: '13',
				code: '0542',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Resende Costa',
			},
		],
		'0543': [
			{
				j: '8',
				tr: '13',
				code: '0543',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Resplendor',
			},
			{
				j: '8',
				tr: '26',
				code: '0543',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santa Isabel ',
			},
		],
		'0549': [
			{
				j: '8',
				tr: '13',
				code: '0549',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Rio Casca',
			},
			{
				j: '8',
				tr: '26',
				code: '0549',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santa Rosa de Viterbo ',
			},
		],
		'0554': [
			{
				j: '8',
				tr: '13',
				code: '0554',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Rio Novo',
			},
			{
				j: '8',
				tr: '26',
				code: '0554',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santo André ',
			},
		],
		'0555': [
			{
				j: '8',
				tr: '13',
				code: '0555',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Rio Paranaíba',
			},
		],
		'0556': [
			{
				j: '8',
				tr: '13',
				code: '0556',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Rio Pardo de Minas',
			},
		],
		'0557': [
			{
				j: '8',
				tr: '13',
				code: '0557',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Rio Piracicaba',
			},
		],
		'0558': [
			{
				j: '8',
				tr: '13',
				code: '0558',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Rio Pomba',
			},
		],
		'0559': [
			{
				j: '8',
				tr: '13',
				code: '0559',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Rio Preto',
			},
		],
		'0560': [
			{
				j: '8',
				tr: '13',
				code: '0560',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Rio Vermelho',
			},
		],
		'0567': [
			{
				j: '8',
				tr: '13',
				code: '0567',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Sabará',
			},
		],
		'0568': [
			{
				j: '8',
				tr: '13',
				code: '0568',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Sabinópolis',
			},
			{
				j: '8',
				tr: '13',
				code: '0568',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Santa Vitória',
			},
			{
				j: '8',
				tr: '26',
				code: '0568',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São João da Boa Vista ',
			},
		],
		'0569': [
			{
				j: '8',
				tr: '13',
				code: '0569',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Sacramento',
			},
		],
		'0570': [
			{
				j: '8',
				tr: '13',
				code: '0570',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Salinas',
			},
		],
		'0572': [
			{
				j: '8',
				tr: '13',
				code: '0572',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Santa Bárbara',
			},
			{
				j: '8',
				tr: '26',
				code: '0572',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Joaquim da Barra ',
			},
		],
		'0582': [
			{
				j: '8',
				tr: '13',
				code: '0582',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Santa Maria do Suaçuí',
			},
			{
				j: '8',
				tr: '26',
				code: '0582',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Miguel Arcanjo ',
			},
		],
		'0592': [
			{
				j: '8',
				tr: '13',
				code: '0592',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Santa Rita de Caldas',
			},
		],
		'0596': [
			{
				j: '8',
				tr: '13',
				code: '0596',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Santa Rita do Sapucaí',
			},
			{
				j: '8',
				tr: '26',
				code: '0596',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Serrana ',
			},
		],
		'0604': [
			{
				j: '8',
				tr: '13',
				code: '0604',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Santo Antônio do Monte',
			},
			{
				j: '8',
				tr: '22',
				code: '0604',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Porto Velho',
			},
			{
				j: '8',
				tr: '26',
				code: '0604',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Sumaré ',
			},
		],
		'0607': [
			{
				j: '8',
				tr: '13',
				code: '0607',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Santos Dumont',
			},
			{
				j: '8',
				tr: '26',
				code: '0607',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Catanduva ',
			},
		],
		'0610': [
			{
				j: '8',
				tr: '13',
				code: '0610',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'São Domingos do Prata',
			},
		],
		'0611': [
			{
				j: '8',
				tr: '13',
				code: '0611',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'São Francisco',
			},
			{
				j: '8',
				tr: '15',
				code: '0611',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Mari',
			},
		],
		'0620': [
			{
				j: '8',
				tr: '13',
				code: '0620',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'São Gonçalo do Sapucaí',
			},
			{
				j: '8',
				tr: '26',
				code: '0620',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Taquarituba ',
			},
		],
		'0621': [
			{
				j: '8',
				tr: '13',
				code: '0621',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'São Gotardo',
			},
		],
		'0624': [
			{
				j: '8',
				tr: '13',
				code: '0624',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'São João da Ponte',
			},
			{
				j: '8',
				tr: '26',
				code: '0624',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Tatuí ',
			},
		],
		'0625': [
			{
				j: '8',
				tr: '13',
				code: '0625',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'São João Del-Rei',
			},
			{
				j: '8',
				tr: '26',
				code: '0625',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Taubaté ',
			},
		],
		'0627': [
			{
				j: '8',
				tr: '13',
				code: '0627',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'São João do Paraíso',
			},
			{
				j: '8',
				tr: '26',
				code: '0627',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Teodoro Sampaio ',
			},
		],
		'0628': [
			{
				j: '8',
				tr: '13',
				code: '0628',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'São João Evangelista',
			},
		],
		'0629': [
			{
				j: '8',
				tr: '13',
				code: '0629',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'São João Nepomuceno',
			},
			{
				j: '8',
				tr: '26',
				code: '0629',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Tietê ',
			},
		],
		'0637': [
			{
				j: '8',
				tr: '13',
				code: '0637',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'São Lourenço',
			},
			{
				j: '8',
				tr: '26',
				code: '0637',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Tupã ',
			},
		],
		'0642': [
			{
				j: '8',
				tr: '13',
				code: '0642',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'São Romão',
			},
			{
				j: '8',
				tr: '26',
				code: '0642',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Ubatuba ',
			},
		],
		'0643': [
			{
				j: '8',
				tr: '13',
				code: '0643',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'São Roque de Minas',
			},
		],
		'0647': [
			{
				j: '8',
				tr: '13',
				code: '0647',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'São Sebastião do Paraíso',
			},
		],
		'0657': [
			{
				j: '8',
				tr: '13',
				code: '0657',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Senador Firmino',
			},
		],
		'0671': [
			{
				j: '8',
				tr: '13',
				code: '0671',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Serro',
			},
			{
				j: '8',
				tr: '26',
				code: '0671',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Olímpia ',
			},
		],
		'0672': [
			{
				j: '8',
				tr: '13',
				code: '0672',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Sete Lagoas',
			},
			{
				j: '8',
				tr: '26',
				code: '0672',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Tatuí ',
			},
		],
		'0674': [
			{
				j: '8',
				tr: '13',
				code: '0674',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Silvianópolis',
			},
			{
				j: '8',
				tr: '26',
				code: '0674',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Assis ',
			},
		],
		'0680': [
			{
				j: '8',
				tr: '13',
				code: '0680',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Taiobeiras',
			},
			{
				j: '8',
				tr: '26',
				code: '0680',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itapecerica da Serra ',
			},
		],
		'0684': [
			{
				j: '8',
				tr: '13',
				code: '0684',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Tarumirim',
			},
			{
				j: '8',
				tr: '26',
				code: '0684',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Bananal ',
			},
		],
		'0685': [
			{
				j: '8',
				tr: '13',
				code: '0685',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Teixeiras',
			},
			{
				j: '8',
				tr: '26',
				code: '0685',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itapecerica da Serra ',
			},
		],
		'0686': [
			{
				j: '8',
				tr: '13',
				code: '0686',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Teófilo Otôni',
			},
			{
				j: '8',
				tr: '26',
				code: '0686',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cachoeira Paulista ',
			},
		],
		'0687': [
			{
				j: '8',
				tr: '13',
				code: '0687',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Timótio',
			},
			{
				j: '8',
				tr: '26',
				code: '0687',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Pereira Barreto ',
			},
		],
		'0689': [
			{
				j: '8',
				tr: '13',
				code: '0689',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Tiros',
			},
			{
				j: '8',
				tr: '26',
				code: '0689',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santa Fé do Sul ',
			},
		],
		'0692': [
			{
				j: '8',
				tr: '13',
				code: '0692',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Tombos',
			},
			{
				j: '8',
				tr: '26',
				code: '0692',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Ribeirão Bonito ',
			},
		],
		'0693': [
			{
				j: '8',
				tr: '13',
				code: '0693',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Três Corações',
			},
			{
				j: '8',
				tr: '26',
				code: '0693',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Tatuí ',
			},
		],
		'0694': [
			{
				j: '8',
				tr: '13',
				code: '0694',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Três Pontas',
			},
		],
		'0696': [
			{
				j: '8',
				tr: '13',
				code: '0696',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Tupaciguara',
			},
			{
				j: '8',
				tr: '26',
				code: '0696',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Fernandópolis ',
			},
		],
		'0697': [
			{
				j: '8',
				tr: '13',
				code: '0697',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Turmalina',
			},
			{
				j: '8',
				tr: '26',
				code: '0697',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Jales ',
			},
		],
		'0699': [
			{
				j: '8',
				tr: '13',
				code: '0699',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Ubá',
			},
			{
				j: '8',
				tr: '26',
				code: '0699',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Sorocaba ',
			},
		],
		'0701': [
			{
				j: '8',
				tr: '13',
				code: '0701',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Uberaba',
			},
			{
				j: '8',
				tr: '22',
				code: '0701',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Porto Velho',
			},
			{
				j: '8',
				tr: '26',
				code: '0701',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Ibitinga ',
			},
		],
		'0702': [
			{
				j: '8',
				tr: '13',
				code: '0702',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Uberlândia',
			},
			{
				j: '8',
				tr: '26',
				code: '0702',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
		'0704': [
			{
				j: '8',
				tr: '13',
				code: '0704',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Unaí',
			},
			{
				j: '8',
				tr: '26',
				code: '0704',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
		'0707': [
			{
				j: '8',
				tr: '13',
				code: '0707',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Varginha',
			},
			{
				j: '8',
				tr: '26',
				code: '0707',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Pindorama ',
			},
		],
		'0708': [
			{
				j: '8',
				tr: '13',
				code: '0708',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Várzea da Palma',
			},
			{
				j: '8',
				tr: '26',
				code: '0708',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santa Salete ',
			},
		],
		'0710': [
			{
				j: '8',
				tr: '13',
				code: '0710',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Vazante',
			},
			{
				j: '8',
				tr: '26',
				code: '0710',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
		'0290': [
			{
				j: '8',
				tr: '13',
				code: '0290',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Vespasiano',
			},
		],
		'0713': [
			{
				j: '8',
				tr: '13',
				code: '0713',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Viçosa',
			},
		],
		'0718': [
			{
				j: '8',
				tr: '13',
				code: '0718',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Virginópolis',
			},
		],
		'0720': [
			{
				j: '8',
				tr: '13',
				code: '0720',
				courthouse: 'TJMG',
				state: 'MG',
				city: 'Visconde do Rio Branco',
			},
		],
		'0291': [
			{
				j: '8',
				tr: '15',
				code: '0291',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Cruz do Espírito Santo',
			},
			{
				j: '8',
				tr: '26',
				code: '0291',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Jaboticabal ',
			},
		],
		'0311': [
			{
				j: '8',
				tr: '15',
				code: '0311',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Princesa Isabel',
			},
			{
				j: '8',
				tr: '26',
				code: '0311',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Junqueirópolis ',
			},
		],
		'0321': [
			{
				j: '8',
				tr: '15',
				code: '0321',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Santa Luzia',
			},
		],
		'0341': [
			{
				j: '8',
				tr: '15',
				code: '0341',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'São João do Cariri',
			},
			{
				j: '8',
				tr: '26',
				code: '0341',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Maracaí ',
			},
		],
		'0361': [
			{
				j: '8',
				tr: '15',
				code: '0361',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Serraria',
			},
			{
				j: '8',
				tr: '26',
				code: '0361',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mogi das Cruzes ',
			},
		],
		'0371': [
			{
				j: '8',
				tr: '15',
				code: '0371',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Sousa',
			},
		],
		'0381': [
			{
				j: '8',
				tr: '15',
				code: '0381',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Itabaiana',
			},
		],
		'0391': [
			{
				j: '8',
				tr: '15',
				code: '0391',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Teixeira',
			},
		],
		'0401': [
			{
				j: '8',
				tr: '15',
				code: '0401',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Umbuzeiro',
			},
		],
		'0501': [
			{
				j: '8',
				tr: '15',
				code: '0501',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'São Mamede',
			},
			{
				j: '8',
				tr: '22',
				code: '0501',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Porto Velho',
			},
		],
		'0531': [
			{
				j: '8',
				tr: '15',
				code: '0531',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Malta',
			},
			{
				j: '8',
				tr: '26',
				code: '0531',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santa Adélia ',
			},
		],
		'0541': [
			{
				j: '8',
				tr: '15',
				code: '0541',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Pocinhos',
			},
			{
				j: '8',
				tr: '26',
				code: '0541',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santa Fé do Sul ',
			},
		],
		'0551': [
			{
				j: '8',
				tr: '15',
				code: '0551',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Remígio',
			},
		],
		'0561': [
			{
				j: '8',
				tr: '15',
				code: '0561',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Coremas',
			},
		],
		'0571': [
			{
				j: '8',
				tr: '15',
				code: '0571',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Pedras de Fogo',
			},
		],
		'0581': [
			{
				j: '8',
				tr: '15',
				code: '0581',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Rio Tinto',
			},
			{
				j: '8',
				tr: '26',
				code: '0581',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Manuel ',
			},
		],
		'0601': [
			{
				j: '8',
				tr: '15',
				code: '0601',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Belém',
			},
			{
				j: '8',
				tr: '22',
				code: '0601',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Porto Velho',
			},
			{
				j: '8',
				tr: '26',
				code: '0601',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Socorro ',
			},
		],
		'0631': [
			{
				j: '8',
				tr: '15',
				code: '0631',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Juazeirinho',
			},
		],
		'0681': [
			{
				j: '8',
				tr: '15',
				code: '0681',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Prata',
			},
			{
				j: '8',
				tr: '26',
				code: '0681',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Vinhedo ',
			},
		],
		'0731': [
			{
				j: '8',
				tr: '15',
				code: '0731',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Cabedelo',
			},
		],
		'0741': [
			{
				j: '8',
				tr: '15',
				code: '0741',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Boqueirão',
			},
		],
		'0751': [
			{
				j: '8',
				tr: '15',
				code: '0751',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Bayeux',
			},
		],
		'0761': [
			{
				j: '8',
				tr: '15',
				code: '0761',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Gurinhém',
			},
		],
		'0781': [
			{
				j: '8',
				tr: '15',
				code: '0781',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Barra de Santa Rosa',
			},
		],
		'0831': [
			{
				j: '8',
				tr: '15',
				code: '0831',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Dentro',
			},
		],
		'0881': [
			{
				j: '8',
				tr: '15',
				code: '0881',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'São Bento',
			},
		],
		'0911': [
			{
				j: '8',
				tr: '15',
				code: '0911',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Serra Branca',
			},
		],
		'0941': [
			{
				j: '8',
				tr: '15',
				code: '0941',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Água Branca',
			},
		],
		'0951': [
			{
				j: '8',
				tr: '15',
				code: '0951',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Arara',
			},
		],
		'0981': [
			{
				j: '8',
				tr: '15',
				code: '0981',
				courthouse: 'TJPB',
				state: 'PB',
				city: 'Queimadas',
			},
		],
		'0024  ': [
			{
				j: '8',
				tr: '19',
				code: '0024  ',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'ltaguaí ',
			},
		],
		'0029 ': [
			{
				j: '8',
				tr: '19',
				code: '0029 ',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Magé ',
			},
		],
		'0002 ': [
			{
				j: '8',
				tr: '19',
				code: '0002 ',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Niterói ',
			},
		],
		'0900 ': [
			{
				j: '8',
				tr: '19',
				code: '0900 ',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Rio de Janeiro',
			},
		],
		'0902': [
			{
				j: '8',
				tr: '19',
				code: '0902',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Niteroi ',
			},
		],
		'0903': [
			{
				j: '8',
				tr: '19',
				code: '0903',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Rio Bonito ',
			},
		],
		'0904': [
			{
				j: '8',
				tr: '19',
				code: '0904',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Duque de Caxias',
			},
			{
				j: '8',
				tr: '22',
				code: '0904',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Ouro Preto do Oeste',
			},
		],
		'0905': [
			{
				j: '8',
				tr: '19',
				code: '0905',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'ltaguai',
			},
		],
		'0906': [
			{
				j: '8',
				tr: '19',
				code: '0906',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Petrópolis ',
			},
		],
		'0907': [
			{
				j: '8',
				tr: '19',
				code: '0907',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Volta Redonda',
			},
		],
		'0908': [
			{
				j: '8',
				tr: '19',
				code: '0908',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Nova Friburgo ',
			},
		],
		'0909': [
			{
				j: '8',
				tr: '19',
				code: '0909',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'Campos',
			},
		],
		'0910': [
			{
				j: '8',
				tr: '19',
				code: '0910',
				courthouse: 'TJRJ',
				state: 'RJ',
				city: 'ltaocara',
			},
		],
		'0603': [
			{
				j: '8',
				tr: '22',
				code: '0603',
				courthouse: 'TJRO',
				state: 'RO',
				city: 'Porto Velho',
			},
		],
		'0279': [
			{
				j: '8',
				tr: '26',
				code: '0279',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itararé ',
			},
		],
		'0282': [
			{
				j: '8',
				tr: '26',
				code: '0282',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Botucatu ',
			},
		],
		'0286': [
			{
				j: '8',
				tr: '26',
				code: '0286',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itu ',
			},
		],
		'0288': [
			{
				j: '8',
				tr: '26',
				code: '0288',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Ituverava ',
			},
		],
		'0292': [
			{
				j: '8',
				tr: '26',
				code: '0292',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Jacareí ',
			},
		],
		'0294': [
			{
				j: '8',
				tr: '26',
				code: '0294',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Jacupiranga ',
			},
		],
		'0296': [
			{
				j: '8',
				tr: '26',
				code: '0296',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Jaguariúna ',
			},
		],
		'0299': [
			{
				j: '8',
				tr: '26',
				code: '0299',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Barueri ',
			},
		],
		'0300': [
			{
				j: '8',
				tr: '26',
				code: '0300',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Jardinópolis ',
			},
		],
		'0302': [
			{
				j: '8',
				tr: '26',
				code: '0302',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Jaú ',
			},
		],
		'0306': [
			{
				j: '8',
				tr: '26',
				code: '0306',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'José Bonifácio ',
			},
		],
		'0315': [
			{
				j: '8',
				tr: '26',
				code: '0315',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Laranjal Paulista ',
			},
		],
		'0318': [
			{
				j: '8',
				tr: '26',
				code: '0318',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Leme ',
			},
		],
		'0320': [
			{
				j: '8',
				tr: '26',
				code: '0320',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Limeira ',
			},
		],
		'0323': [
			{
				j: '8',
				tr: '26',
				code: '0323',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Lorena ',
			},
		],
		'0326': [
			{
				j: '8',
				tr: '26',
				code: '0326',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Lucélia ',
			},
		],
		'0333': [
			{
				j: '8',
				tr: '26',
				code: '0333',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Macatuba ',
			},
		],
		'0337': [
			{
				j: '8',
				tr: '26',
				code: '0337',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mairinque ',
			},
		],
		'0352': [
			{
				j: '8',
				tr: '26',
				code: '0352',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Miguelópolis ',
			},
		],
		'0356': [
			{
				j: '8',
				tr: '26',
				code: '0356',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mirandópolis ',
			},
		],
		'0357': [
			{
				j: '8',
				tr: '26',
				code: '0357',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mirante do Paranapanema ',
			},
		],
		'0360': [
			{
				j: '8',
				tr: '26',
				code: '0360',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mococa ',
			},
		],
		'0366': [
			{
				j: '8',
				tr: '26',
				code: '0366',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mongaguá ',
			},
		],
		'0368': [
			{
				j: '8',
				tr: '26',
				code: '0368',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Monte Alto ',
			},
		],
		'0369': [
			{
				j: '8',
				tr: '26',
				code: '0369',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Monte Aprazível ',
			},
		],
		'0370': [
			{
				j: '8',
				tr: '26',
				code: '0370',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Monte Azul Paulista ',
			},
		],
		'0374': [
			{
				j: '8',
				tr: '26',
				code: '0374',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Morro Agudo ',
			},
		],
		'0383': [
			{
				j: '8',
				tr: '26',
				code: '0383',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Nhandeara ',
			},
		],
		'0397': [
			{
				j: '8',
				tr: '26',
				code: '0397',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Nuporanga ',
			},
		],
		'0404': [
			{
				j: '8',
				tr: '26',
				code: '0404',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Orlândia ',
			},
		],
		'0412': [
			{
				j: '8',
				tr: '26',
				code: '0412',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Palestina ',
			},
		],
		'0415': [
			{
				j: '8',
				tr: '26',
				code: '0415',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Palmital ',
			},
		],
		'0420': [
			{
				j: '8',
				tr: '26',
				code: '0420',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Avaré ',
			},
		],
		'0424': [
			{
				j: '8',
				tr: '26',
				code: '0424',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Jacupiranga ',
			},
		],
		'0426': [
			{
				j: '8',
				tr: '26',
				code: '0426',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Patrocínio Paulista ',
			},
		],
		'0438': [
			{
				j: '8',
				tr: '26',
				code: '0438',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Penápolis ',
			},
		],
		'0445': [
			{
				j: '8',
				tr: '26',
				code: '0445',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Pindamonhangaba ',
			},
		],
		'0449': [
			{
				j: '8',
				tr: '26',
				code: '0449',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Lorena ',
			},
		],
		'0457': [
			{
				j: '8',
				tr: '26',
				code: '0457',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Pirassununga ',
			},
		],
		'0458': [
			{
				j: '8',
				tr: '26',
				code: '0458',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Piratininga ',
			},
		],
		'0462': [
			{
				j: '8',
				tr: '26',
				code: '0462',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Poá ',
			},
		],
		'0464': [
			{
				j: '8',
				tr: '26',
				code: '0464',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Pompéia ',
			},
		],
		'0466': [
			{
				j: '8',
				tr: '26',
				code: '0466',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Pontal ',
			},
		],
		'0482': [
			{
				j: '8',
				tr: '26',
				code: '0482',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Presidente Prudente ',
			},
		],
		'0483': [
			{
				j: '8',
				tr: '26',
				code: '0483',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Presidente Venceslau ',
			},
		],
		'0484': [
			{
				j: '8',
				tr: '26',
				code: '0484',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Promissão ',
			},
		],
		'0488': [
			{
				j: '8',
				tr: '26',
				code: '0488',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Queluz ',
			},
		],
		'0493': [
			{
				j: '8',
				tr: '26',
				code: '0493',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Regente Feijó ',
			},
		],
		'0495': [
			{
				j: '8',
				tr: '26',
				code: '0495',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Registro ',
			},
		],
		'0506': [
			{
				j: '8',
				tr: '26',
				code: '0506',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Ribeirão Preto ',
			},
		],
		'0510': [
			{
				j: '8',
				tr: '26',
				code: '0510',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Rio Claro ',
			},
		],
		'0516': [
			{
				j: '8',
				tr: '26',
				code: '0516',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Aparecida ',
			},
		],
		'0523': [
			{
				j: '8',
				tr: '26',
				code: '0523',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santa Branca ',
			},
		],
		'0526': [
			{
				j: '8',
				tr: '26',
				code: '0526',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Salto ',
			},
		],
		'0533': [
			{
				j: '8',
				tr: '26',
				code: '0533',
				courthouse: 'TJSP',
				state: 'SP',
				city: "Santa Bárbara D'Oeste ",
			},
		],
		'0538': [
			{
				j: '8',
				tr: '26',
				code: '0538',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santa Cruz das Palmeiras ',
			},
		],
		'0539': [
			{
				j: '8',
				tr: '26',
				code: '0539',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santa Cruz do Rio Pardo ',
			},
		],
		'0547': [
			{
				j: '8',
				tr: '26',
				code: '0547',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santa Rita do Passa Quatro ',
			},
		],
		'0553': [
			{
				j: '8',
				tr: '26',
				code: '0553',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santo Anastácio ',
			},
		],
		'0562': [
			{
				j: '8',
				tr: '26',
				code: '0562',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santos ',
			},
		],
		'0563': [
			{
				j: '8',
				tr: '26',
				code: '0563',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Bento do Sapucaí ',
			},
		],
		'0564': [
			{
				j: '8',
				tr: '26',
				code: '0564',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Bernardo do Campo ',
			},
		],
		'0565': [
			{
				j: '8',
				tr: '26',
				code: '0565',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Caetano do Sul ',
			},
		],
		'0566': [
			{
				j: '8',
				tr: '26',
				code: '0566',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Carlos ',
			},
		],
		'0575': [
			{
				j: '8',
				tr: '26',
				code: '0575',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São José do Rio Pardo ',
			},
		],
		'0576': [
			{
				j: '8',
				tr: '26',
				code: '0576',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São José do Rio Preto ',
			},
		],
		'0577': [
			{
				j: '8',
				tr: '26',
				code: '0577',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São José dos Campos ',
			},
		],
		'0579': [
			{
				j: '8',
				tr: '26',
				code: '0579',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Luiz do Paraitinga ',
			},
		],
		'0584': [
			{
				j: '8',
				tr: '26',
				code: '0584',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Pedro ',
			},
		],
		'0586': [
			{
				j: '8',
				tr: '26',
				code: '0586',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Roque ',
			},
		],
		'0587': [
			{
				j: '8',
				tr: '26',
				code: '0587',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Sebastião ',
			},
		],
		'0588': [
			{
				j: '8',
				tr: '26',
				code: '0588',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São José do Rio Pardo ',
			},
		],
		'0589': [
			{
				j: '8',
				tr: '26',
				code: '0589',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Simão ',
			},
		],
		'0590': [
			{
				j: '8',
				tr: '26',
				code: '0590',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Vicente ',
			},
		],
		'0595': [
			{
				j: '8',
				tr: '26',
				code: '0595',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Serra Negra ',
			},
		],
		'0597': [
			{
				j: '8',
				tr: '26',
				code: '0597',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Sertãozinho ',
			},
		],
		'0602': [
			{
				j: '8',
				tr: '26',
				code: '0602',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Sorocaba ',
			},
		],
		'0606': [
			{
				j: '8',
				tr: '26',
				code: '0606',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Suzano ',
			},
		],
		'0609': [
			{
				j: '8',
				tr: '26',
				code: '0609',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Taboão da Serra ',
			},
		],
		'0614': [
			{
				j: '8',
				tr: '26',
				code: '0614',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Tambaú ',
			},
		],
		'0615': [
			{
				j: '8',
				tr: '26',
				code: '0615',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Tanabi ',
			},
		],
		'0619': [
			{
				j: '8',
				tr: '26',
				code: '0619',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Taquaritinga ',
			},
		],
		'0634': [
			{
				j: '8',
				tr: '26',
				code: '0634',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Tremembé ',
			},
		],
		'0638': [
			{
				j: '8',
				tr: '26',
				code: '0638',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Tupi Paulista ',
			},
		],
		'0646': [
			{
				j: '8',
				tr: '26',
				code: '0646',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Urânia ',
			},
		],
		'0648': [
			{
				j: '8',
				tr: '26',
				code: '0648',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Urupês ',
			},
		],
		'0650': [
			{
				j: '8',
				tr: '26',
				code: '0650',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Valinhos ',
			},
		],
		'0651': [
			{
				j: '8',
				tr: '26',
				code: '0651',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Valparaíso ',
			},
		],
		'0653': [
			{
				j: '8',
				tr: '26',
				code: '0653',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Vargem Grande do Sul ',
			},
		],
		'0654': [
			{
				j: '8',
				tr: '26',
				code: '0654',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Cotia ',
			},
		],
		'0655': [
			{
				j: '8',
				tr: '26',
				code: '0655',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Várzea Paulista ',
			},
		],
		'0659': [
			{
				j: '8',
				tr: '26',
				code: '0659',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Vinhedo ',
			},
		],
		'0660': [
			{
				j: '8',
				tr: '26',
				code: '0660',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Viradouro ',
			},
		],
		'0663': [
			{
				j: '8',
				tr: '26',
				code: '0663',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Votorantim ',
			},
		],
		'0664': [
			{
				j: '8',
				tr: '26',
				code: '0664',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Votuporanga ',
			},
		],
		'0665': [
			{
				j: '8',
				tr: '26',
				code: '0665',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Presidente Prudente ',
			},
		],
		'0666': [
			{
				j: '8',
				tr: '26',
				code: '0666',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mogi-Mirim ',
			},
		],
		'0667': [
			{
				j: '8',
				tr: '26',
				code: '0667',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Jacupiranga ',
			},
		],
		'0668': [
			{
				j: '8',
				tr: '26',
				code: '0668',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Sertãozinho ',
			},
		],
		'0669': [
			{
				j: '8',
				tr: '26',
				code: '0669',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Porangaba ',
			},
		],
		'0670': [
			{
				j: '8',
				tr: '26',
				code: '0670',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Jacupiranga ',
			},
		],
		'0673': [
			{
				j: '8',
				tr: '26',
				code: '0673',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Adamantina ',
			},
		],
		'0675': [
			{
				j: '8',
				tr: '26',
				code: '0675',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São José do Rio Preto ',
			},
		],
		'0676': [
			{
				j: '8',
				tr: '26',
				code: '0676',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Mirandópolis ',
			},
		],
		'0677': [
			{
				j: '8',
				tr: '26',
				code: '0677',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Ibitinga ',
			},
		],
		'0678': [
			{
				j: '8',
				tr: '26',
				code: '0678',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Barra Bonita ',
			},
		],
		'0679': [
			{
				j: '8',
				tr: '26',
				code: '0679',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Jundiaí ',
			},
		],
		'0682': [
			{
				j: '8',
				tr: '26',
				code: '0682',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Monte Aprazível ',
			},
		],
		'0683': [
			{
				j: '8',
				tr: '26',
				code: '0683',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Paulo de Faria ',
			},
		],
		'0688': [
			{
				j: '8',
				tr: '26',
				code: '0688',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Assis ',
			},
		],
		'0690': [
			{
				j: '8',
				tr: '26',
				code: '0690',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Votuporanga ',
			},
		],
		'0691': [
			{
				j: '8',
				tr: '26',
				code: '0691',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Itapeva ',
			},
		],
		'0695': [
			{
				j: '8',
				tr: '26',
				code: '0695',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Atibaia ',
			},
		],
		'0698': [
			{
				j: '8',
				tr: '26',
				code: '0698',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Monte Alto ',
			},
		],
		'0700': [
			{
				j: '8',
				tr: '26',
				code: '0700',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Olímpia ',
			},
		],
		'0703': [
			{
				j: '8',
				tr: '26',
				code: '0703',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
		'0705': [
			{
				j: '8',
				tr: '26',
				code: '0705',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Aspásia ',
			},
		],
		'0706': [
			{
				j: '8',
				tr: '26',
				code: '0706',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Bernardino de Campos ',
			},
		],
		'0709': [
			{
				j: '8',
				tr: '26',
				code: '0709',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'Santa Albertina ',
			},
		],
		'0990': [
			{
				j: '8',
				tr: '26',
				code: '0990',
				courthouse: 'TJSP',
				state: 'SP',
				city: 'São Paulo ',
			},
		],
	}
}
